import pr, { useLayoutEffect as hs, useEffect as Po, useMemo as tn, useContext as jo, useDebugValue as ms, useReducer as vs, useRef as tr, createContext as ys, useCallback as ko } from "react";
import { unstable_batchedUpdates as gs } from "react-dom";
var ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function bs(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Fe = {}, Co = {}, dr = {}, hr = {}, wt = {}, Sn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.camelCaseKeys = e.camelCase = e.int = e.bool = e.isNode = e.isBrowser = void 0, e.isBrowser = typeof window < "u" && typeof window.document < "u", e.isNode = typeof process < "u" && process.versions != null && process.versions.node != null;
  var t = /^(|false|falsy|f|0|nill|null|no|n)$/i, r = function(a) {
    return !!(a && !t.test(a.trim()));
  };
  e.bool = r;
  var n = function(a) {
    return parseInt(a, 10);
  };
  e.int = n;
  var i = function(a) {
    var s = a.split("_").filter(function(u) {
      return u;
    }).map(function(u) {
      return u[0].toUpperCase() + u.slice(1).toLowerCase();
    }).join("");
    return s[0].toLowerCase() + s.slice(1);
  };
  e.camelCase = i;
  var o = function(a) {
    var s = {};
    return Object.keys(a).forEach(function(u) {
      s[(0, e.camelCase)(u)] = a[u];
    }), s;
  };
  e.camelCaseKeys = o;
})(Sn);
Object.defineProperty(wt, "__esModule", { value: !0 });
wt.setConfigCreator = wt.getConfigCreator = void 0;
var Sr = Sn, et = {}, xs = function(e, t) {
  var r = t === void 0 ? {} : t, n = r.envToConfig, i = n === void 0 ? Sr.camelCaseKeys : n, o = r.rawEnv, a = o === void 0 ? !1 : o;
  return function() {
    var s;
    if (et[e])
      return et[e];
    if (Sr.isBrowser)
      return (s = window.appConfig) === null || s === void 0 ? void 0 : s[e];
    if (Sr.isNode) {
      if (a)
        return i(process.env);
      var u = {}, c = "APP_".concat(e.toUpperCase(), "_");
      return Object.keys(process.env).forEach(function(_) {
        var h;
        _.startsWith(c) && (u[_.slice(c.length)] = (h = process.env[_]) === null || h === void 0 ? void 0 : h.trim());
      }), et[e] = i(u), et[e];
    }
    return et[e];
  };
};
wt.getConfigCreator = xs;
var ws = function(e) {
  return function(t) {
    t ? et[e] = t : delete et[e];
  };
};
wt.setConfigCreator = ws;
(function(e) {
  var t = ie && ie.__createBinding || (Object.create ? function(n, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(n, a, s);
  } : function(n, i, o, a) {
    a === void 0 && (a = o), n[a] = i[o];
  }), r = ie && ie.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), r(wt, e), r(Sn, e);
})(hr);
var Uo = { exports: {} };
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(ie, function() {
    function r(O, x) {
      var w = Object.keys(O);
      if (Object.getOwnPropertySymbols) {
        var E = Object.getOwnPropertySymbols(O);
        x && (E = E.filter(function(N) {
          return Object.getOwnPropertyDescriptor(O, N).enumerable;
        })), w.push.apply(w, E);
      }
      return w;
    }
    function n(O) {
      for (var x = 1; x < arguments.length; x++) {
        var w = arguments[x] != null ? arguments[x] : {};
        x % 2 ? r(Object(w), !0).forEach(function(E) {
          s(O, E, w[E]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(O, Object.getOwnPropertyDescriptors(w)) : r(Object(w)).forEach(function(E) {
          Object.defineProperty(O, E, Object.getOwnPropertyDescriptor(w, E));
        });
      }
      return O;
    }
    function i(O, x) {
      if (!(O instanceof x))
        throw new TypeError("Cannot call a class as a function");
    }
    function o(O, x) {
      for (var w = 0; w < x.length; w++) {
        var E = x[w];
        E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(O, _(E.key), E);
      }
    }
    function a(O, x, w) {
      return x && o(O.prototype, x), w && o(O, w), Object.defineProperty(O, "prototype", {
        writable: !1
      }), O;
    }
    function s(O, x, w) {
      return x = _(x), x in O ? Object.defineProperty(O, x, {
        value: w,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : O[x] = w, O;
    }
    function u() {
      return u = Object.assign ? Object.assign.bind() : function(O) {
        for (var x = 1; x < arguments.length; x++) {
          var w = arguments[x];
          for (var E in w)
            Object.prototype.hasOwnProperty.call(w, E) && (O[E] = w[E]);
        }
        return O;
      }, u.apply(this, arguments);
    }
    function c(O, x) {
      if (typeof O != "object" || O === null)
        return O;
      var w = O[Symbol.toPrimitive];
      if (w !== void 0) {
        var E = w.call(O, x || "default");
        if (typeof E != "object")
          return E;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (x === "string" ? String : Number)(O);
    }
    function _(O) {
      var x = c(O, "string");
      return typeof x == "symbol" ? x : String(x);
    }
    var h = { exports: {} };
    (function(O) {
      typeof window > "u" || function(x) {
        var w = x.HTMLCanvasElement && x.HTMLCanvasElement.prototype, E = x.Blob && function() {
          try {
            return !!new Blob();
          } catch {
            return !1;
          }
        }(), N = E && x.Uint8Array && function() {
          try {
            return new Blob([new Uint8Array(100)]).size === 100;
          } catch {
            return !1;
          }
        }(), M = x.BlobBuilder || x.WebKitBlobBuilder || x.MozBlobBuilder || x.MSBlobBuilder, V = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, A = (E || M) && x.atob && x.ArrayBuffer && x.Uint8Array && function(k) {
          var G, ne, ue, Se, ye, J, Te, he, De;
          if (G = k.match(V), !G)
            throw new Error("invalid data URI");
          for (ne = G[2] ? G[1] : "text/plain" + (G[3] || ";charset=US-ASCII"), ue = !!G[4], Se = k.slice(G[0].length), ue ? ye = atob(Se) : ye = decodeURIComponent(Se), J = new ArrayBuffer(ye.length), Te = new Uint8Array(J), he = 0; he < ye.length; he += 1)
            Te[he] = ye.charCodeAt(he);
          return E ? new Blob([N ? Te : J], {
            type: ne
          }) : (De = new M(), De.append(J), De.getBlob(ne));
        };
        x.HTMLCanvasElement && !w.toBlob && (w.mozGetAsFile ? w.toBlob = function(k, G, ne) {
          var ue = this;
          setTimeout(function() {
            ne && w.toDataURL && A ? k(A(ue.toDataURL(G, ne))) : k(ue.mozGetAsFile("blob", G));
          });
        } : w.toDataURL && A && (w.msToBlob ? w.toBlob = function(k, G, ne) {
          var ue = this;
          setTimeout(function() {
            (G && G !== "image/png" || ne) && w.toDataURL && A ? k(A(ue.toDataURL(G, ne))) : k(ue.msToBlob(G));
          });
        } : w.toBlob = function(k, G, ne) {
          var ue = this;
          setTimeout(function() {
            k(A(ue.toDataURL(G, ne)));
          });
        })), O.exports ? O.exports = A : x.dataURLtoBlob = A;
      }(window);
    })(h);
    var P = h.exports, D = function(x) {
      return typeof Blob > "u" ? !1 : x instanceof Blob || Object.prototype.toString.call(x) === "[object Blob]";
    }, W = {
      /**
       * Indicates if output the original image instead of the compressed one
       * when the size of the compressed image is greater than the original one's
       * @type {boolean}
       */
      strict: !0,
      /**
       * Indicates if read the image's Exif Orientation information,
       * and then rotate or flip the image automatically.
       * @type {boolean}
       */
      checkOrientation: !0,
      /**
       * Indicates if retain the image's Exif information after compressed.
       * @type {boolean}
      */
      retainExif: !1,
      /**
       * The max width of the output image.
       * @type {number}
       */
      maxWidth: 1 / 0,
      /**
       * The max height of the output image.
       * @type {number}
       */
      maxHeight: 1 / 0,
      /**
       * The min width of the output image.
       * @type {number}
       */
      minWidth: 0,
      /**
       * The min height of the output image.
       * @type {number}
       */
      minHeight: 0,
      /**
       * The width of the output image.
       * If not specified, the natural width of the source image will be used.
       * @type {number}
       */
      width: void 0,
      /**
       * The height of the output image.
       * If not specified, the natural height of the source image will be used.
       * @type {number}
       */
      height: void 0,
      /**
       * Sets how the size of the image should be resized to the container
       * specified by the `width` and `height` options.
       * @type {string}
       */
      resize: "none",
      /**
       * The quality of the output image.
       * It must be a number between `0` and `1`,
       * and only available for `image/jpeg` and `image/webp` images.
       * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
       * @type {number}
       */
      quality: 0.8,
      /**
       * The mime type of the output image.
       * By default, the original mime type of the source image file will be used.
       * @type {string}
       */
      mimeType: "auto",
      /**
       * Files whose file type is included in this list,
       * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
       * @type {string｜Array}
       */
      convertTypes: ["image/png"],
      /**
       * PNG files over this size (5 MB by default) will be converted to JPEGs.
       * To disable this, just set the value to `Infinity`.
       * @type {number}
       */
      convertSize: 5e6,
      /**
       * The hook function to execute before draw the image into the canvas for compression.
       * @type {Function}
       * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
       * @param {HTMLCanvasElement} canvas - The canvas for compression.
       * @example
       * function (context, canvas) {
       *   context.fillStyle = '#fff';
       * }
       */
      beforeDraw: null,
      /**
       * The hook function to execute after drew the image into the canvas for compression.
       * @type {Function}
       * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
       * @param {HTMLCanvasElement} canvas - The canvas for compression.
       * @example
       * function (context, canvas) {
       *   context.filter = 'grayscale(100%)';
       * }
       */
      drew: null,
      /**
       * The hook function to execute when success to compress the image.
       * @type {Function}
       * @param {File} file - The compressed image File object.
       * @example
       * function (file) {
       *   console.log(file);
       * }
       */
      success: null,
      /**
       * The hook function to execute when fail to compress the image.
       * @type {Function}
       * @param {Error} err - An Error object.
       * @example
       * function (err) {
       *   console.log(err.message);
       * }
       */
      error: null
    }, I = typeof window < "u" && typeof window.document < "u", R = I ? window : {}, U = function(x) {
      return x > 0 && x < 1 / 0;
    }, H = Array.prototype.slice;
    function m(O) {
      return Array.from ? Array.from(O) : H.call(O);
    }
    var y = /^image\/.+$/;
    function f(O) {
      return y.test(O);
    }
    function T(O) {
      var x = f(O) ? O.substr(6) : "";
      return x === "jpeg" && (x = "jpg"), ".".concat(x);
    }
    var S = String.fromCharCode;
    function j(O, x, w) {
      var E = "", N;
      for (w += x, N = x; N < w; N += 1)
        E += S(O.getUint8(N));
      return E;
    }
    var z = R.btoa;
    function Y(O, x) {
      for (var w = [], E = 8192, N = new Uint8Array(O); N.length > 0; )
        w.push(S.apply(null, m(N.subarray(0, E)))), N = N.subarray(E);
      return "data:".concat(x, ";base64,").concat(z(w.join("")));
    }
    function K(O) {
      var x = new DataView(O), w;
      try {
        var E, N, M;
        if (x.getUint8(0) === 255 && x.getUint8(1) === 216)
          for (var V = x.byteLength, A = 2; A + 1 < V; ) {
            if (x.getUint8(A) === 255 && x.getUint8(A + 1) === 225) {
              N = A;
              break;
            }
            A += 1;
          }
        if (N) {
          var k = N + 4, G = N + 10;
          if (j(x, k, 4) === "Exif") {
            var ne = x.getUint16(G);
            if (E = ne === 18761, (E || ne === 19789) && x.getUint16(G + 2, E) === 42) {
              var ue = x.getUint32(G + 4, E);
              ue >= 8 && (M = G + ue);
            }
          }
        }
        if (M) {
          var Se = x.getUint16(M, E), ye, J;
          for (J = 0; J < Se; J += 1)
            if (ye = M + J * 12 + 2, x.getUint16(ye, E) === 274) {
              ye += 8, w = x.getUint16(ye, E), x.setUint16(ye, 1, E);
              break;
            }
        }
      } catch {
        w = 1;
      }
      return w;
    }
    function de(O) {
      var x = 0, w = 1, E = 1;
      switch (O) {
        case 2:
          w = -1;
          break;
        case 3:
          x = -180;
          break;
        case 4:
          E = -1;
          break;
        case 5:
          x = 90, E = -1;
          break;
        case 6:
          x = 90;
          break;
        case 7:
          x = 90, w = -1;
          break;
        case 8:
          x = -90;
          break;
      }
      return {
        rotate: x,
        scaleX: w,
        scaleY: E
      };
    }
    var q = /\.\d*(?:0|9){12}\d*$/;
    function Z(O) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
      return q.test(O) ? Math.round(O * x) / x : O;
    }
    function re(O) {
      var x = O.aspectRatio, w = O.height, E = O.width, N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none", M = U(E), V = U(w);
      if (M && V) {
        var A = w * x;
        (N === "contain" || N === "none") && A > E || N === "cover" && A < E ? w = E / x : E = w * x;
      } else
        M ? w = E / x : V && (E = w * x);
      return {
        width: E,
        height: w
      };
    }
    function g(O) {
      for (var x = m(new Uint8Array(O)), w = x.length, E = [], N = 0; N + 3 < w; ) {
        var M = x[N], V = x[N + 1];
        if (M === 255 && V === 218)
          break;
        if (M === 255 && V === 216)
          N += 2;
        else {
          var A = x[N + 2] * 256 + x[N + 3], k = N + A + 2, G = x.slice(N, k);
          E.push(G), N = k;
        }
      }
      return E.reduce(function(ne, ue) {
        return ue[0] === 255 && ue[1] === 225 ? ne.concat(ue) : ne;
      }, []);
    }
    function p(O, x) {
      var w = m(new Uint8Array(O));
      if (w[2] !== 255 || w[3] !== 224)
        return O;
      var E = w[4] * 256 + w[5], N = [255, 216].concat(x, w.slice(4 + E));
      return new Uint8Array(N);
    }
    var v = R.ArrayBuffer, C = R.FileReader, d = R.URL || R.webkitURL, b = /\.\w+$/, $ = R.Compressor, B = /* @__PURE__ */ function() {
      function O(x, w) {
        i(this, O), this.file = x, this.exif = [], this.image = new Image(), this.options = n(n({}, W), w), this.aborted = !1, this.result = null, this.init();
      }
      return a(O, [{
        key: "init",
        value: function() {
          var w = this, E = this.file, N = this.options;
          if (!D(E)) {
            this.fail(new Error("The first argument must be a File or Blob object."));
            return;
          }
          var M = E.type;
          if (!f(M)) {
            this.fail(new Error("The first argument must be an image File or Blob object."));
            return;
          }
          if (!d || !C) {
            this.fail(new Error("The current browser does not support image compression."));
            return;
          }
          v || (N.checkOrientation = !1, N.retainExif = !1);
          var V = M === "image/jpeg", A = V && N.checkOrientation, k = V && N.retainExif;
          if (d && !A && !k)
            this.load({
              url: d.createObjectURL(E)
            });
          else {
            var G = new C();
            this.reader = G, G.onload = function(ne) {
              var ue = ne.target, Se = ue.result, ye = {}, J = 1;
              A && (J = K(Se), J > 1 && u(ye, de(J))), k && (w.exif = g(Se)), A || k ? !d || J > 1 ? ye.url = Y(Se, M) : ye.url = d.createObjectURL(E) : ye.url = Se, w.load(ye);
            }, G.onabort = function() {
              w.fail(new Error("Aborted to read the image with FileReader."));
            }, G.onerror = function() {
              w.fail(new Error("Failed to read the image with FileReader."));
            }, G.onloadend = function() {
              w.reader = null;
            }, A || k ? G.readAsArrayBuffer(E) : G.readAsDataURL(E);
          }
        }
      }, {
        key: "load",
        value: function(w) {
          var E = this, N = this.file, M = this.image;
          M.onload = function() {
            E.draw(n(n({}, w), {}, {
              naturalWidth: M.naturalWidth,
              naturalHeight: M.naturalHeight
            }));
          }, M.onabort = function() {
            E.fail(new Error("Aborted to load the image."));
          }, M.onerror = function() {
            E.fail(new Error("Failed to load the image."));
          }, R.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(R.navigator.userAgent) && (M.crossOrigin = "anonymous"), M.alt = N.name, M.src = w.url;
        }
      }, {
        key: "draw",
        value: function(w) {
          var E = this, N = w.naturalWidth, M = w.naturalHeight, V = w.rotate, A = V === void 0 ? 0 : V, k = w.scaleX, G = k === void 0 ? 1 : k, ne = w.scaleY, ue = ne === void 0 ? 1 : ne, Se = this.file, ye = this.image, J = this.options, Te = document.createElement("canvas"), he = Te.getContext("2d"), De = Math.abs(A) % 180 === 90, Tt = (J.resize === "contain" || J.resize === "cover") && U(J.width) && U(J.height), Ve = Math.max(J.maxWidth, 0) || 1 / 0, Ye = Math.max(J.maxHeight, 0) || 1 / 0, $e = Math.max(J.minWidth, 0) || 0, Xe = Math.max(J.minHeight, 0) || 0, Ke = N / M, we = J.width, _e = J.height;
          if (De) {
            var Wt = [Ye, Ve];
            Ve = Wt[0], Ye = Wt[1];
            var Vt = [Xe, $e];
            $e = Vt[0], Xe = Vt[1];
            var Yt = [_e, we];
            we = Yt[0], _e = Yt[1];
          }
          Tt && (Ke = we / _e);
          var ot = re({
            aspectRatio: Ke,
            width: Ve,
            height: Ye
          }, "contain");
          Ve = ot.width, Ye = ot.height;
          var Pt = re({
            aspectRatio: Ke,
            width: $e,
            height: Xe
          }, "cover");
          if ($e = Pt.width, Xe = Pt.height, Tt) {
            var qe = re({
              aspectRatio: Ke,
              width: we,
              height: _e
            }, J.resize);
            we = qe.width, _e = qe.height;
          } else {
            var at = re({
              aspectRatio: Ke,
              width: we,
              height: _e
            }), st = at.width;
            we = st === void 0 ? N : st;
            var jt = at.height;
            _e = jt === void 0 ? M : jt;
          }
          we = Math.floor(Z(Math.min(Math.max(we, $e), Ve))), _e = Math.floor(Z(Math.min(Math.max(_e, Xe), Ye)));
          var Er = -we / 2, Kt = -_e / 2, Or = we, Gt = _e, ct = [];
          if (Tt) {
            var Xt = 0, Jt = 0, ut = N, kt = M, Zt = re({
              aspectRatio: Ke,
              width: N,
              height: M
            }, {
              contain: "cover",
              cover: "contain"
            }[J.resize]);
            ut = Zt.width, kt = Zt.height, Xt = (N - ut) / 2, Jt = (M - kt) / 2, ct.push(Xt, Jt, ut, kt);
          }
          if (ct.push(Er, Kt, Or, Gt), De) {
            var Qt = [_e, we];
            we = Qt[0], _e = Qt[1];
          }
          Te.width = we, Te.height = _e, f(J.mimeType) || (J.mimeType = Se.type);
          var er = "transparent";
          Se.size > J.convertSize && J.convertTypes.indexOf(J.mimeType) >= 0 && (J.mimeType = "image/jpeg");
          var l = J.mimeType === "image/jpeg";
          if (l && (er = "#fff"), he.fillStyle = er, he.fillRect(0, 0, we, _e), J.beforeDraw && J.beforeDraw.call(this, he, Te), !this.aborted && (he.save(), he.translate(we / 2, _e / 2), he.rotate(A * Math.PI / 180), he.scale(G, ue), he.drawImage.apply(he, [ye].concat(ct)), he.restore(), J.drew && J.drew.call(this, he, Te), !this.aborted)) {
            var L = function(X) {
              if (!E.aborted) {
                var oe = function(ge) {
                  return E.done({
                    naturalWidth: N,
                    naturalHeight: M,
                    result: ge
                  });
                };
                if (X && l && J.retainExif && E.exif && E.exif.length > 0) {
                  var ae = function(ge) {
                    return oe(P(Y(p(ge, E.exif), J.mimeType)));
                  };
                  if (X.arrayBuffer)
                    X.arrayBuffer().then(ae).catch(function() {
                      E.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."));
                    });
                  else {
                    var Q = new C();
                    E.reader = Q, Q.onload = function(ee) {
                      var ge = ee.target;
                      ae(ge.result);
                    }, Q.onabort = function() {
                      E.fail(new Error("Aborted to read the compressed image with FileReader."));
                    }, Q.onerror = function() {
                      E.fail(new Error("Failed to read the compressed image with FileReader."));
                    }, Q.onloadend = function() {
                      E.reader = null;
                    }, Q.readAsArrayBuffer(X);
                  }
                } else
                  oe(X);
              }
            };
            Te.toBlob ? Te.toBlob(L, J.mimeType, J.quality) : L(P(Te.toDataURL(J.mimeType, J.quality)));
          }
        }
      }, {
        key: "done",
        value: function(w) {
          var E = w.naturalWidth, N = w.naturalHeight, M = w.result, V = this.file, A = this.image, k = this.options;
          if (d && A.src.indexOf("blob:") === 0 && d.revokeObjectURL(A.src), M)
            if (k.strict && !k.retainExif && M.size > V.size && k.mimeType === V.type && !(k.width > E || k.height > N || k.minWidth > E || k.minHeight > N || k.maxWidth < E || k.maxHeight < N))
              M = V;
            else {
              var G = /* @__PURE__ */ new Date();
              M.lastModified = G.getTime(), M.lastModifiedDate = G, M.name = V.name, M.name && M.type !== V.type && (M.name = M.name.replace(b, T(M.type)));
            }
          else
            M = V;
          this.result = M, k.success && k.success.call(this, M);
        }
      }, {
        key: "fail",
        value: function(w) {
          var E = this.options;
          if (E.error)
            E.error.call(this, w);
          else
            throw w;
        }
      }, {
        key: "abort",
        value: function() {
          this.aborted || (this.aborted = !0, this.reader ? this.reader.abort() : this.image.complete ? this.fail(new Error("The compression process has been aborted.")) : (this.image.onload = null, this.image.onabort()));
        }
        /**
         * Get the no conflict compressor class.
         * @returns {Compressor} The compressor class.
         */
      }], [{
        key: "noConflict",
        value: function() {
          return window.Compressor = $, O;
        }
        /**
         * Change the default options.
         * @param {Object} options - The new default options.
         */
      }, {
        key: "setDefaults",
        value: function(w) {
          u(W, w);
        }
      }]), O;
    }();
    return B;
  });
})(Uo);
var _s = Uo.exports, Es = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(dr, "__esModule", { value: !0 });
dr.compressImage = void 0;
const Os = hr, Ss = Es(_s), Rs = async (e, t) => Os.isBrowser ? new Promise((r, n) => new Ss.default(e, Object.assign(Object.assign({}, t), { success: r, error: n }))) : e;
dr.compressImage = Rs;
var ze = {}, me = {}, Rn = { exports: {} }, Ao = function(t, r) {
  return function() {
    for (var i = new Array(arguments.length), o = 0; o < i.length; o++)
      i[o] = arguments[o];
    return t.apply(r, i);
  };
}, Ts = Ao, it = Object.prototype.toString;
function Tn(e) {
  return it.call(e) === "[object Array]";
}
function rn(e) {
  return typeof e > "u";
}
function Ps(e) {
  return e !== null && !rn(e) && e.constructor !== null && !rn(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function js(e) {
  return it.call(e) === "[object ArrayBuffer]";
}
function ks(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function Cs(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && e.buffer instanceof ArrayBuffer, t;
}
function Us(e) {
  return typeof e == "string";
}
function As(e) {
  return typeof e == "number";
}
function Lo(e) {
  return e !== null && typeof e == "object";
}
function nr(e) {
  if (it.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function Ls(e) {
  return it.call(e) === "[object Date]";
}
function Ds(e) {
  return it.call(e) === "[object File]";
}
function Ns(e) {
  return it.call(e) === "[object Blob]";
}
function Do(e) {
  return it.call(e) === "[object Function]";
}
function Is(e) {
  return Lo(e) && Do(e.pipe);
}
function $s(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function qs(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function Ms() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Pn(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), Tn(e))
      for (var r = 0, n = e.length; r < n; r++)
        t.call(null, e[r], r, e);
    else
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
}
function nn() {
  var e = {};
  function t(i, o) {
    nr(e[o]) && nr(i) ? e[o] = nn(e[o], i) : nr(i) ? e[o] = nn({}, i) : Tn(i) ? e[o] = i.slice() : e[o] = i;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    Pn(arguments[r], t);
  return e;
}
function Bs(e, t, r) {
  return Pn(t, function(i, o) {
    r && typeof i == "function" ? e[o] = Ts(i, r) : e[o] = i;
  }), e;
}
function zs(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var Ce = {
  isArray: Tn,
  isArrayBuffer: js,
  isBuffer: Ps,
  isFormData: ks,
  isArrayBufferView: Cs,
  isString: Us,
  isNumber: As,
  isObject: Lo,
  isPlainObject: nr,
  isUndefined: rn,
  isDate: Ls,
  isFile: Ds,
  isBlob: Ns,
  isFunction: Do,
  isStream: Is,
  isURLSearchParams: $s,
  isStandardBrowserEnv: Ms,
  forEach: Pn,
  merge: nn,
  extend: Bs,
  trim: qs,
  stripBOM: zs
}, pt = Ce;
function Zn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var No = function(t, r, n) {
  if (!r)
    return t;
  var i;
  if (n)
    i = n(r);
  else if (pt.isURLSearchParams(r))
    i = r.toString();
  else {
    var o = [];
    pt.forEach(r, function(u, c) {
      u === null || typeof u > "u" || (pt.isArray(u) ? c = c + "[]" : u = [u], pt.forEach(u, function(h) {
        pt.isDate(h) ? h = h.toISOString() : pt.isObject(h) && (h = JSON.stringify(h)), o.push(Zn(c) + "=" + Zn(h));
      }));
    }), i = o.join("&");
  }
  if (i) {
    var a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}, Fs = Ce;
function mr() {
  this.handlers = [];
}
mr.prototype.use = function(t, r, n) {
  return this.handlers.push({
    fulfilled: t,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
mr.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
mr.prototype.forEach = function(t) {
  Fs.forEach(this.handlers, function(n) {
    n !== null && t(n);
  });
};
var Hs = mr, Ws = Ce, Vs = function(t, r) {
  Ws.forEach(t, function(i, o) {
    o !== r && o.toUpperCase() === r.toUpperCase() && (t[r] = i, delete t[o]);
  });
}, Io = function(t, r, n, i, o) {
  return t.config = r, n && (t.code = n), t.request = i, t.response = o, t.isAxiosError = !0, t.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, t;
}, Rr, Qn;
function $o() {
  if (Qn)
    return Rr;
  Qn = 1;
  var e = Io;
  return Rr = function(r, n, i, o, a) {
    var s = new Error(r);
    return e(s, n, i, o, a);
  }, Rr;
}
var Tr, ei;
function Ys() {
  if (ei)
    return Tr;
  ei = 1;
  var e = $o();
  return Tr = function(r, n, i) {
    var o = i.config.validateStatus;
    !i.status || !o || o(i.status) ? r(i) : n(e(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, Tr;
}
var Pr, ti;
function Ks() {
  if (ti)
    return Pr;
  ti = 1;
  var e = Ce;
  return Pr = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(n, i, o, a, s, u) {
          var c = [];
          c.push(n + "=" + encodeURIComponent(i)), e.isNumber(o) && c.push("expires=" + new Date(o).toGMTString()), e.isString(a) && c.push("path=" + a), e.isString(s) && c.push("domain=" + s), u === !0 && c.push("secure"), document.cookie = c.join("; ");
        },
        read: function(n) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Pr;
}
var jr, ri;
function Gs() {
  return ri || (ri = 1, jr = function(t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  }), jr;
}
var kr, ni;
function Xs() {
  return ni || (ni = 1, kr = function(t, r) {
    return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
  }), kr;
}
var Cr, ii;
function Js() {
  if (ii)
    return Cr;
  ii = 1;
  var e = Gs(), t = Xs();
  return Cr = function(n, i) {
    return n && !e(i) ? t(n, i) : i;
  }, Cr;
}
var Ur, oi;
function Zs() {
  if (oi)
    return Ur;
  oi = 1;
  var e = Ce, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Ur = function(n) {
    var i = {}, o, a, s;
    return n && e.forEach(n.split(`
`), function(c) {
      if (s = c.indexOf(":"), o = e.trim(c.substr(0, s)).toLowerCase(), a = e.trim(c.substr(s + 1)), o) {
        if (i[o] && t.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? i[o] = (i[o] ? i[o] : []).concat([a]) : i[o] = i[o] ? i[o] + ", " + a : a;
      }
    }), i;
  }, Ur;
}
var Ar, ai;
function Qs() {
  if (ai)
    return Ar;
  ai = 1;
  var e = Ce;
  return Ar = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), i;
      function o(a) {
        var s = a;
        return r && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return i = o(window.location.href), function(s) {
        var u = e.isString(s) ? o(s) : s;
        return u.protocol === i.protocol && u.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), Ar;
}
var Lr, si;
function ci() {
  if (si)
    return Lr;
  si = 1;
  var e = Ce, t = Ys(), r = Ks(), n = No, i = Js(), o = Zs(), a = Qs(), s = $o();
  return Lr = function(c) {
    return new Promise(function(h, P) {
      var D = c.data, W = c.headers, I = c.responseType;
      e.isFormData(D) && delete W["Content-Type"];
      var R = new XMLHttpRequest();
      if (c.auth) {
        var U = c.auth.username || "", H = c.auth.password ? unescape(encodeURIComponent(c.auth.password)) : "";
        W.Authorization = "Basic " + btoa(U + ":" + H);
      }
      var m = i(c.baseURL, c.url);
      R.open(c.method.toUpperCase(), n(m, c.params, c.paramsSerializer), !0), R.timeout = c.timeout;
      function y() {
        if (R) {
          var T = "getAllResponseHeaders" in R ? o(R.getAllResponseHeaders()) : null, S = !I || I === "text" || I === "json" ? R.responseText : R.response, j = {
            data: S,
            status: R.status,
            statusText: R.statusText,
            headers: T,
            config: c,
            request: R
          };
          t(h, P, j), R = null;
        }
      }
      if ("onloadend" in R ? R.onloadend = y : R.onreadystatechange = function() {
        !R || R.readyState !== 4 || R.status === 0 && !(R.responseURL && R.responseURL.indexOf("file:") === 0) || setTimeout(y);
      }, R.onabort = function() {
        R && (P(s("Request aborted", c, "ECONNABORTED", R)), R = null);
      }, R.onerror = function() {
        P(s("Network Error", c, null, R)), R = null;
      }, R.ontimeout = function() {
        var S = "timeout of " + c.timeout + "ms exceeded";
        c.timeoutErrorMessage && (S = c.timeoutErrorMessage), P(s(
          S,
          c,
          c.transitional && c.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          R
        )), R = null;
      }, e.isStandardBrowserEnv()) {
        var f = (c.withCredentials || a(m)) && c.xsrfCookieName ? r.read(c.xsrfCookieName) : void 0;
        f && (W[c.xsrfHeaderName] = f);
      }
      "setRequestHeader" in R && e.forEach(W, function(S, j) {
        typeof D > "u" && j.toLowerCase() === "content-type" ? delete W[j] : R.setRequestHeader(j, S);
      }), e.isUndefined(c.withCredentials) || (R.withCredentials = !!c.withCredentials), I && I !== "json" && (R.responseType = c.responseType), typeof c.onDownloadProgress == "function" && R.addEventListener("progress", c.onDownloadProgress), typeof c.onUploadProgress == "function" && R.upload && R.upload.addEventListener("progress", c.onUploadProgress), c.cancelToken && c.cancelToken.promise.then(function(S) {
        R && (R.abort(), P(S), R = null);
      }), D || (D = null), R.send(D);
    });
  }, Lr;
}
var Ee = Ce, ui = Vs, ec = Io, tc = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function li(e, t) {
  !Ee.isUndefined(e) && Ee.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function rc() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = ci()), e;
}
function nc(e, t, r) {
  if (Ee.isString(e))
    try {
      return (t || JSON.parse)(e), Ee.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
var vr = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: rc(),
  transformRequest: [function(t, r) {
    return ui(r, "Accept"), ui(r, "Content-Type"), Ee.isFormData(t) || Ee.isArrayBuffer(t) || Ee.isBuffer(t) || Ee.isStream(t) || Ee.isFile(t) || Ee.isBlob(t) ? t : Ee.isArrayBufferView(t) ? t.buffer : Ee.isURLSearchParams(t) ? (li(r, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : Ee.isObject(t) || r && r["Content-Type"] === "application/json" ? (li(r, "application/json"), nc(t)) : t;
  }],
  transformResponse: [function(t) {
    var r = this.transitional, n = r && r.silentJSONParsing, i = r && r.forcedJSONParsing, o = !n && this.responseType === "json";
    if (o || i && Ee.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? ec(a, this, "E_JSON_PARSE") : a;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  }
};
vr.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
Ee.forEach(["delete", "get", "head"], function(t) {
  vr.headers[t] = {};
});
Ee.forEach(["post", "put", "patch"], function(t) {
  vr.headers[t] = Ee.merge(tc);
});
var jn = vr, ic = Ce, oc = jn, ac = function(t, r, n) {
  var i = this || oc;
  return ic.forEach(n, function(a) {
    t = a.call(i, t, r);
  }), t;
}, Dr, pi;
function qo() {
  return pi || (pi = 1, Dr = function(t) {
    return !!(t && t.__CANCEL__);
  }), Dr;
}
var fi = Ce, Nr = ac, sc = qo(), cc = jn;
function Ir(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var uc = function(t) {
  Ir(t), t.headers = t.headers || {}, t.data = Nr.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = fi.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), fi.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete t.headers[i];
    }
  );
  var r = t.adapter || cc.adapter;
  return r(t).then(function(i) {
    return Ir(t), i.data = Nr.call(
      t,
      i.data,
      i.headers,
      t.transformResponse
    ), i;
  }, function(i) {
    return sc(i) || (Ir(t), i && i.response && (i.response.data = Nr.call(
      t,
      i.response.data,
      i.response.headers,
      t.transformResponse
    ))), Promise.reject(i);
  });
}, Re = Ce, Mo = function(t, r) {
  r = r || {};
  var n = {}, i = ["url", "method", "data"], o = ["headers", "auth", "proxy", "params"], a = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], s = ["validateStatus"];
  function u(P, D) {
    return Re.isPlainObject(P) && Re.isPlainObject(D) ? Re.merge(P, D) : Re.isPlainObject(D) ? Re.merge({}, D) : Re.isArray(D) ? D.slice() : D;
  }
  function c(P) {
    Re.isUndefined(r[P]) ? Re.isUndefined(t[P]) || (n[P] = u(void 0, t[P])) : n[P] = u(t[P], r[P]);
  }
  Re.forEach(i, function(D) {
    Re.isUndefined(r[D]) || (n[D] = u(void 0, r[D]));
  }), Re.forEach(o, c), Re.forEach(a, function(D) {
    Re.isUndefined(r[D]) ? Re.isUndefined(t[D]) || (n[D] = u(void 0, t[D])) : n[D] = u(void 0, r[D]);
  }), Re.forEach(s, function(D) {
    D in r ? n[D] = u(t[D], r[D]) : D in t && (n[D] = u(void 0, t[D]));
  });
  var _ = i.concat(o).concat(a).concat(s), h = Object.keys(t).concat(Object.keys(r)).filter(function(D) {
    return _.indexOf(D) === -1;
  });
  return Re.forEach(h, c), n;
};
const lc = "axios", pc = "0.21.4", fc = "Promise based HTTP client for the browser and node.js", dc = "index.js", hc = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, mc = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, vc = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], yc = "Matt Zabriskie", gc = "MIT", bc = {
  url: "https://github.com/axios/axios/issues"
}, xc = "https://axios-http.com", wc = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, _c = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, Ec = "dist/axios.min.js", Oc = "dist/axios.min.js", Sc = "./index.d.ts", Rc = {
  "follow-redirects": "^1.14.0"
}, Tc = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], Pc = {
  name: lc,
  version: pc,
  description: fc,
  main: dc,
  scripts: hc,
  repository: mc,
  keywords: vc,
  author: yc,
  license: gc,
  bugs: bc,
  homepage: xc,
  devDependencies: wc,
  browser: _c,
  jsdelivr: Ec,
  unpkg: Oc,
  typings: Sc,
  dependencies: Rc,
  bundlesize: Tc
};
var Bo = Pc, kn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  kn[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var di = {}, jc = Bo.version.split(".");
function zo(e, t) {
  for (var r = t ? t.split(".") : jc, n = e.split("."), i = 0; i < 3; i++) {
    if (r[i] > n[i])
      return !0;
    if (r[i] < n[i])
      return !1;
  }
  return !1;
}
kn.transitional = function(t, r, n) {
  var i = r && zo(r);
  function o(a, s) {
    return "[Axios v" + Bo.version + "] Transitional option '" + a + "'" + s + (n ? ". " + n : "");
  }
  return function(a, s, u) {
    if (t === !1)
      throw new Error(o(s, " has been removed in " + r));
    return i && !di[s] && (di[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, s, u) : !0;
  };
};
function kc(e, t, r) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(e), i = n.length; i-- > 0; ) {
    var o = n[i], a = t[o];
    if (a) {
      var s = e[o], u = s === void 0 || a(s, o, e);
      if (u !== !0)
        throw new TypeError("option " + o + " must be " + u);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + o);
  }
}
var Cc = {
  isOlderVersion: zo,
  assertOptions: kc,
  validators: kn
}, Fo = Ce, Uc = No, hi = Hs, mi = uc, yr = Mo, Ho = Cc, ft = Ho.validators;
function zt(e) {
  this.defaults = e, this.interceptors = {
    request: new hi(),
    response: new hi()
  };
}
zt.prototype.request = function(t) {
  typeof t == "string" ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = yr(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var r = t.transitional;
  r !== void 0 && Ho.assertOptions(r, {
    silentJSONParsing: ft.transitional(ft.boolean, "1.0.0"),
    forcedJSONParsing: ft.transitional(ft.boolean, "1.0.0"),
    clarifyTimeoutError: ft.transitional(ft.boolean, "1.0.0")
  }, !1);
  var n = [], i = !0;
  this.interceptors.request.forEach(function(P) {
    typeof P.runWhen == "function" && P.runWhen(t) === !1 || (i = i && P.synchronous, n.unshift(P.fulfilled, P.rejected));
  });
  var o = [];
  this.interceptors.response.forEach(function(P) {
    o.push(P.fulfilled, P.rejected);
  });
  var a;
  if (!i) {
    var s = [mi, void 0];
    for (Array.prototype.unshift.apply(s, n), s = s.concat(o), a = Promise.resolve(t); s.length; )
      a = a.then(s.shift(), s.shift());
    return a;
  }
  for (var u = t; n.length; ) {
    var c = n.shift(), _ = n.shift();
    try {
      u = c(u);
    } catch (h) {
      _(h);
      break;
    }
  }
  try {
    a = mi(u);
  } catch (h) {
    return Promise.reject(h);
  }
  for (; o.length; )
    a = a.then(o.shift(), o.shift());
  return a;
};
zt.prototype.getUri = function(t) {
  return t = yr(this.defaults, t), Uc(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
Fo.forEach(["delete", "get", "head", "options"], function(t) {
  zt.prototype[t] = function(r, n) {
    return this.request(yr(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
Fo.forEach(["post", "put", "patch"], function(t) {
  zt.prototype[t] = function(r, n, i) {
    return this.request(yr(i || {}, {
      method: t,
      url: r,
      data: n
    }));
  };
});
var Ac = zt, $r, vi;
function Wo() {
  if (vi)
    return $r;
  vi = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, $r = e, $r;
}
var qr, yi;
function Lc() {
  if (yi)
    return qr;
  yi = 1;
  var e = Wo();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    var i = this;
    r(function(a) {
      i.reason || (i.reason = new e(a), n(i.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var n, i = new t(function(a) {
      n = a;
    });
    return {
      token: i,
      cancel: n
    };
  }, qr = t, qr;
}
var Mr, gi;
function Dc() {
  return gi || (gi = 1, Mr = function(t) {
    return function(n) {
      return t.apply(null, n);
    };
  }), Mr;
}
var Br, bi;
function Nc() {
  return bi || (bi = 1, Br = function(t) {
    return typeof t == "object" && t.isAxiosError === !0;
  }), Br;
}
var xi = Ce, Ic = Ao, ir = Ac, $c = Mo, qc = jn;
function Vo(e) {
  var t = new ir(e), r = Ic(ir.prototype.request, t);
  return xi.extend(r, ir.prototype, t), xi.extend(r, t), r;
}
var Le = Vo(qc);
Le.Axios = ir;
Le.create = function(t) {
  return Vo($c(Le.defaults, t));
};
Le.Cancel = Wo();
Le.CancelToken = Lc();
Le.isCancel = qo();
Le.all = function(t) {
  return Promise.all(t);
};
Le.spread = Dc();
Le.isAxiosError = Nc();
Rn.exports = Le;
Rn.exports.default = Le;
var Mc = Rn.exports, Bc = Mc;
const Yo = "3.7.5", zc = Yo, Fc = typeof atob == "function", Hc = typeof btoa == "function", St = typeof Buffer == "function", wi = typeof TextDecoder == "function" ? new TextDecoder() : void 0, _i = typeof TextEncoder == "function" ? new TextEncoder() : void 0, Wc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Ct = Array.prototype.slice.call(Wc), rr = ((e) => {
  let t = {};
  return e.forEach((r, n) => t[r] = n), t;
})(Ct), Vc = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, Oe = String.fromCharCode.bind(String), Ei = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), Ko = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), Go = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), Xo = (e) => {
  let t, r, n, i, o = "";
  const a = e.length % 3;
  for (let s = 0; s < e.length; ) {
    if ((r = e.charCodeAt(s++)) > 255 || (n = e.charCodeAt(s++)) > 255 || (i = e.charCodeAt(s++)) > 255)
      throw new TypeError("invalid character found");
    t = r << 16 | n << 8 | i, o += Ct[t >> 18 & 63] + Ct[t >> 12 & 63] + Ct[t >> 6 & 63] + Ct[t & 63];
  }
  return a ? o.slice(0, a - 3) + "===".substring(a) : o;
}, Cn = Hc ? (e) => btoa(e) : St ? (e) => Buffer.from(e, "binary").toString("base64") : Xo, on = St ? (e) => Buffer.from(e).toString("base64") : (e) => {
  let r = [];
  for (let n = 0, i = e.length; n < i; n += 4096)
    r.push(Oe.apply(null, e.subarray(n, n + 4096)));
  return Cn(r.join(""));
}, or = (e, t = !1) => t ? Ko(on(e)) : on(e), Yc = (e) => {
  if (e.length < 2) {
    var t = e.charCodeAt(0);
    return t < 128 ? e : t < 2048 ? Oe(192 | t >>> 6) + Oe(128 | t & 63) : Oe(224 | t >>> 12 & 15) + Oe(128 | t >>> 6 & 63) + Oe(128 | t & 63);
  } else {
    var t = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
    return Oe(240 | t >>> 18 & 7) + Oe(128 | t >>> 12 & 63) + Oe(128 | t >>> 6 & 63) + Oe(128 | t & 63);
  }
}, Kc = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, Jo = (e) => e.replace(Kc, Yc), Oi = St ? (e) => Buffer.from(e, "utf8").toString("base64") : _i ? (e) => on(_i.encode(e)) : (e) => Cn(Jo(e)), bt = (e, t = !1) => t ? Ko(Oi(e)) : Oi(e), Si = (e) => bt(e, !0), Gc = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, Xc = (e) => {
  switch (e.length) {
    case 4:
      var t = (7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3), r = t - 65536;
      return Oe((r >>> 10) + 55296) + Oe((r & 1023) + 56320);
    case 3:
      return Oe((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return Oe((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, Zo = (e) => e.replace(Gc, Xc), Qo = (e) => {
  if (e = e.replace(/\s+/g, ""), !Vc.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (e.length & 3));
  let t, r = "", n, i;
  for (let o = 0; o < e.length; )
    t = rr[e.charAt(o++)] << 18 | rr[e.charAt(o++)] << 12 | (n = rr[e.charAt(o++)]) << 6 | (i = rr[e.charAt(o++)]), r += n === 64 ? Oe(t >> 16 & 255) : i === 64 ? Oe(t >> 16 & 255, t >> 8 & 255) : Oe(t >> 16 & 255, t >> 8 & 255, t & 255);
  return r;
}, Un = Fc ? (e) => atob(Go(e)) : St ? (e) => Buffer.from(e, "base64").toString("binary") : Qo, ea = St ? (e) => Ei(Buffer.from(e, "base64")) : (e) => Ei(Un(e).split("").map((t) => t.charCodeAt(0))), ta = (e) => ea(ra(e)), Jc = St ? (e) => Buffer.from(e, "base64").toString("utf8") : wi ? (e) => wi.decode(ea(e)) : (e) => Zo(Un(e)), ra = (e) => Go(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), an = (e) => Jc(ra(e)), Zc = (e) => {
  if (typeof e != "string")
    return !1;
  const t = e.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(t) || !/[^\s0-9a-zA-Z\-_]/.test(t);
}, na = (e) => ({
  value: e,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), ia = function() {
  const e = (t, r) => Object.defineProperty(String.prototype, t, na(r));
  e("fromBase64", function() {
    return an(this);
  }), e("toBase64", function(t) {
    return bt(this, t);
  }), e("toBase64URI", function() {
    return bt(this, !0);
  }), e("toBase64URL", function() {
    return bt(this, !0);
  }), e("toUint8Array", function() {
    return ta(this);
  });
}, oa = function() {
  const e = (t, r) => Object.defineProperty(Uint8Array.prototype, t, na(r));
  e("toBase64", function(t) {
    return or(this, t);
  }), e("toBase64URI", function() {
    return or(this, !0);
  }), e("toBase64URL", function() {
    return or(this, !0);
  });
}, Qc = () => {
  ia(), oa();
}, eu = {
  version: Yo,
  VERSION: zc,
  atob: Un,
  atobPolyfill: Qo,
  btoa: Cn,
  btoaPolyfill: Xo,
  fromBase64: an,
  toBase64: bt,
  encode: bt,
  encodeURI: Si,
  encodeURL: Si,
  utob: Jo,
  btou: Zo,
  decode: an,
  isValid: Zc,
  fromUint8Array: or,
  toUint8Array: ta,
  extendString: ia,
  extendUint8Array: oa,
  extendBuiltins: Qc
};
var tu = function(t, r) {
  if (r = r.split(":")[0], t = +t, !t)
    return !1;
  switch (r) {
    case "http":
    case "ws":
      return t !== 80;
    case "https":
    case "wss":
      return t !== 443;
    case "ftp":
      return t !== 21;
    case "gopher":
      return t !== 70;
    case "file":
      return !1;
  }
  return t !== 0;
}, An = {}, ru = Object.prototype.hasOwnProperty, nu;
function Ri(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return null;
  }
}
function Ti(e) {
  try {
    return encodeURIComponent(e);
  } catch {
    return null;
  }
}
function iu(e) {
  for (var t = /([^=?#&]+)=?([^&]*)/g, r = {}, n; n = t.exec(e); ) {
    var i = Ri(n[1]), o = Ri(n[2]);
    i === null || o === null || i in r || (r[i] = o);
  }
  return r;
}
function ou(e, t) {
  t = t || "";
  var r = [], n, i;
  typeof t != "string" && (t = "?");
  for (i in e)
    if (ru.call(e, i)) {
      if (n = e[i], !n && (n === null || n === nu || isNaN(n)) && (n = ""), i = Ti(i), n = Ti(n), i === null || n === null)
        continue;
      r.push(i + "=" + n);
    }
  return r.length ? t + r.join("&") : "";
}
An.stringify = ou;
An.parse = iu;
var aa = tu, gr = An, au = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, sa = /[\n\r\t]/g, su = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, ca = /:\d+$/, cu = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, uu = /^[a-zA-Z]:/;
function Ln(e) {
  return (e || "").toString().replace(au, "");
}
var sn = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  function(t, r) {
    return Ne(r.protocol) ? t.replace(/\\/g, "/") : t;
  },
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
], Pi = { hash: 1, query: 1 };
function ua(e) {
  var t;
  typeof window < "u" ? t = window : typeof ie < "u" ? t = ie : typeof self < "u" ? t = self : t = {};
  var r = t.location || {};
  e = e || r;
  var n = {}, i = typeof e, o;
  if (e.protocol === "blob:")
    n = new Ie(unescape(e.pathname), {});
  else if (i === "string") {
    n = new Ie(e, {});
    for (o in Pi)
      delete n[o];
  } else if (i === "object") {
    for (o in e)
      o in Pi || (n[o] = e[o]);
    n.slashes === void 0 && (n.slashes = su.test(e.href));
  }
  return n;
}
function Ne(e) {
  return e === "file:" || e === "ftp:" || e === "http:" || e === "https:" || e === "ws:" || e === "wss:";
}
function la(e, t) {
  e = Ln(e), e = e.replace(sa, ""), t = t || {};
  var r = cu.exec(e), n = r[1] ? r[1].toLowerCase() : "", i = !!r[2], o = !!r[3], a = 0, s;
  return i ? o ? (s = r[2] + r[3] + r[4], a = r[2].length + r[3].length) : (s = r[2] + r[4], a = r[2].length) : o ? (s = r[3] + r[4], a = r[3].length) : s = r[4], n === "file:" ? a >= 2 && (s = s.slice(2)) : Ne(n) ? s = r[4] : n ? i && (s = s.slice(2)) : a >= 2 && Ne(t.protocol) && (s = r[4]), {
    protocol: n,
    slashes: i || Ne(n),
    slashesCount: a,
    rest: s
  };
}
function lu(e, t) {
  if (e === "")
    return t;
  for (var r = (t || "/").split("/").slice(0, -1).concat(e.split("/")), n = r.length, i = r[n - 1], o = !1, a = 0; n--; )
    r[n] === "." ? r.splice(n, 1) : r[n] === ".." ? (r.splice(n, 1), a++) : a && (n === 0 && (o = !0), r.splice(n, 1), a--);
  return o && r.unshift(""), (i === "." || i === "..") && r.push(""), r.join("/");
}
function Ie(e, t, r) {
  if (e = Ln(e), e = e.replace(sa, ""), !(this instanceof Ie))
    return new Ie(e, t, r);
  var n, i, o, a, s, u, c = sn.slice(), _ = typeof t, h = this, P = 0;
  for (_ !== "object" && _ !== "string" && (r = t, t = null), r && typeof r != "function" && (r = gr.parse), t = ua(t), i = la(e || "", t), n = !i.protocol && !i.slashes, h.slashes = i.slashes || n && t.slashes, h.protocol = i.protocol || t.protocol || "", e = i.rest, (i.protocol === "file:" && (i.slashesCount !== 2 || uu.test(e)) || !i.slashes && (i.protocol || i.slashesCount < 2 || !Ne(h.protocol))) && (c[3] = [/(.*)/, "pathname"]); P < c.length; P++) {
    if (a = c[P], typeof a == "function") {
      e = a(e, h);
      continue;
    }
    o = a[0], u = a[1], o !== o ? h[u] = e : typeof o == "string" ? (s = o === "@" ? e.lastIndexOf(o) : e.indexOf(o), ~s && (typeof a[2] == "number" ? (h[u] = e.slice(0, s), e = e.slice(s + a[2])) : (h[u] = e.slice(s), e = e.slice(0, s)))) : (s = o.exec(e)) && (h[u] = s[1], e = e.slice(0, s.index)), h[u] = h[u] || n && a[3] && t[u] || "", a[4] && (h[u] = h[u].toLowerCase());
  }
  r && (h.query = r(h.query)), n && t.slashes && h.pathname.charAt(0) !== "/" && (h.pathname !== "" || t.pathname !== "") && (h.pathname = lu(h.pathname, t.pathname)), h.pathname.charAt(0) !== "/" && Ne(h.protocol) && (h.pathname = "/" + h.pathname), aa(h.port, h.protocol) || (h.host = h.hostname, h.port = ""), h.username = h.password = "", h.auth && (s = h.auth.indexOf(":"), ~s ? (h.username = h.auth.slice(0, s), h.username = encodeURIComponent(decodeURIComponent(h.username)), h.password = h.auth.slice(s + 1), h.password = encodeURIComponent(decodeURIComponent(h.password))) : h.username = encodeURIComponent(decodeURIComponent(h.auth)), h.auth = h.password ? h.username + ":" + h.password : h.username), h.origin = h.protocol !== "file:" && Ne(h.protocol) && h.host ? h.protocol + "//" + h.host : "null", h.href = h.toString();
}
function pu(e, t, r) {
  var n = this;
  switch (e) {
    case "query":
      typeof t == "string" && t.length && (t = (r || gr.parse)(t)), n[e] = t;
      break;
    case "port":
      n[e] = t, aa(t, n.protocol) ? t && (n.host = n.hostname + ":" + t) : (n.host = n.hostname, n[e] = "");
      break;
    case "hostname":
      n[e] = t, n.port && (t += ":" + n.port), n.host = t;
      break;
    case "host":
      n[e] = t, ca.test(t) ? (t = t.split(":"), n.port = t.pop(), n.hostname = t.join(":")) : (n.hostname = t, n.port = "");
      break;
    case "protocol":
      n.protocol = t.toLowerCase(), n.slashes = !r;
      break;
    case "pathname":
    case "hash":
      if (t) {
        var i = e === "pathname" ? "/" : "#";
        n[e] = t.charAt(0) !== i ? i + t : t;
      } else
        n[e] = t;
      break;
    case "username":
    case "password":
      n[e] = encodeURIComponent(t);
      break;
    case "auth":
      var o = t.indexOf(":");
      ~o ? (n.username = t.slice(0, o), n.username = encodeURIComponent(decodeURIComponent(n.username)), n.password = t.slice(o + 1), n.password = encodeURIComponent(decodeURIComponent(n.password))) : n.username = encodeURIComponent(decodeURIComponent(t));
  }
  for (var a = 0; a < sn.length; a++) {
    var s = sn[a];
    s[4] && (n[s[1]] = n[s[1]].toLowerCase());
  }
  return n.auth = n.password ? n.username + ":" + n.password : n.username, n.origin = n.protocol !== "file:" && Ne(n.protocol) && n.host ? n.protocol + "//" + n.host : "null", n.href = n.toString(), n;
}
function fu(e) {
  (!e || typeof e != "function") && (e = gr.stringify);
  var t, r = this, n = r.host, i = r.protocol;
  i && i.charAt(i.length - 1) !== ":" && (i += ":");
  var o = i + (r.protocol && r.slashes || Ne(r.protocol) ? "//" : "");
  return r.username ? (o += r.username, r.password && (o += ":" + r.password), o += "@") : r.password ? (o += ":" + r.password, o += "@") : r.protocol !== "file:" && Ne(r.protocol) && !n && r.pathname !== "/" && (o += "@"), (n[n.length - 1] === ":" || ca.test(r.hostname) && !r.port) && (n += ":"), o += n + r.pathname, t = typeof r.query == "object" ? e(r.query) : r.query, t && (o += t.charAt(0) !== "?" ? "?" + t : t), r.hash && (o += r.hash), o;
}
Ie.prototype = { set: pu, toString: fu };
Ie.extractProtocol = la;
Ie.location = ua;
Ie.trimLeft = Ln;
Ie.qs = gr;
var du = Ie;
const hu = /* @__PURE__ */ fr(du);
function _t(e) {
  "@babel/helpers - typeof";
  return _t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _t(e);
}
function ji(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vu(n.key), n);
  }
}
function mu(e, t, r) {
  return t && ji(e.prototype, t), r && ji(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vu(e) {
  var t = yu(e, "string");
  return _t(t) === "symbol" ? t : String(t);
}
function yu(e, t) {
  if (_t(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (_t(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gu(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function bu(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Lt(e, t);
}
function xu(e) {
  var t = pa();
  return function() {
    var n = Dt(e), i;
    if (t) {
      var o = Dt(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return wu(this, i);
  };
}
function wu(e, t) {
  if (t && (_t(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _u(e);
}
function _u(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cn(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return cn = function(n) {
    if (n === null || !Eu(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, i);
    }
    function i() {
      return ar(n, arguments, Dt(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Lt(i, n);
  }, cn(e);
}
function ar(e, t, r) {
  return pa() ? ar = Reflect.construct.bind() : ar = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var u = Function.bind.apply(i, s), c = new u();
    return a && Lt(c, a.prototype), c;
  }, ar.apply(null, arguments);
}
function pa() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Eu(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Lt(e, t) {
  return Lt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Lt(e, t);
}
function Dt(e) {
  return Dt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Dt(e);
}
var Ut = /* @__PURE__ */ function(e) {
  bu(r, e);
  var t = xu(r);
  function r(n) {
    var i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (gu(this, r), i = t.call(this, n), i.originalRequest = a, i.originalResponse = s, i.causingError = o, o != null && (n += ", caused by ".concat(o.toString())), a != null) {
      var u = a.getHeader("X-Request-ID") || "n/a", c = a.getMethod(), _ = a.getURL(), h = s ? s.getStatus() : "n/a", P = s ? s.getBody() || "" : "n/a";
      n += ", originated from request (method: ".concat(c, ", url: ").concat(_, ", response code: ").concat(h, ", response text: ").concat(P, ", request id: ").concat(u, ")");
    }
    return i.message = n, i;
  }
  return mu(r);
}(/* @__PURE__ */ cn(Error)), fa = !1;
function Ou() {
  fa = !0;
}
function Je(e) {
  fa && console.log(e);
}
function Su() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    var t = Math.random() * 16 | 0, r = e === "x" ? t : t & 3 | 8;
    return r.toString(16);
  });
}
function un() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  un = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(g, p, v) {
    g[p] = v.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function c(g, p, v) {
    return Object.defineProperty(g, p, { value: v, enumerable: !0, configurable: !0, writable: !0 }), g[p];
  }
  try {
    c({}, "");
  } catch {
    c = function(v, C, d) {
      return v[C] = d;
    };
  }
  function _(g, p, v, C) {
    var d = p && p.prototype instanceof U ? p : U, b = Object.create(d.prototype), $ = new Z(C || []);
    return i(b, "_invoke", { value: Y(g, v, $) }), b;
  }
  function h(g, p, v) {
    try {
      return { type: "normal", arg: g.call(p, v) };
    } catch (C) {
      return { type: "throw", arg: C };
    }
  }
  t.wrap = _;
  var P = "suspendedStart", D = "suspendedYield", W = "executing", I = "completed", R = {};
  function U() {
  }
  function H() {
  }
  function m() {
  }
  var y = {};
  c(y, a, function() {
    return this;
  });
  var f = Object.getPrototypeOf, T = f && f(f(re([])));
  T && T !== r && n.call(T, a) && (y = T);
  var S = m.prototype = U.prototype = Object.create(y);
  function j(g) {
    ["next", "throw", "return"].forEach(function(p) {
      c(g, p, function(v) {
        return this._invoke(p, v);
      });
    });
  }
  function z(g, p) {
    function v(d, b, $, B) {
      var O = h(g[d], g, b);
      if (O.type !== "throw") {
        var x = O.arg, w = x.value;
        return w && rt(w) == "object" && n.call(w, "__await") ? p.resolve(w.__await).then(function(E) {
          v("next", E, $, B);
        }, function(E) {
          v("throw", E, $, B);
        }) : p.resolve(w).then(function(E) {
          x.value = E, $(x);
        }, function(E) {
          return v("throw", E, $, B);
        });
      }
      B(O.arg);
    }
    var C;
    i(this, "_invoke", { value: function(b, $) {
      function B() {
        return new p(function(O, x) {
          v(b, $, O, x);
        });
      }
      return C = C ? C.then(B, B) : B();
    } });
  }
  function Y(g, p, v) {
    var C = P;
    return function(d, b) {
      if (C === W)
        throw new Error("Generator is already running");
      if (C === I) {
        if (d === "throw")
          throw b;
        return { value: e, done: !0 };
      }
      for (v.method = d, v.arg = b; ; ) {
        var $ = v.delegate;
        if ($) {
          var B = K($, v);
          if (B) {
            if (B === R)
              continue;
            return B;
          }
        }
        if (v.method === "next")
          v.sent = v._sent = v.arg;
        else if (v.method === "throw") {
          if (C === P)
            throw C = I, v.arg;
          v.dispatchException(v.arg);
        } else
          v.method === "return" && v.abrupt("return", v.arg);
        C = W;
        var O = h(g, p, v);
        if (O.type === "normal") {
          if (C = v.done ? I : D, O.arg === R)
            continue;
          return { value: O.arg, done: v.done };
        }
        O.type === "throw" && (C = I, v.method = "throw", v.arg = O.arg);
      }
    };
  }
  function K(g, p) {
    var v = p.method, C = g.iterator[v];
    if (C === e)
      return p.delegate = null, v === "throw" && g.iterator.return && (p.method = "return", p.arg = e, K(g, p), p.method === "throw") || v !== "return" && (p.method = "throw", p.arg = new TypeError("The iterator does not provide a '" + v + "' method")), R;
    var d = h(C, g.iterator, p.arg);
    if (d.type === "throw")
      return p.method = "throw", p.arg = d.arg, p.delegate = null, R;
    var b = d.arg;
    return b ? b.done ? (p[g.resultName] = b.value, p.next = g.nextLoc, p.method !== "return" && (p.method = "next", p.arg = e), p.delegate = null, R) : b : (p.method = "throw", p.arg = new TypeError("iterator result is not an object"), p.delegate = null, R);
  }
  function de(g) {
    var p = { tryLoc: g[0] };
    1 in g && (p.catchLoc = g[1]), 2 in g && (p.finallyLoc = g[2], p.afterLoc = g[3]), this.tryEntries.push(p);
  }
  function q(g) {
    var p = g.completion || {};
    p.type = "normal", delete p.arg, g.completion = p;
  }
  function Z(g) {
    this.tryEntries = [{ tryLoc: "root" }], g.forEach(de, this), this.reset(!0);
  }
  function re(g) {
    if (g || g === "") {
      var p = g[a];
      if (p)
        return p.call(g);
      if (typeof g.next == "function")
        return g;
      if (!isNaN(g.length)) {
        var v = -1, C = function d() {
          for (; ++v < g.length; )
            if (n.call(g, v))
              return d.value = g[v], d.done = !1, d;
          return d.value = e, d.done = !0, d;
        };
        return C.next = C;
      }
    }
    throw new TypeError(rt(g) + " is not iterable");
  }
  return H.prototype = m, i(S, "constructor", { value: m, configurable: !0 }), i(m, "constructor", { value: H, configurable: !0 }), H.displayName = c(m, u, "GeneratorFunction"), t.isGeneratorFunction = function(g) {
    var p = typeof g == "function" && g.constructor;
    return !!p && (p === H || (p.displayName || p.name) === "GeneratorFunction");
  }, t.mark = function(g) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(g, m) : (g.__proto__ = m, c(g, u, "GeneratorFunction")), g.prototype = Object.create(S), g;
  }, t.awrap = function(g) {
    return { __await: g };
  }, j(z.prototype), c(z.prototype, s, function() {
    return this;
  }), t.AsyncIterator = z, t.async = function(g, p, v, C, d) {
    d === void 0 && (d = Promise);
    var b = new z(_(g, p, v, C), d);
    return t.isGeneratorFunction(p) ? b : b.next().then(function($) {
      return $.done ? $.value : b.next();
    });
  }, j(S), c(S, u, "Generator"), c(S, a, function() {
    return this;
  }), c(S, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(g) {
    var p = Object(g), v = [];
    for (var C in p)
      v.push(C);
    return v.reverse(), function d() {
      for (; v.length; ) {
        var b = v.pop();
        if (b in p)
          return d.value = b, d.done = !1, d;
      }
      return d.done = !0, d;
    };
  }, t.values = re, Z.prototype = { constructor: Z, reset: function(p) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(q), !p)
      for (var v in this)
        v.charAt(0) === "t" && n.call(this, v) && !isNaN(+v.slice(1)) && (this[v] = e);
  }, stop: function() {
    this.done = !0;
    var p = this.tryEntries[0].completion;
    if (p.type === "throw")
      throw p.arg;
    return this.rval;
  }, dispatchException: function(p) {
    if (this.done)
      throw p;
    var v = this;
    function C(x, w) {
      return $.type = "throw", $.arg = p, v.next = x, w && (v.method = "next", v.arg = e), !!w;
    }
    for (var d = this.tryEntries.length - 1; d >= 0; --d) {
      var b = this.tryEntries[d], $ = b.completion;
      if (b.tryLoc === "root")
        return C("end");
      if (b.tryLoc <= this.prev) {
        var B = n.call(b, "catchLoc"), O = n.call(b, "finallyLoc");
        if (B && O) {
          if (this.prev < b.catchLoc)
            return C(b.catchLoc, !0);
          if (this.prev < b.finallyLoc)
            return C(b.finallyLoc);
        } else if (B) {
          if (this.prev < b.catchLoc)
            return C(b.catchLoc, !0);
        } else {
          if (!O)
            throw new Error("try statement without catch or finally");
          if (this.prev < b.finallyLoc)
            return C(b.finallyLoc);
        }
      }
    }
  }, abrupt: function(p, v) {
    for (var C = this.tryEntries.length - 1; C >= 0; --C) {
      var d = this.tryEntries[C];
      if (d.tryLoc <= this.prev && n.call(d, "finallyLoc") && this.prev < d.finallyLoc) {
        var b = d;
        break;
      }
    }
    b && (p === "break" || p === "continue") && b.tryLoc <= v && v <= b.finallyLoc && (b = null);
    var $ = b ? b.completion : {};
    return $.type = p, $.arg = v, b ? (this.method = "next", this.next = b.finallyLoc, R) : this.complete($);
  }, complete: function(p, v) {
    if (p.type === "throw")
      throw p.arg;
    return p.type === "break" || p.type === "continue" ? this.next = p.arg : p.type === "return" ? (this.rval = this.arg = p.arg, this.method = "return", this.next = "end") : p.type === "normal" && v && (this.next = v), R;
  }, finish: function(p) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var C = this.tryEntries[v];
      if (C.finallyLoc === p)
        return this.complete(C.completion, C.afterLoc), q(C), R;
    }
  }, catch: function(p) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var C = this.tryEntries[v];
      if (C.tryLoc === p) {
        var d = C.completion;
        if (d.type === "throw") {
          var b = d.arg;
          q(C);
        }
        return b;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(p, v, C) {
    return this.delegate = { iterator: re(p), resultName: v, nextLoc: C }, this.method === "next" && (this.arg = e), R;
  } }, t;
}
function ki(e, t, r, n, i, o, a) {
  try {
    var s = e[o](a), u = s.value;
  } catch (c) {
    r(c);
    return;
  }
  s.done ? t(u) : Promise.resolve(u).then(n, i);
}
function Ru(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, i) {
      var o = e.apply(t, r);
      function a(u) {
        ki(o, n, i, a, s, "next", u);
      }
      function s(u) {
        ki(o, n, i, a, s, "throw", u);
      }
      a(void 0);
    });
  };
}
function da(e, t) {
  return ku(e) || ju(e, t) || Pu(e, t) || Tu();
}
function Tu() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pu(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ci(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ci(e, t);
  }
}
function Ci(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function ju(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, o, a, s = [], u = !0, c = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r)
          return;
        u = !1;
      } else
        for (; !(u = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); u = !0)
          ;
    } catch (_) {
      c = !0, i = _;
    } finally {
      try {
        if (!u && r.return != null && (a = r.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw i;
      }
    }
    return s;
  }
}
function ku(e) {
  if (Array.isArray(e))
    return e;
}
function rt(e) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rt(e);
}
function Ui(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ui(Object(r), !0).forEach(function(n) {
      Cu(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ui(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Cu(e, t, r) {
  return t = ha(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Uu(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ai(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ha(n.key), n);
  }
}
function Au(e, t, r) {
  return t && Ai(e.prototype, t), r && Ai(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ha(e) {
  var t = Lu(e, "string");
  return rt(t) === "symbol" ? t : String(t);
}
function Lu(e, t) {
  if (rt(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (rt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Du = {
  endpoint: null,
  uploadUrl: null,
  metadata: {},
  fingerprint: null,
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  onUploadUrlAvailable: null,
  overridePatchMethod: !1,
  headers: {},
  addRequestId: !1,
  onBeforeRequest: null,
  onAfterResponse: null,
  onShouldRetry: ma,
  chunkSize: 1 / 0,
  retryDelays: [0, 1e3, 3e3, 5e3],
  parallelUploads: 1,
  parallelUploadBoundaries: null,
  storeFingerprintForResuming: !0,
  removeFingerprintOnSuccess: !1,
  uploadLengthDeferred: !1,
  uploadDataDuringCreation: !1,
  urlStorage: null,
  fileReader: null,
  httpStack: null
}, cr = /* @__PURE__ */ function() {
  function e(t, r) {
    Uu(this, e), "resume" in r && console.log("tus: The `resume` option has been removed in tus-js-client v2. Please use the URL storage API instead."), this.options = r, this.options.chunkSize = Number(this.options.chunkSize), this._urlStorage = this.options.urlStorage, this.file = t, this.url = null, this._req = null, this._fingerprint = null, this._urlStorageKey = null, this._offset = null, this._aborted = !1, this._size = null, this._source = null, this._retryAttempt = 0, this._retryTimeout = null, this._offsetBeforeRetry = 0, this._parallelUploads = null, this._parallelUploadUrls = null;
  }
  return Au(e, [{
    key: "findPreviousUploads",
    value: function() {
      var r = this;
      return this.options.fingerprint(this.file, this.options).then(function(n) {
        return r._urlStorage.findUploadsByFingerprint(n);
      });
    }
  }, {
    key: "resumeFromPreviousUpload",
    value: function(r) {
      this.url = r.uploadUrl || null, this._parallelUploadUrls = r.parallelUploadUrls || null, this._urlStorageKey = r.urlStorageKey;
    }
  }, {
    key: "start",
    value: function() {
      var r = this, n = this.file;
      if (!n) {
        this._emitError(new Error("tus: no file or stream to upload provided"));
        return;
      }
      if (!this.options.endpoint && !this.options.uploadUrl && !this.url) {
        this._emitError(new Error("tus: neither an endpoint or an upload URL is provided"));
        return;
      }
      var i = this.options.retryDelays;
      if (i != null && Object.prototype.toString.call(i) !== "[object Array]") {
        this._emitError(new Error("tus: the `retryDelays` option must either be an array or null"));
        return;
      }
      if (this.options.parallelUploads > 1)
        for (var o = 0, a = ["uploadUrl", "uploadSize", "uploadLengthDeferred"]; o < a.length; o++) {
          var s = a[o];
          if (this.options[s]) {
            this._emitError(new Error("tus: cannot use the ".concat(s, " option when parallelUploads is enabled")));
            return;
          }
        }
      if (this.options.parallelUploadBoundaries) {
        if (this.options.parallelUploads <= 1) {
          this._emitError(new Error("tus: cannot use the `parallelUploadBoundaries` option when `parallelUploads` is disabled"));
          return;
        }
        if (this.options.parallelUploads !== this.options.parallelUploadBoundaries.length) {
          this._emitError(new Error("tus: the `parallelUploadBoundaries` must have the same length as the value of `parallelUploads`"));
          return;
        }
      }
      this.options.fingerprint(n, this.options).then(function(u) {
        return u == null ? Je("No fingerprint was calculated meaning that the upload cannot be stored in the URL storage.") : Je("Calculated fingerprint: ".concat(u)), r._fingerprint = u, r._source ? r._source : r.options.fileReader.openFile(n, r.options.chunkSize);
      }).then(function(u) {
        if (r._source = u, r.options.uploadLengthDeferred)
          r._size = null;
        else if (r.options.uploadSize != null) {
          if (r._size = Number(r.options.uploadSize), Number.isNaN(r._size)) {
            r._emitError(new Error("tus: cannot convert `uploadSize` option into a number"));
            return;
          }
        } else if (r._size = r._source.size, r._size == null) {
          r._emitError(new Error("tus: cannot automatically derive upload's size from input. Specify it manually using the `uploadSize` option or use the `uploadLengthDeferred` option"));
          return;
        }
        r.options.parallelUploads > 1 || r._parallelUploadUrls != null ? r._startParallelUpload() : r._startSingleUpload();
      }).catch(function(u) {
        r._emitError(u);
      });
    }
    /**
     * Initiate the uploading procedure for a parallelized upload, where one file is split into
     * multiple request which are run in parallel.
     *
     * @api private
     */
  }, {
    key: "_startParallelUpload",
    value: function() {
      var r, n = this, i = this._size, o = 0;
      this._parallelUploads = [];
      var a = this._parallelUploadUrls != null ? this._parallelUploadUrls.length : this.options.parallelUploads, s = (r = this.options.parallelUploadBoundaries) !== null && r !== void 0 ? r : Iu(this._source.size, a);
      this._parallelUploadUrls && s.forEach(function(_, h) {
        _.uploadUrl = n._parallelUploadUrls[h] || null;
      }), this._parallelUploadUrls = new Array(s.length);
      var u = s.map(function(_, h) {
        var P = 0;
        return n._source.slice(_.start, _.end).then(function(D) {
          var W = D.value;
          return new Promise(function(I, R) {
            var U = dt(dt({}, n.options), {}, {
              // If available, the partial upload should be resumed from a previous URL.
              uploadUrl: _.uploadUrl || null,
              // We take manually care of resuming for partial uploads, so they should
              // not be stored in the URL storage.
              storeFingerprintForResuming: !1,
              removeFingerprintOnSuccess: !1,
              // Reset the parallelUploads option to not cause recursion.
              parallelUploads: 1,
              // Reset this option as we are not doing a parallel upload.
              parallelUploadBoundaries: null,
              metadata: {},
              // Add the header to indicate the this is a partial upload.
              headers: dt(dt({}, n.options.headers), {}, {
                "Upload-Concat": "partial"
              }),
              // Reject or resolve the promise if the upload errors or completes.
              onSuccess: I,
              onError: R,
              // Based in the progress for this partial upload, calculate the progress
              // for the entire final upload.
              onProgress: function(y) {
                o = o - P + y, P = y, n._emitProgress(o, i);
              },
              // Wait until every partial upload has an upload URL, so we can add
              // them to the URL storage.
              onUploadUrlAvailable: function() {
                n._parallelUploadUrls[h] = H.url, n._parallelUploadUrls.filter(function(y) {
                  return !!y;
                }).length === s.length && n._saveUploadInUrlStorage();
              }
            }), H = new e(W, U);
            H.start(), n._parallelUploads.push(H);
          });
        });
      }), c;
      Promise.all(u).then(function() {
        c = n._openRequest("POST", n.options.endpoint), c.setHeader("Upload-Concat", "final;".concat(n._parallelUploadUrls.join(" ")));
        var _ = Li(n.options.metadata);
        return _ !== "" && c.setHeader("Upload-Metadata", _), n._sendRequest(c, null);
      }).then(function(_) {
        if (!vt(_.getStatus(), 200)) {
          n._emitHttpError(c, _, "tus: unexpected response while creating upload");
          return;
        }
        var h = _.getHeader("Location");
        if (h == null) {
          n._emitHttpError(c, _, "tus: invalid or missing Location header");
          return;
        }
        n.url = $i(n.options.endpoint, h), Je("Created upload at ".concat(n.url)), n._emitSuccess();
      }).catch(function(_) {
        n._emitError(_);
      });
    }
    /**
     * Initiate the uploading procedure for a non-parallel upload. Here the entire file is
     * uploaded in a sequential matter.
     *
     * @api private
     */
  }, {
    key: "_startSingleUpload",
    value: function() {
      if (this._aborted = !1, this.url != null) {
        Je("Resuming upload from previous URL: ".concat(this.url)), this._resumeUpload();
        return;
      }
      if (this.options.uploadUrl != null) {
        Je("Resuming upload from provided URL: ".concat(this.options.uploadUrl)), this.url = this.options.uploadUrl, this._resumeUpload();
        return;
      }
      Je("Creating a new upload"), this._createUpload();
    }
    /**
     * Abort any running request and stop the current upload. After abort is called, no event
     * handler will be invoked anymore. You can use the `start` method to resume the upload
     * again.
     * If `shouldTerminate` is true, the `terminate` function will be called to remove the
     * current upload from the server.
     *
     * @param {boolean} shouldTerminate True if the upload should be deleted from the server.
     * @return {Promise} The Promise will be resolved/rejected when the requests finish.
     */
  }, {
    key: "abort",
    value: function(r) {
      var n = this;
      return this._parallelUploads != null && this._parallelUploads.forEach(function(i) {
        i.abort(r);
      }), this._req !== null && this._req.abort(), this._aborted = !0, this._retryTimeout != null && (clearTimeout(this._retryTimeout), this._retryTimeout = null), !r || this.url == null ? Promise.resolve() : e.terminate(this.url, this.options).then(function() {
        return n._removeFromUrlStorage();
      });
    }
  }, {
    key: "_emitHttpError",
    value: function(r, n, i, o) {
      this._emitError(new Ut(i, o, r, n));
    }
  }, {
    key: "_emitError",
    value: function(r) {
      var n = this;
      if (!this._aborted) {
        if (this.options.retryDelays != null) {
          var i = this._offset != null && this._offset > this._offsetBeforeRetry;
          if (i && (this._retryAttempt = 0), Ii(r, this._retryAttempt, this.options)) {
            var o = this.options.retryDelays[this._retryAttempt++];
            this._offsetBeforeRetry = this._offset, this._retryTimeout = setTimeout(function() {
              n.start();
            }, o);
            return;
          }
        }
        if (typeof this.options.onError == "function")
          this.options.onError(r);
        else
          throw r;
      }
    }
    /**
     * Publishes notification if the upload has been successfully completed.
     *
     * @api private
     */
  }, {
    key: "_emitSuccess",
    value: function() {
      this.options.removeFingerprintOnSuccess && this._removeFromUrlStorage(), typeof this.options.onSuccess == "function" && this.options.onSuccess();
    }
    /**
     * Publishes notification when data has been sent to the server. This
     * data may not have been accepted by the server yet.
     *
     * @param {number} bytesSent  Number of bytes sent to the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitProgress",
    value: function(r, n) {
      typeof this.options.onProgress == "function" && this.options.onProgress(r, n);
    }
    /**
     * Publishes notification when a chunk of data has been sent to the server
     * and accepted by the server.
     * @param {number} chunkSize  Size of the chunk that was accepted by the server.
     * @param {number} bytesAccepted Total number of bytes that have been
     *                                accepted by the server.
     * @param {number} bytesTotal Total number of bytes to be sent to the server.
     * @api private
     */
  }, {
    key: "_emitChunkComplete",
    value: function(r, n, i) {
      typeof this.options.onChunkComplete == "function" && this.options.onChunkComplete(r, n, i);
    }
    /**
     * Create a new upload using the creation extension by sending a POST
     * request to the endpoint. After successful creation the file will be
     * uploaded
     *
     * @api private
     */
  }, {
    key: "_createUpload",
    value: function() {
      var r = this;
      if (!this.options.endpoint) {
        this._emitError(new Error("tus: unable to create upload because no endpoint is provided"));
        return;
      }
      var n = this._openRequest("POST", this.options.endpoint);
      this.options.uploadLengthDeferred ? n.setHeader("Upload-Defer-Length", 1) : n.setHeader("Upload-Length", this._size);
      var i = Li(this.options.metadata);
      i !== "" && n.setHeader("Upload-Metadata", i);
      var o;
      this.options.uploadDataDuringCreation && !this.options.uploadLengthDeferred ? (this._offset = 0, o = this._addChunkToRequest(n)) : o = this._sendRequest(n, null), o.then(function(a) {
        if (!vt(a.getStatus(), 200)) {
          r._emitHttpError(n, a, "tus: unexpected response while creating upload");
          return;
        }
        var s = a.getHeader("Location");
        if (s == null) {
          r._emitHttpError(n, a, "tus: invalid or missing Location header");
          return;
        }
        if (r.url = $i(r.options.endpoint, s), Je("Created upload at ".concat(r.url)), typeof r.options.onUploadUrlAvailable == "function" && r.options.onUploadUrlAvailable(), r._size === 0) {
          r._emitSuccess(), r._source.close();
          return;
        }
        r._saveUploadInUrlStorage().then(function() {
          r.options.uploadDataDuringCreation ? r._handleUploadResponse(n, a) : (r._offset = 0, r._performUpload());
        });
      }).catch(function(a) {
        r._emitHttpError(n, null, "tus: failed to create upload", a);
      });
    }
    /*
     * Try to resume an existing upload. First a HEAD request will be sent
     * to retrieve the offset. If the request fails a new upload will be
     * created. In the case of a successful response the file will be uploaded.
     *
     * @api private
     */
  }, {
    key: "_resumeUpload",
    value: function() {
      var r = this, n = this._openRequest("HEAD", this.url), i = this._sendRequest(n, null);
      i.then(function(o) {
        var a = o.getStatus();
        if (!vt(a, 200)) {
          if (a === 423) {
            r._emitHttpError(n, o, "tus: upload is currently locked; retry later");
            return;
          }
          if (vt(a, 400) && r._removeFromUrlStorage(), !r.options.endpoint) {
            r._emitHttpError(n, o, "tus: unable to resume upload (new upload cannot be created without an endpoint)");
            return;
          }
          r.url = null, r._createUpload();
          return;
        }
        var s = parseInt(o.getHeader("Upload-Offset"), 10);
        if (Number.isNaN(s)) {
          r._emitHttpError(n, o, "tus: invalid or missing offset value");
          return;
        }
        var u = parseInt(o.getHeader("Upload-Length"), 10);
        if (Number.isNaN(u) && !r.options.uploadLengthDeferred) {
          r._emitHttpError(n, o, "tus: invalid or missing length value");
          return;
        }
        typeof r.options.onUploadUrlAvailable == "function" && r.options.onUploadUrlAvailable(), r._saveUploadInUrlStorage().then(function() {
          if (s === u) {
            r._emitProgress(u, u), r._emitSuccess();
            return;
          }
          r._offset = s, r._performUpload();
        });
      }).catch(function(o) {
        r._emitHttpError(n, null, "tus: failed to resume upload", o);
      });
    }
    /**
     * Start uploading the file using PATCH requests. The file will be divided
     * into chunks as specified in the chunkSize option. During the upload
     * the onProgress event handler may be invoked multiple times.
     *
     * @api private
     */
  }, {
    key: "_performUpload",
    value: function() {
      var r = this;
      if (!this._aborted) {
        var n;
        this.options.overridePatchMethod ? (n = this._openRequest("POST", this.url), n.setHeader("X-HTTP-Method-Override", "PATCH")) : n = this._openRequest("PATCH", this.url), n.setHeader("Upload-Offset", this._offset);
        var i = this._addChunkToRequest(n);
        i.then(function(o) {
          if (!vt(o.getStatus(), 200)) {
            r._emitHttpError(n, o, "tus: unexpected response while uploading chunk");
            return;
          }
          r._handleUploadResponse(n, o);
        }).catch(function(o) {
          r._aborted || r._emitHttpError(n, null, "tus: failed to upload chunk at offset ".concat(r._offset), o);
        });
      }
    }
    /**
     * _addChunktoRequest reads a chunk from the source and sends it using the
     * supplied request object. It will not handle the response.
     *
     * @api private
     */
  }, {
    key: "_addChunkToRequest",
    value: function(r) {
      var n = this, i = this._offset, o = this._offset + this.options.chunkSize;
      return r.setProgressHandler(function(a) {
        n._emitProgress(i + a, n._size);
      }), r.setHeader("Content-Type", "application/offset+octet-stream"), (o === 1 / 0 || o > this._size) && !this.options.uploadLengthDeferred && (o = this._size), this._source.slice(i, o).then(function(a) {
        var s = a.value, u = a.done, c = s && s.size ? s.size : 0;
        n.options.uploadLengthDeferred && u && (n._size = n._offset + c, r.setHeader("Upload-Length", n._size));
        var _ = n._offset + c;
        return !n.options.uploadLengthDeferred && u && _ !== n._size ? Promise.reject(new Error("upload was configured with a size of ".concat(n._size, " bytes, but the source is done after ").concat(_, " bytes"))) : s === null ? n._sendRequest(r) : (n._emitProgress(n._offset, n._size), n._sendRequest(r, s));
      });
    }
    /**
     * _handleUploadResponse is used by requests that haven been sent using _addChunkToRequest
     * and already have received a response.
     *
     * @api private
     */
  }, {
    key: "_handleUploadResponse",
    value: function(r, n) {
      var i = parseInt(n.getHeader("Upload-Offset"), 10);
      if (Number.isNaN(i)) {
        this._emitHttpError(r, n, "tus: invalid or missing offset value");
        return;
      }
      if (this._emitProgress(i, this._size), this._emitChunkComplete(i - this._offset, i, this._size), this._offset = i, i === this._size) {
        this._emitSuccess(), this._source.close();
        return;
      }
      this._performUpload();
    }
    /**
     * Create a new HTTP request object with the given method and URL.
     *
     * @api private
     */
  }, {
    key: "_openRequest",
    value: function(r, n) {
      var i = Di(r, n, this.options);
      return this._req = i, i;
    }
    /**
     * Remove the entry in the URL storage, if it has been saved before.
     *
     * @api private
     */
  }, {
    key: "_removeFromUrlStorage",
    value: function() {
      var r = this;
      this._urlStorageKey && (this._urlStorage.removeUpload(this._urlStorageKey).catch(function(n) {
        r._emitError(n);
      }), this._urlStorageKey = null);
    }
    /**
     * Add the upload URL to the URL storage, if possible.
     *
     * @api private
     */
  }, {
    key: "_saveUploadInUrlStorage",
    value: function() {
      var r = this;
      if (!this.options.storeFingerprintForResuming || !this._fingerprint || this._urlStorageKey !== null)
        return Promise.resolve();
      var n = {
        size: this._size,
        metadata: this.options.metadata,
        creationTime: (/* @__PURE__ */ new Date()).toString()
      };
      return this._parallelUploads ? n.parallelUploadUrls = this._parallelUploadUrls : n.uploadUrl = this.url, this._urlStorage.addUpload(this._fingerprint, n).then(function(i) {
        r._urlStorageKey = i;
      });
    }
    /**
     * Send a request with the provided body.
     *
     * @api private
     */
  }, {
    key: "_sendRequest",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return Ni(r, n, this.options);
    }
  }], [{
    key: "terminate",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = Di("DELETE", r, n);
      return Ni(i, null, n).then(function(o) {
        if (o.getStatus() !== 204)
          throw new Ut("tus: unexpected response while terminating upload", null, i, o);
      }).catch(function(o) {
        if (o instanceof Ut || (o = new Ut("tus: failed to terminate upload", o, i, null)), !Ii(o, 0, n))
          throw o;
        var a = n.retryDelays[0], s = n.retryDelays.slice(1), u = dt(dt({}, n), {}, {
          retryDelays: s
        });
        return new Promise(function(c) {
          return setTimeout(c, a);
        }).then(function() {
          return e.terminate(r, u);
        });
      });
    }
  }]), e;
}();
function Li(e) {
  return Object.entries(e).map(function(t) {
    var r = da(t, 2), n = r[0], i = r[1];
    return "".concat(n, " ").concat(eu.encode(String(i)));
  }).join(",");
}
function vt(e, t) {
  return e >= t && e < t + 100;
}
function Di(e, t, r) {
  var n = r.httpStack.createRequest(e, t);
  n.setHeader("Tus-Resumable", "1.0.0");
  var i = r.headers || {};
  if (Object.entries(i).forEach(function(a) {
    var s = da(a, 2), u = s[0], c = s[1];
    n.setHeader(u, c);
  }), r.addRequestId) {
    var o = Su();
    n.setHeader("X-Request-ID", o);
  }
  return n;
}
function Ni(e, t, r) {
  return ln.apply(this, arguments);
}
function ln() {
  return ln = Ru(/* @__PURE__ */ un().mark(function e(t, r, n) {
    var i;
    return un().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            if (typeof n.onBeforeRequest != "function") {
              a.next = 3;
              break;
            }
            return a.next = 3, n.onBeforeRequest(t);
          case 3:
            return a.next = 5, t.send(r);
          case 5:
            if (i = a.sent, typeof n.onAfterResponse != "function") {
              a.next = 9;
              break;
            }
            return a.next = 9, n.onAfterResponse(t, i);
          case 9:
            return a.abrupt("return", i);
          case 10:
          case "end":
            return a.stop();
        }
    }, e);
  })), ln.apply(this, arguments);
}
function Nu() {
  var e = !0;
  return typeof window < "u" && // eslint-disable-next-line no-undef
  "navigator" in window && // eslint-disable-next-line no-undef
  window.navigator.onLine === !1 && (e = !1), e;
}
function Ii(e, t, r) {
  return r.retryDelays == null || t >= r.retryDelays.length || e.originalRequest == null ? !1 : r && typeof r.onShouldRetry == "function" ? r.onShouldRetry(e, t, r) : ma(e);
}
function ma(e) {
  var t = e.originalResponse ? e.originalResponse.getStatus() : 0;
  return (!vt(t, 400) || t === 409 || t === 423) && Nu();
}
function $i(e, t) {
  return new hu(t, e).toString();
}
function Iu(e, t) {
  for (var r = Math.floor(e / t), n = [], i = 0; i < t; i++)
    n.push({
      start: r * i,
      end: r * (i + 1)
    });
  return n[t - 1].end = e, n;
}
cr.defaultOptions = Du;
function Nt(e) {
  "@babel/helpers - typeof";
  return Nt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nt(e);
}
function $u(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Mu(n.key), n);
  }
}
function qu(e, t, r) {
  return t && qi(e.prototype, t), r && qi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Mu(e) {
  var t = Bu(e, "string");
  return Nt(t) === "symbol" ? t : String(t);
}
function Bu(e, t) {
  if (Nt(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Nt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zu = /* @__PURE__ */ function() {
  function e() {
    $u(this, e);
  }
  return qu(e, [{
    key: "listAllUploads",
    value: function() {
      return Promise.resolve([]);
    }
  }, {
    key: "findUploadsByFingerprint",
    value: function(r) {
      return Promise.resolve([]);
    }
  }, {
    key: "removeUpload",
    value: function(r) {
      return Promise.resolve();
    }
  }, {
    key: "addUpload",
    value: function(r, n) {
      return Promise.resolve(null);
    }
  }]), e;
}();
function It(e) {
  "@babel/helpers - typeof";
  return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, It(e);
}
function Fu(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Mi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wu(n.key), n);
  }
}
function Hu(e, t, r) {
  return t && Mi(e.prototype, t), r && Mi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Wu(e) {
  var t = Vu(e, "string");
  return It(t) === "symbol" ? t : String(t);
}
function Vu(e, t) {
  if (It(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (It(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var pn = !1;
try {
  pn = "localStorage" in window;
  var zr = "tusSupport", Bi = localStorage.getItem(zr);
  localStorage.setItem(zr, Bi), Bi === null && localStorage.removeItem(zr);
} catch (e) {
  if (e.code === e.SECURITY_ERR || e.code === e.QUOTA_EXCEEDED_ERR)
    pn = !1;
  else
    throw e;
}
var va = pn, Yu = /* @__PURE__ */ function() {
  function e() {
    Fu(this, e);
  }
  return Hu(e, [{
    key: "findAllUploads",
    value: function() {
      var r = this._findEntries("tus::");
      return Promise.resolve(r);
    }
  }, {
    key: "findUploadsByFingerprint",
    value: function(r) {
      var n = this._findEntries("tus::".concat(r, "::"));
      return Promise.resolve(n);
    }
  }, {
    key: "removeUpload",
    value: function(r) {
      return localStorage.removeItem(r), Promise.resolve();
    }
  }, {
    key: "addUpload",
    value: function(r, n) {
      var i = Math.round(Math.random() * 1e12), o = "tus::".concat(r, "::").concat(i);
      return localStorage.setItem(o, JSON.stringify(n)), Promise.resolve(o);
    }
  }, {
    key: "_findEntries",
    value: function(r) {
      for (var n = [], i = 0; i < localStorage.length; i++) {
        var o = localStorage.key(i);
        if (o.indexOf(r) === 0)
          try {
            var a = JSON.parse(localStorage.getItem(o));
            a.urlStorageKey = o, n.push(a);
          } catch {
          }
      }
      return n;
    }
  }]), e;
}();
function $t(e) {
  "@babel/helpers - typeof";
  return $t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $t(e);
}
function Dn(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ku(n.key), n);
  }
}
function Nn(e, t, r) {
  return t && zi(e.prototype, t), r && zi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ku(e) {
  var t = Gu(e, "string");
  return $t(t) === "symbol" ? t : String(t);
}
function Gu(e, t) {
  if ($t(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($t(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ya = /* @__PURE__ */ function() {
  function e() {
    Dn(this, e);
  }
  return Nn(e, [{
    key: "createRequest",
    value: function(r, n) {
      return new Xu(r, n);
    }
  }, {
    key: "getName",
    value: function() {
      return "XHRHttpStack";
    }
  }]), e;
}(), Xu = /* @__PURE__ */ function() {
  function e(t, r) {
    Dn(this, e), this._xhr = new XMLHttpRequest(), this._xhr.open(t, r, !0), this._method = t, this._url = r, this._headers = {};
  }
  return Nn(e, [{
    key: "getMethod",
    value: function() {
      return this._method;
    }
  }, {
    key: "getURL",
    value: function() {
      return this._url;
    }
  }, {
    key: "setHeader",
    value: function(r, n) {
      this._xhr.setRequestHeader(r, n), this._headers[r] = n;
    }
  }, {
    key: "getHeader",
    value: function(r) {
      return this._headers[r];
    }
  }, {
    key: "setProgressHandler",
    value: function(r) {
      "upload" in this._xhr && (this._xhr.upload.onprogress = function(n) {
        n.lengthComputable && r(n.loaded);
      });
    }
  }, {
    key: "send",
    value: function() {
      var r = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return new Promise(function(i, o) {
        r._xhr.onload = function() {
          i(new Ju(r._xhr));
        }, r._xhr.onerror = function(a) {
          o(a);
        }, r._xhr.send(n);
      });
    }
  }, {
    key: "abort",
    value: function() {
      return this._xhr.abort(), Promise.resolve();
    }
  }, {
    key: "getUnderlyingObject",
    value: function() {
      return this._xhr;
    }
  }]), e;
}(), Ju = /* @__PURE__ */ function() {
  function e(t) {
    Dn(this, e), this._xhr = t;
  }
  return Nn(e, [{
    key: "getStatus",
    value: function() {
      return this._xhr.status;
    }
  }, {
    key: "getHeader",
    value: function(r) {
      return this._xhr.getResponseHeader(r);
    }
  }, {
    key: "getBody",
    value: function() {
      return this._xhr.responseText;
    }
  }, {
    key: "getUnderlyingObject",
    value: function() {
      return this._xhr;
    }
  }]), e;
}(), ga = function() {
  return typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
};
function Zu(e) {
  return new Promise(function(t, r) {
    var n = new XMLHttpRequest();
    n.responseType = "blob", n.onload = function() {
      var i = n.response;
      t(i);
    }, n.onerror = function(i) {
      r(i);
    }, n.open("GET", e), n.send();
  });
}
var Qu = function() {
  return typeof window < "u" && (typeof window.PhoneGap < "u" || typeof window.Cordova < "u" || typeof window.cordova < "u");
};
function el(e) {
  return new Promise(function(t, r) {
    var n = new FileReader();
    n.onload = function() {
      var i = new Uint8Array(n.result);
      t({
        value: i
      });
    }, n.onerror = function(i) {
      r(i);
    }, n.readAsArrayBuffer(e);
  });
}
function qt(e) {
  "@babel/helpers - typeof";
  return qt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qt(e);
}
function tl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Fi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nl(n.key), n);
  }
}
function rl(e, t, r) {
  return t && Fi(e.prototype, t), r && Fi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function nl(e) {
  var t = il(e, "string");
  return qt(t) === "symbol" ? t : String(t);
}
function il(e, t) {
  if (qt(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (qt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Hi = /* @__PURE__ */ function() {
  function e(t) {
    tl(this, e), this._file = t, this.size = t.size;
  }
  return rl(e, [{
    key: "slice",
    value: function(r, n) {
      if (Qu())
        return el(this._file.slice(r, n));
      var i = this._file.slice(r, n), o = n >= this.size;
      return Promise.resolve({
        value: i,
        done: o
      });
    }
  }, {
    key: "close",
    value: function() {
    }
  }]), e;
}();
function Mt(e) {
  "@babel/helpers - typeof";
  return Mt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mt(e);
}
function ol(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sl(n.key), n);
  }
}
function al(e, t, r) {
  return t && Wi(e.prototype, t), r && Wi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sl(e) {
  var t = cl(e, "string");
  return Mt(t) === "symbol" ? t : String(t);
}
function cl(e, t) {
  if (Mt(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Mt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vi(e) {
  return e === void 0 ? 0 : e.size !== void 0 ? e.size : e.length;
}
function ul(e, t) {
  if (e.concat)
    return e.concat(t);
  if (e instanceof Blob)
    return new Blob([e, t], {
      type: e.type
    });
  if (e.set) {
    var r = new e.constructor(e.length + t.length);
    return r.set(e), r.set(t, e.length), r;
  }
  throw new Error("Unknown data type");
}
var ll = /* @__PURE__ */ function() {
  function e(t) {
    ol(this, e), this._buffer = void 0, this._bufferOffset = 0, this._reader = t, this._done = !1;
  }
  return al(e, [{
    key: "slice",
    value: function(r, n) {
      return r < this._bufferOffset ? Promise.reject(new Error("Requested data is before the reader's current offset")) : this._readUntilEnoughDataOrDone(r, n);
    }
  }, {
    key: "_readUntilEnoughDataOrDone",
    value: function(r, n) {
      var i = this, o = n <= this._bufferOffset + Vi(this._buffer);
      if (this._done || o) {
        var a = this._getDataFromBuffer(r, n), s = a == null ? this._done : !1;
        return Promise.resolve({
          value: a,
          done: s
        });
      }
      return this._reader.read().then(function(u) {
        var c = u.value, _ = u.done;
        return _ ? i._done = !0 : i._buffer === void 0 ? i._buffer = c : i._buffer = ul(i._buffer, c), i._readUntilEnoughDataOrDone(r, n);
      });
    }
  }, {
    key: "_getDataFromBuffer",
    value: function(r, n) {
      r > this._bufferOffset && (this._buffer = this._buffer.slice(r - this._bufferOffset), this._bufferOffset = r);
      var i = Vi(this._buffer) === 0;
      return this._done && i ? null : this._buffer.slice(0, n - r);
    }
  }, {
    key: "close",
    value: function() {
      this._reader.cancel && this._reader.cancel();
    }
  }]), e;
}();
function nt(e) {
  "@babel/helpers - typeof";
  return nt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nt(e);
}
function fn() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  fn = function() {
    return t;
  };
  var e, t = {}, r = Object.prototype, n = r.hasOwnProperty, i = Object.defineProperty || function(g, p, v) {
    g[p] = v.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function c(g, p, v) {
    return Object.defineProperty(g, p, { value: v, enumerable: !0, configurable: !0, writable: !0 }), g[p];
  }
  try {
    c({}, "");
  } catch {
    c = function(v, C, d) {
      return v[C] = d;
    };
  }
  function _(g, p, v, C) {
    var d = p && p.prototype instanceof U ? p : U, b = Object.create(d.prototype), $ = new Z(C || []);
    return i(b, "_invoke", { value: Y(g, v, $) }), b;
  }
  function h(g, p, v) {
    try {
      return { type: "normal", arg: g.call(p, v) };
    } catch (C) {
      return { type: "throw", arg: C };
    }
  }
  t.wrap = _;
  var P = "suspendedStart", D = "suspendedYield", W = "executing", I = "completed", R = {};
  function U() {
  }
  function H() {
  }
  function m() {
  }
  var y = {};
  c(y, a, function() {
    return this;
  });
  var f = Object.getPrototypeOf, T = f && f(f(re([])));
  T && T !== r && n.call(T, a) && (y = T);
  var S = m.prototype = U.prototype = Object.create(y);
  function j(g) {
    ["next", "throw", "return"].forEach(function(p) {
      c(g, p, function(v) {
        return this._invoke(p, v);
      });
    });
  }
  function z(g, p) {
    function v(d, b, $, B) {
      var O = h(g[d], g, b);
      if (O.type !== "throw") {
        var x = O.arg, w = x.value;
        return w && nt(w) == "object" && n.call(w, "__await") ? p.resolve(w.__await).then(function(E) {
          v("next", E, $, B);
        }, function(E) {
          v("throw", E, $, B);
        }) : p.resolve(w).then(function(E) {
          x.value = E, $(x);
        }, function(E) {
          return v("throw", E, $, B);
        });
      }
      B(O.arg);
    }
    var C;
    i(this, "_invoke", { value: function(b, $) {
      function B() {
        return new p(function(O, x) {
          v(b, $, O, x);
        });
      }
      return C = C ? C.then(B, B) : B();
    } });
  }
  function Y(g, p, v) {
    var C = P;
    return function(d, b) {
      if (C === W)
        throw new Error("Generator is already running");
      if (C === I) {
        if (d === "throw")
          throw b;
        return { value: e, done: !0 };
      }
      for (v.method = d, v.arg = b; ; ) {
        var $ = v.delegate;
        if ($) {
          var B = K($, v);
          if (B) {
            if (B === R)
              continue;
            return B;
          }
        }
        if (v.method === "next")
          v.sent = v._sent = v.arg;
        else if (v.method === "throw") {
          if (C === P)
            throw C = I, v.arg;
          v.dispatchException(v.arg);
        } else
          v.method === "return" && v.abrupt("return", v.arg);
        C = W;
        var O = h(g, p, v);
        if (O.type === "normal") {
          if (C = v.done ? I : D, O.arg === R)
            continue;
          return { value: O.arg, done: v.done };
        }
        O.type === "throw" && (C = I, v.method = "throw", v.arg = O.arg);
      }
    };
  }
  function K(g, p) {
    var v = p.method, C = g.iterator[v];
    if (C === e)
      return p.delegate = null, v === "throw" && g.iterator.return && (p.method = "return", p.arg = e, K(g, p), p.method === "throw") || v !== "return" && (p.method = "throw", p.arg = new TypeError("The iterator does not provide a '" + v + "' method")), R;
    var d = h(C, g.iterator, p.arg);
    if (d.type === "throw")
      return p.method = "throw", p.arg = d.arg, p.delegate = null, R;
    var b = d.arg;
    return b ? b.done ? (p[g.resultName] = b.value, p.next = g.nextLoc, p.method !== "return" && (p.method = "next", p.arg = e), p.delegate = null, R) : b : (p.method = "throw", p.arg = new TypeError("iterator result is not an object"), p.delegate = null, R);
  }
  function de(g) {
    var p = { tryLoc: g[0] };
    1 in g && (p.catchLoc = g[1]), 2 in g && (p.finallyLoc = g[2], p.afterLoc = g[3]), this.tryEntries.push(p);
  }
  function q(g) {
    var p = g.completion || {};
    p.type = "normal", delete p.arg, g.completion = p;
  }
  function Z(g) {
    this.tryEntries = [{ tryLoc: "root" }], g.forEach(de, this), this.reset(!0);
  }
  function re(g) {
    if (g || g === "") {
      var p = g[a];
      if (p)
        return p.call(g);
      if (typeof g.next == "function")
        return g;
      if (!isNaN(g.length)) {
        var v = -1, C = function d() {
          for (; ++v < g.length; )
            if (n.call(g, v))
              return d.value = g[v], d.done = !1, d;
          return d.value = e, d.done = !0, d;
        };
        return C.next = C;
      }
    }
    throw new TypeError(nt(g) + " is not iterable");
  }
  return H.prototype = m, i(S, "constructor", { value: m, configurable: !0 }), i(m, "constructor", { value: H, configurable: !0 }), H.displayName = c(m, u, "GeneratorFunction"), t.isGeneratorFunction = function(g) {
    var p = typeof g == "function" && g.constructor;
    return !!p && (p === H || (p.displayName || p.name) === "GeneratorFunction");
  }, t.mark = function(g) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(g, m) : (g.__proto__ = m, c(g, u, "GeneratorFunction")), g.prototype = Object.create(S), g;
  }, t.awrap = function(g) {
    return { __await: g };
  }, j(z.prototype), c(z.prototype, s, function() {
    return this;
  }), t.AsyncIterator = z, t.async = function(g, p, v, C, d) {
    d === void 0 && (d = Promise);
    var b = new z(_(g, p, v, C), d);
    return t.isGeneratorFunction(p) ? b : b.next().then(function($) {
      return $.done ? $.value : b.next();
    });
  }, j(S), c(S, u, "Generator"), c(S, a, function() {
    return this;
  }), c(S, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(g) {
    var p = Object(g), v = [];
    for (var C in p)
      v.push(C);
    return v.reverse(), function d() {
      for (; v.length; ) {
        var b = v.pop();
        if (b in p)
          return d.value = b, d.done = !1, d;
      }
      return d.done = !0, d;
    };
  }, t.values = re, Z.prototype = { constructor: Z, reset: function(p) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(q), !p)
      for (var v in this)
        v.charAt(0) === "t" && n.call(this, v) && !isNaN(+v.slice(1)) && (this[v] = e);
  }, stop: function() {
    this.done = !0;
    var p = this.tryEntries[0].completion;
    if (p.type === "throw")
      throw p.arg;
    return this.rval;
  }, dispatchException: function(p) {
    if (this.done)
      throw p;
    var v = this;
    function C(x, w) {
      return $.type = "throw", $.arg = p, v.next = x, w && (v.method = "next", v.arg = e), !!w;
    }
    for (var d = this.tryEntries.length - 1; d >= 0; --d) {
      var b = this.tryEntries[d], $ = b.completion;
      if (b.tryLoc === "root")
        return C("end");
      if (b.tryLoc <= this.prev) {
        var B = n.call(b, "catchLoc"), O = n.call(b, "finallyLoc");
        if (B && O) {
          if (this.prev < b.catchLoc)
            return C(b.catchLoc, !0);
          if (this.prev < b.finallyLoc)
            return C(b.finallyLoc);
        } else if (B) {
          if (this.prev < b.catchLoc)
            return C(b.catchLoc, !0);
        } else {
          if (!O)
            throw new Error("try statement without catch or finally");
          if (this.prev < b.finallyLoc)
            return C(b.finallyLoc);
        }
      }
    }
  }, abrupt: function(p, v) {
    for (var C = this.tryEntries.length - 1; C >= 0; --C) {
      var d = this.tryEntries[C];
      if (d.tryLoc <= this.prev && n.call(d, "finallyLoc") && this.prev < d.finallyLoc) {
        var b = d;
        break;
      }
    }
    b && (p === "break" || p === "continue") && b.tryLoc <= v && v <= b.finallyLoc && (b = null);
    var $ = b ? b.completion : {};
    return $.type = p, $.arg = v, b ? (this.method = "next", this.next = b.finallyLoc, R) : this.complete($);
  }, complete: function(p, v) {
    if (p.type === "throw")
      throw p.arg;
    return p.type === "break" || p.type === "continue" ? this.next = p.arg : p.type === "return" ? (this.rval = this.arg = p.arg, this.method = "return", this.next = "end") : p.type === "normal" && v && (this.next = v), R;
  }, finish: function(p) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var C = this.tryEntries[v];
      if (C.finallyLoc === p)
        return this.complete(C.completion, C.afterLoc), q(C), R;
    }
  }, catch: function(p) {
    for (var v = this.tryEntries.length - 1; v >= 0; --v) {
      var C = this.tryEntries[v];
      if (C.tryLoc === p) {
        var d = C.completion;
        if (d.type === "throw") {
          var b = d.arg;
          q(C);
        }
        return b;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(p, v, C) {
    return this.delegate = { iterator: re(p), resultName: v, nextLoc: C }, this.method === "next" && (this.arg = e), R;
  } }, t;
}
function Yi(e, t, r, n, i, o, a) {
  try {
    var s = e[o](a), u = s.value;
  } catch (c) {
    r(c);
    return;
  }
  s.done ? t(u) : Promise.resolve(u).then(n, i);
}
function pl(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, i) {
      var o = e.apply(t, r);
      function a(u) {
        Yi(o, n, i, a, s, "next", u);
      }
      function s(u) {
        Yi(o, n, i, a, s, "throw", u);
      }
      a(void 0);
    });
  };
}
function fl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ki(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hl(n.key), n);
  }
}
function dl(e, t, r) {
  return t && Ki(e.prototype, t), r && Ki(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function hl(e) {
  var t = ml(e, "string");
  return nt(t) === "symbol" ? t : String(t);
}
function ml(e, t) {
  if (nt(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (nt(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var vl = /* @__PURE__ */ function() {
  function e() {
    fl(this, e);
  }
  return dl(e, [{
    key: "openFile",
    value: function() {
      var t = pl(/* @__PURE__ */ fn().mark(function n(i, o) {
        var a;
        return fn().wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                if (!(ga() && i && typeof i.uri < "u")) {
                  u.next = 11;
                  break;
                }
                return u.prev = 1, u.next = 4, Zu(i.uri);
              case 4:
                return a = u.sent, u.abrupt("return", new Hi(a));
              case 8:
                throw u.prev = 8, u.t0 = u.catch(1), new Error("tus: cannot fetch `file.uri` as Blob, make sure the uri is correct and accessible. ".concat(u.t0));
              case 11:
                if (!(typeof i.slice == "function" && typeof i.size < "u")) {
                  u.next = 13;
                  break;
                }
                return u.abrupt("return", Promise.resolve(new Hi(i)));
              case 13:
                if (typeof i.read != "function") {
                  u.next = 18;
                  break;
                }
                if (o = Number(o), Number.isFinite(o)) {
                  u.next = 17;
                  break;
                }
                return u.abrupt("return", Promise.reject(new Error("cannot create source for stream without a finite value for the `chunkSize` option")));
              case 17:
                return u.abrupt("return", Promise.resolve(new ll(i, o)));
              case 18:
                return u.abrupt("return", Promise.reject(new Error("source object may only be an instance of File, Blob, or Reader in this environment")));
              case 19:
              case "end":
                return u.stop();
            }
        }, n, null, [[1, 8]]);
      }));
      function r(n, i) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }]), e;
}();
function yl(e, t) {
  return ga() ? Promise.resolve(gl(e, t)) : Promise.resolve(["tus-br", e.name, e.type, e.size, e.lastModified, t.endpoint].join("-"));
}
function gl(e, t) {
  var r = e.exif ? bl(JSON.stringify(e.exif)) : "noexif";
  return ["tus-rn", e.name || "noname", e.size || "nosize", r, t.endpoint].join("/");
}
function bl(e) {
  var t = 0;
  if (e.length === 0)
    return t;
  for (var r = 0; r < e.length; r++) {
    var n = e.charCodeAt(r);
    t = (t << 5) - t + n, t &= t;
  }
  return t;
}
function Et(e) {
  "@babel/helpers - typeof";
  return Et = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Et(e);
}
function xl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gi(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ba(n.key), n);
  }
}
function wl(e, t, r) {
  return t && Gi(e.prototype, t), r && Gi(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _l(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && dn(e, t);
}
function dn(e, t) {
  return dn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, dn(e, t);
}
function El(e) {
  var t = Rl();
  return function() {
    var n = ur(e), i;
    if (t) {
      var o = ur(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return Ol(this, i);
  };
}
function Ol(e, t) {
  if (t && (Et(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Sl(e);
}
function Sl(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rl() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ur(e) {
  return ur = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ur(e);
}
function Xi(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xi(Object(r), !0).forEach(function(n) {
      Tl(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xi(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tl(e, t, r) {
  return t = ba(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ba(e) {
  var t = Pl(e, "string");
  return Et(t) === "symbol" ? t : String(t);
}
function Pl(e, t) {
  if (Et(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (Et(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var hn = gt(gt({}, cr.defaultOptions), {}, {
  httpStack: new ya(),
  fileReader: new vl(),
  urlStorage: va ? new Yu() : new zu(),
  fingerprint: yl
}), jl = /* @__PURE__ */ function(e) {
  _l(r, e);
  var t = El(r);
  function r() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return xl(this, r), i = gt(gt({}, hn), i), t.call(this, n, i);
  }
  return wl(r, null, [{
    key: "terminate",
    value: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return o = gt(gt({}, hn), o), cr.terminate(i, o);
    }
  }]), r;
}(cr), xa = window, kl = xa.XMLHttpRequest, Ji = xa.Blob, Cl = kl && Ji && typeof Ji.prototype.slice == "function";
const Ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultHttpStack: ya,
  DetailedError: Ut,
  Upload: jl,
  canStoreURLs: va,
  defaultOptions: hn,
  enableDebugLog: Ou,
  isSupported: Cl
}, Symbol.toStringTag, { value: "Module" })), Al = /* @__PURE__ */ bs(Ul);
var je = {}, Ll = ie && ie.__createBinding || (Object.create ? function(e, t, r, n) {
  n === void 0 && (n = r);
  var i = Object.getOwnPropertyDescriptor(t, r);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, n, i);
} : function(e, t, r, n) {
  n === void 0 && (n = r), e[n] = t[r];
}), Dl = ie && ie.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Nl = ie && ie.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && Ll(t, e, r);
  return Dl(t, e), t;
};
Object.defineProperty(je, "__esModule", { value: !0 });
je.getStatus = je.unsetStatus = je.setStatus = je.getConfig = je.setConfig = void 0;
const wa = Nl(hr), In = {};
je.setConfig = wa.setConfigCreator("storage");
je.getConfig = wa.getConfigCreator("storage");
const Il = (e, t) => {
  In[e] = t;
};
je.setStatus = Il;
const $l = (e) => {
  delete In[e];
};
je.unsetStatus = $l;
const ql = (e) => In[e];
je.getStatus = ql;
var br = {};
Object.defineProperty(br, "__esModule", { value: !0 });
br.filenamify = void 0;
function Ml(e) {
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Bl(e, t) {
  const r = new RegExp(`(?:${Ml(t)}){2,}`, "g");
  return e.replace(r, t);
}
function zl(e, t) {
  return e.startsWith(t) && (e = e.slice(t.length)), e.endsWith(t) && (e = e.slice(0, -t.length)), e;
}
const Zi = /[<>:"/\\|?*\u0000-\u001F]/g, Fl = /^(con|prn|aux|nul|com\d|lpt\d)$/i, Qi = /[\u0000-\u001F\u0080-\u009F]/g, Hl = /^\.+[\\/]|^\.+$/, Wl = /\.+$/, Vl = 100, Yl = (e, { replacement: t = "_", maxLength: r = Vl } = {}) => {
  if (Zi.test(t) && Qi.test(t))
    throw new Error("Replacement string cannot contain reserved filename characters");
  if (e = e.normalize("NFD"), e = e.replace(Hl, t), e = e.replace(Zi, t), e = e.replace(Qi, t), e = e.replace(Wl, ""), t.length > 0) {
    const n = e[0] === ".";
    e = Bl(e, t), e = e.length > 1 ? zl(e, t) : e, !n && e[0] === "." && (e = t + e), e[e.length - 1] === "." && (e += t);
  }
  if (e = Fl.test(e) ? e + t : e, e.length > r) {
    const n = e.lastIndexOf(".");
    if (n === -1)
      e = e.slice(0, r);
    else {
      const i = e.slice(0, n), o = e.slice(n);
      e = i.slice(0, Math.max(1, r - o.length)) + o;
    }
  }
  return e;
};
br.filenamify = Yl;
var eo;
function $n() {
  if (eo)
    return me;
  eo = 1;
  var e = ie && ie.__createBinding || (Object.create ? function(S, j, z, Y) {
    Y === void 0 && (Y = z);
    var K = Object.getOwnPropertyDescriptor(j, z);
    (!K || ("get" in K ? !j.__esModule : K.writable || K.configurable)) && (K = { enumerable: !0, get: function() {
      return j[z];
    } }), Object.defineProperty(S, Y, K);
  } : function(S, j, z, Y) {
    Y === void 0 && (Y = z), S[Y] = j[z];
  }), t = ie && ie.__setModuleDefault || (Object.create ? function(S, j) {
    Object.defineProperty(S, "default", { enumerable: !0, value: j });
  } : function(S, j) {
    S.default = j;
  }), r = ie && ie.__importStar || function(S) {
    if (S && S.__esModule)
      return S;
    var j = {};
    if (S != null)
      for (var z in S)
        z !== "default" && Object.prototype.hasOwnProperty.call(S, z) && e(j, S, z);
    return t(j, S), j;
  }, n = ie && ie.__rest || function(S, j) {
    var z = {};
    for (var Y in S)
      Object.prototype.hasOwnProperty.call(S, Y) && j.indexOf(Y) < 0 && (z[Y] = S[Y]);
    if (S != null && typeof Object.getOwnPropertySymbols == "function")
      for (var K = 0, Y = Object.getOwnPropertySymbols(S); K < Y.length; K++)
        j.indexOf(Y[K]) < 0 && Object.prototype.propertyIsEnumerable.call(S, Y[K]) && (z[Y[K]] = S[Y[K]]);
    return z;
  }, i = ie && ie.__importDefault || function(S) {
    return S && S.__esModule ? S : { default: S };
  };
  Object.defineProperty(me, "__esModule", { value: !0 }), me.getVideo = me.saveVideo = me.uploadVideo = me.getFileInfo = me.getDownloadUrl = me.getConvertStatus = me.convertFiles = me.uploadFile = me.getInternalPutUploadUrl = me.getUploadUrl = void 0;
  const o = hr, a = i(Bc), s = r(Al), u = qn(), c = je, _ = br, h = "Authorization", P = async (S, j) => {
    const { data: z } = await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/upload`, {
      params: S,
      headers: {
        [h]: `Bearer ${j}`
      }
    });
    return z;
  };
  me.getUploadUrl = P;
  const D = async (S, j) => {
    const { data: z } = await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/internal/upload`, {
      params: S,
      headers: {
        [h]: `Bearer ${j}`
      }
    });
    return z;
  };
  me.getInternalPutUploadUrl = D;
  const W = async (S, { fileId: j, fileName: z, contentType: Y, url: K, meta: de, onUploadStart: q, onProgress: Z }) => {
    const re = a.default.CancelToken.source();
    (0, c.setStatus)(j, re.cancel), q && q(j);
    const { data: g } = await a.default.put(K, S, {
      cancelToken: re.token,
      onUploadProgress: (p) => Z && Z(j, { sent: p.loaded, total: p.total }),
      headers: Object.assign(Object.assign({}, (0, u.metaToHeaders)(de)), { "x-amz-meta-filename": encodeURI((0, _.filenamify)(z) || ""), "x-amz-meta-content-type": Y, "content-type": Y })
    }).catch((p) => {
      if (a.default.isCancel(p))
        return { data: "cancelled" };
      throw (0, c.unsetStatus)(j), p;
    });
    return (0, c.unsetStatus)(j), g;
  };
  me.uploadFile = W;
  const I = async (S, j) => {
    const { data: z } = await a.default.post(`${(0, c.getConfig)().fileServiceUrl}/convert`, S, j && {
      headers: {
        [h]: `Bearer ${j}`
      }
    });
    return z;
  };
  me.convertFiles = I;
  const R = async (S, j) => {
    const { data: z } = await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/convert/status`, {
      params: { convertId: S, percent: j }
    });
    return z;
  };
  me.getConvertStatus = R;
  const U = async (S, j) => {
    const { data: z } = await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/download`, {
      params: { fileId: S },
      headers: {
        [h]: `Bearer ${j}`
      }
    });
    return z.url;
  };
  me.getDownloadUrl = U;
  const H = async (S, j) => {
    const z = (await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/stat`, {
      params: { fileId: S },
      headers: {
        [h]: `Bearer ${j}`
      }
    })).data, { size: Y } = z, K = z.meta, { filename: de, "content-type": q } = K, Z = n(K, ["filename", "content-type"]);
    return {
      size: Y,
      fileName: decodeURI(de) || S.split("/").pop(),
      contentType: q,
      meta: Z
    };
  };
  me.getFileInfo = H;
  const m = (0, o.getConfigCreator)("vod"), y = (S, j, z) => {
    let Y;
    const K = new Promise((de, q) => {
      const { baseUrl: Z, channelId: re } = m();
      Y = new s.Upload(S, Object.assign({ endpoint: `https://${Z}/vod/2.0/channels/${re}/files`, retryDelays: [0, 3e3, 5e3, 1e4, 2e4], headers: { Authorization: `Bearer ${z}` }, onError: q, onSuccess: () => de(Y) }, j)), Y.start();
    });
    return K.upload = Y, K;
  };
  me.uploadVideo = y;
  const f = async (S, j) => {
    const { data: z } = await a.default.post(`${(0, c.getConfig)().fileServiceUrl}/vod`, S, {
      headers: {
        [h]: `Bearer ${j}`
      }
    });
    return z;
  };
  me.saveVideo = f;
  const T = async (S, j, z) => {
    const { data: Y } = await a.default.get(`${(0, c.getConfig)().fileServiceUrl}/vod/${S}/${j}`, {
      headers: {
        [h]: `Bearer ${z}`
      }
    });
    return Y;
  };
  return me.getVideo = T, me;
}
var to;
function qn() {
  if (to)
    return ze;
  to = 1, Object.defineProperty(ze, "__esModule", { value: !0 }), ze.handleConversionProgress = ze.inferTypeFromMimeType = ze.metaToHeaders = void 0;
  const e = $n(), t = (i) => Object.keys(i).reduce((o, a) => Object.assign(Object.assign({}, o), { [`x-amz-meta-${a.toLowerCase()}`]: i[a] }), {});
  ze.metaToHeaders = t;
  const r = (i) => typeof i != "string" ? "file" : i === "image/jpeg" || i === "image/png" ? "image" : i.startsWith("audio/") ? "voice" : "file";
  ze.inferTypeFromMimeType = r;
  const n = async (i, o) => {
    const { convertId: a } = i;
    let { status: s } = i;
    for (o == null || o(s); s.phase !== "done"; )
      if (s = await (0, e.getConvertStatus)(a, s.percent), o == null || o(s), s.error)
        throw s.error;
    return s;
  };
  return ze.handleConversionProgress = n, ze;
}
var xr = {}, Mn = { exports: {} }, mn = { exports: {} };
typeof Object.create == "function" ? mn.exports = function(t, r) {
  r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : mn.exports = function(t, r) {
  if (r) {
    t.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, t.prototype = new n(), t.prototype.constructor = t;
  }
};
var Kl = mn.exports, Bn = { exports: {} }, xt = typeof Reflect == "object" ? Reflect : null, ro = xt && typeof xt.apply == "function" ? xt.apply : function(t, r, n) {
  return Function.prototype.apply.call(t, r, n);
}, sr;
xt && typeof xt.ownKeys == "function" ? sr = xt.ownKeys : Object.getOwnPropertySymbols ? sr = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : sr = function(t) {
  return Object.getOwnPropertyNames(t);
};
function Gl(e) {
  console && console.warn && console.warn(e);
}
var _a = Number.isNaN || function(t) {
  return t !== t;
};
function fe() {
  fe.init.call(this);
}
Bn.exports = fe;
Bn.exports.once = Ql;
fe.EventEmitter = fe;
fe.prototype._events = void 0;
fe.prototype._eventsCount = 0;
fe.prototype._maxListeners = void 0;
var no = 10;
function wr(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(fe, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return no;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || _a(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    no = e;
  }
});
fe.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
fe.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || _a(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function Ea(e) {
  return e._maxListeners === void 0 ? fe.defaultMaxListeners : e._maxListeners;
}
fe.prototype.getMaxListeners = function() {
  return Ea(this);
};
fe.prototype.emit = function(t) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r.push(arguments[n]);
  var i = t === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (r.length > 0 && (a = r[0]), a instanceof Error)
      throw a;
    var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw s.context = a, s;
  }
  var u = o[t];
  if (u === void 0)
    return !1;
  if (typeof u == "function")
    ro(u, this, r);
  else
    for (var c = u.length, _ = Pa(u, c), n = 0; n < c; ++n)
      ro(_[n], this, r);
  return !0;
};
function Oa(e, t, r, n) {
  var i, o, a;
  if (wr(r), o = e._events, o === void 0 ? (o = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), o = e._events), a = o[t]), a === void 0)
    a = o[t] = r, ++e._eventsCount;
  else if (typeof a == "function" ? a = o[t] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), i = Ea(e), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, Gl(s);
  }
  return e;
}
fe.prototype.addListener = function(t, r) {
  return Oa(this, t, r, !1);
};
fe.prototype.on = fe.prototype.addListener;
fe.prototype.prependListener = function(t, r) {
  return Oa(this, t, r, !0);
};
function Xl() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Sa(e, t, r) {
  var n = { fired: !1, wrapFn: void 0, target: e, type: t, listener: r }, i = Xl.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
fe.prototype.once = function(t, r) {
  return wr(r), this.on(t, Sa(this, t, r)), this;
};
fe.prototype.prependOnceListener = function(t, r) {
  return wr(r), this.prependListener(t, Sa(this, t, r)), this;
};
fe.prototype.removeListener = function(t, r) {
  var n, i, o, a, s;
  if (wr(r), i = this._events, i === void 0)
    return this;
  if (n = i[t], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, n.listener || r));
  else if (typeof n != "function") {
    for (o = -1, a = n.length - 1; a >= 0; a--)
      if (n[a] === r || n[a].listener === r) {
        s = n[a].listener, o = a;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? n.shift() : Jl(n, o), n.length === 1 && (i[t] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || r);
  }
  return this;
};
fe.prototype.off = fe.prototype.removeListener;
fe.prototype.removeAllListeners = function(t) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[t]), this;
  if (arguments.length === 0) {
    var o = Object.keys(n), a;
    for (i = 0; i < o.length; ++i)
      a = o[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[t], typeof r == "function")
    this.removeListener(t, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(t, r[i]);
  return this;
};
function Ra(e, t, r) {
  var n = e._events;
  if (n === void 0)
    return [];
  var i = n[t];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? Zl(i) : Pa(i, i.length);
}
fe.prototype.listeners = function(t) {
  return Ra(this, t, !0);
};
fe.prototype.rawListeners = function(t) {
  return Ra(this, t, !1);
};
fe.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : Ta.call(e, t);
};
fe.prototype.listenerCount = Ta;
function Ta(e) {
  var t = this._events;
  if (t !== void 0) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
fe.prototype.eventNames = function() {
  return this._eventsCount > 0 ? sr(this._events) : [];
};
function Pa(e, t) {
  for (var r = new Array(t), n = 0; n < t; ++n)
    r[n] = e[n];
  return r;
}
function Jl(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function Zl(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
function Ql(e, t) {
  return new Promise(function(r, n) {
    function i(a) {
      e.removeListener(t, o), n(a);
    }
    function o() {
      typeof e.removeListener == "function" && e.removeListener("error", i), r([].slice.call(arguments));
    }
    ja(e, t, o, { once: !0 }), t !== "error" && ep(e, i, { once: !0 });
  });
}
function ep(e, t, r) {
  typeof e.on == "function" && ja(e, "error", t, r);
}
function ja(e, t, r, n) {
  if (typeof e.on == "function")
    n.once ? e.once(t, r) : e.on(t, r);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function i(o) {
      n.once && e.removeEventListener(t, i), r(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var tp = Bn.exports, rp = Kl, ka = tp.EventEmitter;
Mn.exports = ke;
Mn.exports.default = ke;
function ke(e) {
  if (!(this instanceof ke))
    return new ke(e);
  ka.call(this), e = e || {}, this.concurrency = e.concurrency || 1 / 0, this.timeout = e.timeout || 0, this.autostart = e.autostart || !1, this.results = e.results || null, this.pending = 0, this.session = 0, this.running = !1, this.jobs = [], this.timers = {};
}
rp(ke, ka);
var np = [
  "pop",
  "shift",
  "indexOf",
  "lastIndexOf"
];
np.forEach(function(e) {
  ke.prototype[e] = function() {
    return Array.prototype[e].apply(this.jobs, arguments);
  };
});
ke.prototype.slice = function(e, t) {
  return this.jobs = this.jobs.slice(e, t), this;
};
ke.prototype.reverse = function() {
  return this.jobs.reverse(), this;
};
var ip = [
  "push",
  "unshift",
  "splice"
];
ip.forEach(function(e) {
  ke.prototype[e] = function() {
    var t = Array.prototype[e].apply(this.jobs, arguments);
    return this.autostart && this.start(), t;
  };
});
Object.defineProperty(ke.prototype, "length", {
  get: function() {
    return this.pending + this.jobs.length;
  }
});
ke.prototype.start = function(e) {
  if (e && ap.call(this, e), this.running = !0, this.pending >= this.concurrency)
    return;
  if (this.jobs.length === 0) {
    this.pending === 0 && vn.call(this);
    return;
  }
  var t = this, r = this.jobs.shift(), n = !0, i = this.session, o = null, a = !1, s = null, u = r.hasOwnProperty("timeout") ? r.timeout : this.timeout;
  function c(h, P) {
    n && t.session === i && (n = !1, t.pending--, o !== null && (delete t.timers[o], clearTimeout(o)), h ? t.emit("error", h, r) : a === !1 && (s !== null && (t.results[s] = Array.prototype.slice.call(arguments, 1)), t.emit("success", P, r)), t.session === i && (t.pending === 0 && t.jobs.length === 0 ? vn.call(t) : t.running && t.start()));
  }
  u && (o = setTimeout(function() {
    a = !0, t.listeners("timeout").length > 0 ? t.emit("timeout", c, r) : c();
  }, u), this.timers[o] = o), this.results && (s = this.results.length, this.results[s] = null), this.pending++, t.emit("start", r);
  var _ = r(c);
  _ && _.then && typeof _.then == "function" && _.then(function(h) {
    return c(null, h);
  }).catch(function(h) {
    return c(h || !0);
  }), this.running && this.jobs.length > 0 && this.start();
};
ke.prototype.stop = function() {
  this.running = !1;
};
ke.prototype.end = function(e) {
  op.call(this), this.jobs.length = 0, this.pending = 0, vn.call(this, e);
};
function op() {
  for (var e in this.timers) {
    var t = this.timers[e];
    delete this.timers[e], clearTimeout(t);
  }
}
function ap(e) {
  var t = this;
  this.on("error", r), this.on("end", n);
  function r(i) {
    t.end(i);
  }
  function n(i) {
    t.removeListener("error", r), t.removeListener("end", n), e(i, this.results);
  }
}
function vn(e) {
  this.session++, this.running = !1, this.emit("end", e);
}
var sp = Mn.exports, cp = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(xr, "__esModule", { value: !0 });
xr.waitToUpload = void 0;
const up = cp(sp), lp = $n(), yn = je, pp = () => new up.default({ concurrency: 1, autostart: !0 }), Fr = {}, fp = (e, t, r, n) => async () => {
  try {
    const { fileId: i } = t;
    if ((0, yn.getStatus)(i) === "cancelled") {
      r("cancelled"), (0, yn.unsetStatus)(i);
      return;
    }
    const o = await (0, lp.uploadFile)(e, t);
    r(o);
  } catch (i) {
    n(i);
  }
}, dp = (e, t, r, n = "default") => new Promise((i, o) => {
  (0, yn.setStatus)(t.fileId, "waiting"), r && r(t.fileId);
  const a = fp(e, t, i, o);
  n ? (Fr[n] || (Fr[n] = pp()), Fr[n].push(a)) : a();
});
xr.waitToUpload = dp;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.vod = e.getInfo = e.getPreSignedDownloadUrl = e.getDirectLink = e.cancelUpload = e.convertAll = e.convert = e.getInternalUploadUrl = e.upload = void 0;
  const t = dr, r = qn(), n = xr, i = $n(), o = je, a = "NO_USER_TOKEN", s = "NO_APIKEY", u = "BAD_FILE_ID", c = "MISSING_INPUT", _ = async (f, { name: T, type: S = "file", temp: j = !1, meta: z = {}, accessToken: Y, compression: K, onUploadSubmit: de, onUploadStart: q, onProgress: Z, queue: re } = {}) => {
    const g = Y || (0, o.getConfig)().authToken;
    if (!g)
      throw new Error(a);
    const p = T || f.name || "uploaded_file", v = S === "infer" ? (0, r.inferTypeFromMimeType)(f.type) : S, [{ url: C, fileId: d, convertToken: b }, $] = await Promise.all([
      (0, i.getUploadUrl)({ fileName: p, type: v, temp: j.toString() }, g),
      v === "image" && K ? (0, t.compressImage)(f, K) : f
    ]);
    return await (0, n.waitToUpload)($, {
      fileId: d,
      fileName: p,
      contentType: f.type || "",
      url: C,
      meta: z,
      onUploadStart: q,
      onProgress: Z
    }, de, re) === "cancelled" ? null : {
      fileId: d,
      convertToken: b
    };
  };
  e.upload = _;
  const h = async (f, T, S) => {
    const j = S || (0, o.getConfig)().authToken;
    if (!j)
      throw new Error(s);
    return (0, i.getInternalPutUploadUrl)({ fileName: f, bucketName: T }, j);
  };
  e.getInternalUploadUrl = h;
  const P = async (f, T, S = {}, j) => (0, e.convertAll)(Object.assign(Object.assign({}, T), { inputs: [{ token: f }] }), S, j);
  e.convert = P;
  const D = async (f, { onProgress: T } = {}, S) => {
    const j = S || (0, o.getConfig)().authToken, z = await (0, i.convertFiles)(f, j);
    return (0, r.handleConversionProgress)(z, T);
  };
  e.convertAll = D;
  const W = (f) => {
    const T = (0, o.getStatus)(f);
    return !T || T === "cancelled" ? !1 : T === "waiting" ? ((0, o.setStatus)(f, "cancelled"), !0) : (T(), !0);
  };
  e.cancelUpload = W;
  const I = (f) => `${(0, o.getConfig)().s3Url}/${f}`;
  e.getDirectLink = I;
  const R = async (f, T) => {
    if (!f)
      throw new Error(u);
    const S = T || (0, o.getConfig)().authToken;
    if (!S)
      throw new Error(a);
    return (0, i.getDownloadUrl)(f, S);
  };
  e.getPreSignedDownloadUrl = R;
  const U = async (f, T) => {
    if (!f)
      throw new Error(u);
    const S = T || (0, o.getConfig)().authToken;
    if (!S)
      throw new Error(a);
    const j = await (0, i.getFileInfo)(f, S);
    return Object.assign(Object.assign({}, j), { directLink: (0, e.getDirectLink)(f) });
  };
  e.getInfo = U;
  const H = (f, T, S) => {
    if (!f)
      throw new Error(c);
    const j = S || (0, o.getConfig)().authToken;
    if (!j)
      throw new Error(a);
    return (0, i.uploadVideo)(f, T, j);
  }, m = async (f, T) => {
    if (!f.channelId || !f.url)
      throw new Error(c);
    const S = T || (0, o.getConfig)().authToken;
    if (!S)
      throw new Error(a);
    return (0, i.saveVideo)(f, S);
  }, y = async (f, T, S) => {
    if (!f || !T)
      throw new Error(c);
    const j = S || (0, o.getConfig)().authToken;
    if (!j)
      throw new Error(a);
    return (0, i.getVideo)(f, T, j);
  };
  e.vod = {
    uploadVideo: H,
    saveVideo: m,
    getVideo: y
  };
})(Co);
var Ca = {};
Object.defineProperty(Ca, "__esModule", { value: !0 });
(function(e) {
  var t = ie && ie.__createBinding || (Object.create ? function(o, a, s, u) {
    u === void 0 && (u = s);
    var c = Object.getOwnPropertyDescriptor(a, s);
    (!c || ("get" in c ? !a.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return a[s];
    } }), Object.defineProperty(o, u, c);
  } : function(o, a, s, u) {
    u === void 0 && (u = s), o[u] = a[s];
  }), r = ie && ie.__exportStar || function(o, a) {
    for (var s in o)
      s !== "default" && !Object.prototype.hasOwnProperty.call(a, s) && t(a, o, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.handleConversionProgress = e.setConfig = e.getConfig = void 0, r(Co, e), r(Ca, e);
  var n = je;
  Object.defineProperty(e, "getConfig", { enumerable: !0, get: function() {
    return n.getConfig;
  } }), Object.defineProperty(e, "setConfig", { enumerable: !0, get: function() {
    return n.setConfig;
  } });
  var i = qn();
  Object.defineProperty(e, "handleConversionProgress", { enumerable: !0, get: function() {
    return i.handleConversionProgress;
  } });
})(Fe);
var Ro, To;
Fe.setConfig({
  fileServiceUrl: (Ro = window.config) == null ? void 0 : Ro.frontend.FILE_HOST,
  s3Url: (To = window.config) == null ? void 0 : To.frontend.S3_HOST
});
var hp = function(e, t, r, n, i, o, a, s) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    var u;
    if (t === void 0)
      u = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var c = [r, n, i, o, a, s], _ = 0;
      u = new Error(
        t.replace(/%s/g, function() {
          return c[_++];
        })
      ), u.name = "Invariant Violation";
    }
    throw u.framesToPop = 1, u;
  }
}, mp = hp;
const vp = /* @__PURE__ */ fr(mp), io = function(e) {
  return typeof e == "function";
}, Hr = function(e) {
  return e;
}, oo = function(e) {
  return e === null;
};
function He(e, t, r) {
  t === void 0 && (t = Hr), vp(io(t) || oo(t), "Expected payloadCreator to be a function, undefined or null");
  var n = oo(t) || t === Hr ? Hr : function(s) {
    for (var u = arguments.length, c = new Array(u > 1 ? u - 1 : 0), _ = 1; _ < u; _++)
      c[_ - 1] = arguments[_];
    return s instanceof Error ? s : t.apply(void 0, [s].concat(c));
  }, i = io(r), o = e.toString(), a = function() {
    var u = n.apply(void 0, arguments), c = {
      type: e
    };
    return u instanceof Error && (c.error = !0), u !== void 0 && (c.payload = u), i && (c.meta = r.apply(void 0, arguments)), c;
  };
  return a.toString = function() {
    return o;
  }, a;
}
const Ua = "SET_TOKEN", Aa = "UPLOAD_UPDATE_PERCENT", La = "MAP_UPLOAD_TO_FILE_ID", Da = "REMOVE_UPLOAD", Na = "UPLOAD_UPDATE_CONVERSION_PERCENT";
function Pe(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var ao = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Wr = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, tt = {
  INIT: "@@redux/INIT" + Wr(),
  REPLACE: "@@redux/REPLACE" + Wr(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Wr();
  }
};
function Ia(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function yp(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (xp(e))
    return "date";
  if (bp(e))
    return "error";
  var r = gp(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function gp(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function bp(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function xp(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ze(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = yp(e)), t;
}
function $a(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Pe(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(1) : "Expected the enhancer to be a function. Instead, received: '" + Ze(r) + "'");
    return r($a)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Pe(2) : "Expected the root reducer to be a function. Instead, received: '" + Ze(e) + "'");
  var i = e, o = t, a = [], s = a, u = !1;
  function c() {
    s === a && (s = a.slice());
  }
  function _() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Pe(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function h(I) {
    if (typeof I != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(4) : "Expected the listener to be a function. Instead, received: '" + Ze(I) + "'");
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Pe(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var R = !0;
    return c(), s.push(I), function() {
      if (R) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? Pe(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        R = !1, c();
        var H = s.indexOf(I);
        s.splice(H, 1), a = null;
      }
    };
  }
  function P(I) {
    if (!Ia(I))
      throw new Error(process.env.NODE_ENV === "production" ? Pe(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ze(I) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof I.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Pe(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, o = i(o, I);
    } finally {
      u = !1;
    }
    for (var R = a = s, U = 0; U < R.length; U++) {
      var H = R[U];
      H();
    }
    return I;
  }
  function D(I) {
    if (typeof I != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ze(I));
    i = I, P({
      type: tt.REPLACE
    });
  }
  function W() {
    var I, R = h;
    return I = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(H) {
        if (typeof H != "object" || H === null)
          throw new Error(process.env.NODE_ENV === "production" ? Pe(11) : "Expected the observer to be an object. Instead, received: '" + Ze(H) + "'");
        function m() {
          H.next && H.next(_());
        }
        m();
        var y = R(m);
        return {
          unsubscribe: y
        };
      }
    }, I[ao] = function() {
      return this;
    }, I;
  }
  return P({
    type: tt.INIT
  }), n = {
    dispatch: P,
    subscribe: h,
    getState: _,
    replaceReducer: D
  }, n[ao] = W, n;
}
function so(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function wp(e, t, r, n) {
  var i = Object.keys(t), o = r && r.type === tt.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Ia(e))
    return "The " + o + ' has unexpected type of "' + Ze(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !n[s];
  });
  if (a.forEach(function(s) {
    n[s] = !0;
  }), !(r && r.type === tt.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + o + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function _p(e) {
  Object.keys(e).forEach(function(t) {
    var r = e[t], n = r(void 0, {
      type: tt.INIT
    });
    if (typeof n > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: tt.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Pe(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + tt.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function Ep(e) {
  for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
    var i = t[n];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && so('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (r[i] = e[i]);
  }
  var o = Object.keys(r), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    _p(r);
  } catch (u) {
    s = u;
  }
  return function(c, _) {
    if (c === void 0 && (c = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var h = wp(c, r, _, a);
      h && so(h);
    }
    for (var P = !1, D = {}, W = 0; W < o.length; W++) {
      var I = o[W], R = r[I], U = c[I], H = R(U, _);
      if (typeof H > "u") {
        var m = _ && _.type;
        throw new Error(process.env.NODE_ENV === "production" ? Pe(14) : "When called with an action of type " + (m ? '"' + String(m) + '"' : "(unknown type)") + ', the slice reducer for key "' + I + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      D[I] = H, P = P || H !== U;
    }
    return P = P || o.length !== Object.keys(c).length, P ? D : c;
  };
}
function Op() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
var gn = { exports: {} }, Vr, co;
function zn() {
  if (co)
    return Vr;
  co = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Vr = e, Vr;
}
var Yr, uo;
function Sp() {
  if (uo)
    return Yr;
  uo = 1;
  var e = zn();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Yr = function() {
    function n(a, s, u, c, _, h) {
      if (h !== e) {
        var P = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw P.name = "Invariant Violation", P;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Yr;
}
var bn = { exports: {} }, se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lo;
function Rp() {
  return lo || (lo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, _ = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, W = e ? Symbol.for("react.lazy") : 60116, I = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, U = e ? Symbol.for("react.responder") : 60118, H = e ? Symbol.for("react.scope") : 60119;
    function m(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === n || k === c || k === o || k === i || k === h || k === P || typeof k == "object" && k !== null && (k.$$typeof === W || k.$$typeof === D || k.$$typeof === a || k.$$typeof === s || k.$$typeof === _ || k.$$typeof === R || k.$$typeof === U || k.$$typeof === H || k.$$typeof === I);
    }
    function y(k) {
      if (typeof k == "object" && k !== null) {
        var G = k.$$typeof;
        switch (G) {
          case t:
            var ne = k.type;
            switch (ne) {
              case u:
              case c:
              case n:
              case o:
              case i:
              case h:
                return ne;
              default:
                var ue = ne && ne.$$typeof;
                switch (ue) {
                  case s:
                  case _:
                  case W:
                  case D:
                  case a:
                    return ue;
                  default:
                    return G;
                }
            }
          case r:
            return G;
        }
      }
    }
    var f = u, T = c, S = s, j = a, z = t, Y = _, K = n, de = W, q = D, Z = r, re = o, g = i, p = h, v = !1;
    function C(k) {
      return v || (v = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), d(k) || y(k) === u;
    }
    function d(k) {
      return y(k) === c;
    }
    function b(k) {
      return y(k) === s;
    }
    function $(k) {
      return y(k) === a;
    }
    function B(k) {
      return typeof k == "object" && k !== null && k.$$typeof === t;
    }
    function O(k) {
      return y(k) === _;
    }
    function x(k) {
      return y(k) === n;
    }
    function w(k) {
      return y(k) === W;
    }
    function E(k) {
      return y(k) === D;
    }
    function N(k) {
      return y(k) === r;
    }
    function M(k) {
      return y(k) === o;
    }
    function V(k) {
      return y(k) === i;
    }
    function A(k) {
      return y(k) === h;
    }
    se.AsyncMode = f, se.ConcurrentMode = T, se.ContextConsumer = S, se.ContextProvider = j, se.Element = z, se.ForwardRef = Y, se.Fragment = K, se.Lazy = de, se.Memo = q, se.Portal = Z, se.Profiler = re, se.StrictMode = g, se.Suspense = p, se.isAsyncMode = C, se.isConcurrentMode = d, se.isContextConsumer = b, se.isContextProvider = $, se.isElement = B, se.isForwardRef = O, se.isFragment = x, se.isLazy = w, se.isMemo = E, se.isPortal = N, se.isProfiler = M, se.isStrictMode = V, se.isSuspense = A, se.isValidElementType = m, se.typeOf = y;
  }()), se;
}
var ce = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var po;
function Tp() {
  if (po)
    return ce;
  po = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, _ = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, D = e ? Symbol.for("react.memo") : 60115, W = e ? Symbol.for("react.lazy") : 60116, I = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, U = e ? Symbol.for("react.responder") : 60118, H = e ? Symbol.for("react.scope") : 60119;
  function m(f) {
    if (typeof f == "object" && f !== null) {
      var T = f.$$typeof;
      switch (T) {
        case t:
          switch (f = f.type, f) {
            case u:
            case c:
            case n:
            case o:
            case i:
            case h:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case _:
                case W:
                case D:
                case a:
                  return f;
                default:
                  return T;
              }
          }
        case r:
          return T;
      }
    }
  }
  function y(f) {
    return m(f) === c;
  }
  return ce.AsyncMode = u, ce.ConcurrentMode = c, ce.ContextConsumer = s, ce.ContextProvider = a, ce.Element = t, ce.ForwardRef = _, ce.Fragment = n, ce.Lazy = W, ce.Memo = D, ce.Portal = r, ce.Profiler = o, ce.StrictMode = i, ce.Suspense = h, ce.isAsyncMode = function(f) {
    return y(f) || m(f) === u;
  }, ce.isConcurrentMode = y, ce.isContextConsumer = function(f) {
    return m(f) === s;
  }, ce.isContextProvider = function(f) {
    return m(f) === a;
  }, ce.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === t;
  }, ce.isForwardRef = function(f) {
    return m(f) === _;
  }, ce.isFragment = function(f) {
    return m(f) === n;
  }, ce.isLazy = function(f) {
    return m(f) === W;
  }, ce.isMemo = function(f) {
    return m(f) === D;
  }, ce.isPortal = function(f) {
    return m(f) === r;
  }, ce.isProfiler = function(f) {
    return m(f) === o;
  }, ce.isStrictMode = function(f) {
    return m(f) === i;
  }, ce.isSuspense = function(f) {
    return m(f) === h;
  }, ce.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === n || f === c || f === o || f === i || f === h || f === P || typeof f == "object" && f !== null && (f.$$typeof === W || f.$$typeof === D || f.$$typeof === a || f.$$typeof === s || f.$$typeof === _ || f.$$typeof === R || f.$$typeof === U || f.$$typeof === H || f.$$typeof === I);
  }, ce.typeOf = m, ce;
}
process.env.NODE_ENV === "production" ? bn.exports = Tp() : bn.exports = Rp();
var Fn = bn.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Kr, fo;
function Hn() {
  if (fo)
    return Kr;
  fo = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(a).map(function(_) {
        return a[_];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(_) {
        c[_] = _;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Kr = i() ? Object.assign : function(o, a) {
    for (var s, u = n(o), c, _ = 1; _ < arguments.length; _++) {
      s = Object(arguments[_]);
      for (var h in s)
        t.call(s, h) && (u[h] = s[h]);
      if (e) {
        c = e(s);
        for (var P = 0; P < c.length; P++)
          r.call(s, c[P]) && (u[c[P]] = s[c[P]]);
      }
    }
    return u;
  }, Kr;
}
var Gr, ho;
function qa() {
  return ho || (ho = 1, Gr = Function.call.bind(Object.prototype.hasOwnProperty)), Gr;
}
var Xr, mo;
function Pp() {
  if (mo)
    return Xr;
  mo = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = zn(), r = {}, n = qa();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var _ in o)
        if (n(o, _)) {
          var h;
          try {
            if (typeof o[_] != "function") {
              var P = Error(
                (u || "React class") + ": " + s + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw P.name = "Invariant Violation", P;
            }
            h = o[_](a, _, u, s, null, t);
          } catch (W) {
            h = W;
          }
          if (h && !(h instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + _ + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in r)) {
            r[h.message] = !0;
            var D = c ? c() : "";
            e(
              "Failed " + s + " type: " + h.message + (D ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Xr = i, Xr;
}
var Jr, vo;
function jp() {
  if (vo)
    return Jr;
  vo = 1;
  var e = Fn, t = Hn(), r = zn(), n = qa(), i = Pp(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Jr = function(s, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, _ = "@@iterator";
    function h(d) {
      var b = d && (c && d[c] || d[_]);
      if (typeof b == "function")
        return b;
    }
    var P = "<<anonymous>>", D = {
      array: U("array"),
      bigint: U("bigint"),
      bool: U("boolean"),
      func: U("function"),
      number: U("number"),
      object: U("object"),
      string: U("string"),
      symbol: U("symbol"),
      any: H(),
      arrayOf: m,
      element: y(),
      elementType: f(),
      instanceOf: T,
      node: Y(),
      objectOf: j,
      oneOf: S,
      oneOfType: z,
      shape: de,
      exact: q
    };
    function W(d, b) {
      return d === b ? d !== 0 || 1 / d === 1 / b : d !== d && b !== b;
    }
    function I(d, b) {
      this.message = d, this.data = b && typeof b == "object" ? b : {}, this.stack = "";
    }
    I.prototype = Error.prototype;
    function R(d) {
      if (process.env.NODE_ENV !== "production")
        var b = {}, $ = 0;
      function B(x, w, E, N, M, V, A) {
        if (N = N || P, V = V || E, A !== r) {
          if (u) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var G = N + ":" + E;
            !b[G] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), b[G] = !0, $++);
          }
        }
        return w[E] == null ? x ? w[E] === null ? new I("The " + M + " `" + V + "` is marked as required " + ("in `" + N + "`, but its value is `null`.")) : new I("The " + M + " `" + V + "` is marked as required in " + ("`" + N + "`, but its value is `undefined`.")) : null : d(w, E, N, M, V);
      }
      var O = B.bind(null, !1);
      return O.isRequired = B.bind(null, !0), O;
    }
    function U(d) {
      function b($, B, O, x, w, E) {
        var N = $[B], M = g(N);
        if (M !== d) {
          var V = p(N);
          return new I(
            "Invalid " + x + " `" + w + "` of type " + ("`" + V + "` supplied to `" + O + "`, expected ") + ("`" + d + "`."),
            { expectedType: d }
          );
        }
        return null;
      }
      return R(b);
    }
    function H() {
      return R(a);
    }
    function m(d) {
      function b($, B, O, x, w) {
        if (typeof d != "function")
          return new I("Property `" + w + "` of component `" + O + "` has invalid PropType notation inside arrayOf.");
        var E = $[B];
        if (!Array.isArray(E)) {
          var N = g(E);
          return new I("Invalid " + x + " `" + w + "` of type " + ("`" + N + "` supplied to `" + O + "`, expected an array."));
        }
        for (var M = 0; M < E.length; M++) {
          var V = d(E, M, O, x, w + "[" + M + "]", r);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return R(b);
    }
    function y() {
      function d(b, $, B, O, x) {
        var w = b[$];
        if (!s(w)) {
          var E = g(w);
          return new I("Invalid " + O + " `" + x + "` of type " + ("`" + E + "` supplied to `" + B + "`, expected a single ReactElement."));
        }
        return null;
      }
      return R(d);
    }
    function f() {
      function d(b, $, B, O, x) {
        var w = b[$];
        if (!e.isValidElementType(w)) {
          var E = g(w);
          return new I("Invalid " + O + " `" + x + "` of type " + ("`" + E + "` supplied to `" + B + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return R(d);
    }
    function T(d) {
      function b($, B, O, x, w) {
        if (!($[B] instanceof d)) {
          var E = d.name || P, N = C($[B]);
          return new I("Invalid " + x + " `" + w + "` of type " + ("`" + N + "` supplied to `" + O + "`, expected ") + ("instance of `" + E + "`."));
        }
        return null;
      }
      return R(b);
    }
    function S(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function b($, B, O, x, w) {
        for (var E = $[B], N = 0; N < d.length; N++)
          if (W(E, d[N]))
            return null;
        var M = JSON.stringify(d, function(A, k) {
          var G = p(k);
          return G === "symbol" ? String(k) : k;
        });
        return new I("Invalid " + x + " `" + w + "` of value `" + String(E) + "` " + ("supplied to `" + O + "`, expected one of " + M + "."));
      }
      return R(b);
    }
    function j(d) {
      function b($, B, O, x, w) {
        if (typeof d != "function")
          return new I("Property `" + w + "` of component `" + O + "` has invalid PropType notation inside objectOf.");
        var E = $[B], N = g(E);
        if (N !== "object")
          return new I("Invalid " + x + " `" + w + "` of type " + ("`" + N + "` supplied to `" + O + "`, expected an object."));
        for (var M in E)
          if (n(E, M)) {
            var V = d(E, M, O, x, w + "." + M, r);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return R(b);
    }
    function z(d) {
      if (!Array.isArray(d))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var b = 0; b < d.length; b++) {
        var $ = d[b];
        if (typeof $ != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + v($) + " at index " + b + "."
          ), a;
      }
      function B(O, x, w, E, N) {
        for (var M = [], V = 0; V < d.length; V++) {
          var A = d[V], k = A(O, x, w, E, N, r);
          if (k == null)
            return null;
          k.data && n(k.data, "expectedType") && M.push(k.data.expectedType);
        }
        var G = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new I("Invalid " + E + " `" + N + "` supplied to " + ("`" + w + "`" + G + "."));
      }
      return R(B);
    }
    function Y() {
      function d(b, $, B, O, x) {
        return Z(b[$]) ? null : new I("Invalid " + O + " `" + x + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
      }
      return R(d);
    }
    function K(d, b, $, B, O) {
      return new I(
        (d || "React class") + ": " + b + " type `" + $ + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + O + "`."
      );
    }
    function de(d) {
      function b($, B, O, x, w) {
        var E = $[B], N = g(E);
        if (N !== "object")
          return new I("Invalid " + x + " `" + w + "` of type `" + N + "` " + ("supplied to `" + O + "`, expected `object`."));
        for (var M in d) {
          var V = d[M];
          if (typeof V != "function")
            return K(O, x, w, M, p(V));
          var A = V(E, M, O, x, w + "." + M, r);
          if (A)
            return A;
        }
        return null;
      }
      return R(b);
    }
    function q(d) {
      function b($, B, O, x, w) {
        var E = $[B], N = g(E);
        if (N !== "object")
          return new I("Invalid " + x + " `" + w + "` of type `" + N + "` " + ("supplied to `" + O + "`, expected `object`."));
        var M = t({}, $[B], d);
        for (var V in M) {
          var A = d[V];
          if (n(d, V) && typeof A != "function")
            return K(O, x, w, V, p(A));
          if (!A)
            return new I(
              "Invalid " + x + " `" + w + "` key `" + V + "` supplied to `" + O + "`.\nBad object: " + JSON.stringify($[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(d), null, "  ")
            );
          var k = A(E, V, O, x, w + "." + V, r);
          if (k)
            return k;
        }
        return null;
      }
      return R(b);
    }
    function Z(d) {
      switch (typeof d) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !d;
        case "object":
          if (Array.isArray(d))
            return d.every(Z);
          if (d === null || s(d))
            return !0;
          var b = h(d);
          if (b) {
            var $ = b.call(d), B;
            if (b !== d.entries) {
              for (; !(B = $.next()).done; )
                if (!Z(B.value))
                  return !1;
            } else
              for (; !(B = $.next()).done; ) {
                var O = B.value;
                if (O && !Z(O[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(d, b) {
      return d === "symbol" ? !0 : b ? b["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && b instanceof Symbol : !1;
    }
    function g(d) {
      var b = typeof d;
      return Array.isArray(d) ? "array" : d instanceof RegExp ? "object" : re(b, d) ? "symbol" : b;
    }
    function p(d) {
      if (typeof d > "u" || d === null)
        return "" + d;
      var b = g(d);
      if (b === "object") {
        if (d instanceof Date)
          return "date";
        if (d instanceof RegExp)
          return "regexp";
      }
      return b;
    }
    function v(d) {
      var b = p(d);
      switch (b) {
        case "array":
        case "object":
          return "an " + b;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + b;
        default:
          return b;
      }
    }
    function C(d) {
      return !d.constructor || !d.constructor.name ? P : d.constructor.name;
    }
    return D.checkPropTypes = i, D.resetWarningCache = i.resetWarningCache, D.PropTypes = D, D;
  }, Jr;
}
if (process.env.NODE_ENV !== "production") {
  var kp = Fn, Cp = !0;
  gn.exports = jp()(kp.isElement, Cp);
} else
  gn.exports = Sp()();
var Up = gn.exports;
const ht = /* @__PURE__ */ fr(Up);
var Bt = /* @__PURE__ */ pr.createContext(null);
process.env.NODE_ENV !== "production" && (Bt.displayName = "ReactRedux");
function Ap(e) {
  e();
}
var Ma = Ap, Lp = function(t) {
  return Ma = t;
}, Dp = function() {
  return Ma;
};
function Np() {
  var e = Dp(), t = null, r = null;
  return {
    clear: function() {
      t = null, r = null;
    },
    notify: function() {
      e(function() {
        for (var i = t; i; )
          i.callback(), i = i.next;
      });
    },
    get: function() {
      for (var i = [], o = t; o; )
        i.push(o), o = o.next;
      return i;
    },
    subscribe: function(i) {
      var o = !0, a = r = {
        callback: i,
        next: null,
        prev: r
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !o || t === null || (o = !1, a.next ? a.next.prev = a.prev : r = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
var yo = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function Ba(e, t) {
  var r, n = yo;
  function i(h) {
    return u(), n.subscribe(h);
  }
  function o() {
    n.notify();
  }
  function a() {
    _.onStateChange && _.onStateChange();
  }
  function s() {
    return !!r;
  }
  function u() {
    r || (r = t ? t.addNestedSub(a) : e.subscribe(a), n = Np());
  }
  function c() {
    r && (r(), r = void 0, n.clear(), n = yo);
  }
  var _ = {
    addNestedSub: i,
    notifyNestedSubs: o,
    handleChangeWrapper: a,
    isSubscribed: s,
    trySubscribe: u,
    tryUnsubscribe: c,
    getListeners: function() {
      return n;
    }
  };
  return _;
}
var xn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? hs : Po;
function za(e) {
  var t = e.store, r = e.context, n = e.children, i = tn(function() {
    var s = Ba(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), o = tn(function() {
    return t.getState();
  }, [t]);
  xn(function() {
    var s = i.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), o !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [i, o]);
  var a = r || Bt;
  return /* @__PURE__ */ pr.createElement(a.Provider, {
    value: i
  }, n);
}
process.env.NODE_ENV !== "production" && (za.propTypes = {
  store: ht.shape({
    subscribe: ht.func.isRequired,
    dispatch: ht.func.isRequired,
    getState: ht.func.isRequired
  }),
  context: ht.object,
  children: ht.any
});
var Fa = Fn, Ip = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, $p = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ha = {};
Ha[Fa.ForwardRef] = Ip;
Ha[Fa.Memo] = $p;
var le = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var go;
function qp() {
  return go || (go = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, a = 60110, s = 60112, u = 60113, c = 60120, _ = 60115, h = 60116, P = 60121, D = 60122, W = 60117, I = 60129, R = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var U = Symbol.for;
      e = U("react.element"), t = U("react.portal"), r = U("react.fragment"), n = U("react.strict_mode"), i = U("react.profiler"), o = U("react.provider"), a = U("react.context"), s = U("react.forward_ref"), u = U("react.suspense"), c = U("react.suspense_list"), _ = U("react.memo"), h = U("react.lazy"), P = U("react.block"), D = U("react.server.block"), W = U("react.fundamental"), U("react.scope"), U("react.opaque.id"), I = U("react.debug_trace_mode"), U("react.offscreen"), R = U("react.legacy_hidden");
    }
    var H = !1;
    function m(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === r || A === i || A === I || A === n || A === u || A === c || A === R || H || typeof A == "object" && A !== null && (A.$$typeof === h || A.$$typeof === _ || A.$$typeof === o || A.$$typeof === a || A.$$typeof === s || A.$$typeof === W || A.$$typeof === P || A[0] === D));
    }
    function y(A) {
      if (typeof A == "object" && A !== null) {
        var k = A.$$typeof;
        switch (k) {
          case e:
            var G = A.type;
            switch (G) {
              case r:
              case i:
              case n:
              case u:
              case c:
                return G;
              default:
                var ne = G && G.$$typeof;
                switch (ne) {
                  case a:
                  case s:
                  case h:
                  case _:
                  case o:
                    return ne;
                  default:
                    return k;
                }
            }
          case t:
            return k;
        }
      }
    }
    var f = a, T = o, S = e, j = s, z = r, Y = h, K = _, de = t, q = i, Z = n, re = u, g = !1, p = !1;
    function v(A) {
      return g || (g = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function C(A) {
      return p || (p = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function d(A) {
      return y(A) === a;
    }
    function b(A) {
      return y(A) === o;
    }
    function $(A) {
      return typeof A == "object" && A !== null && A.$$typeof === e;
    }
    function B(A) {
      return y(A) === s;
    }
    function O(A) {
      return y(A) === r;
    }
    function x(A) {
      return y(A) === h;
    }
    function w(A) {
      return y(A) === _;
    }
    function E(A) {
      return y(A) === t;
    }
    function N(A) {
      return y(A) === i;
    }
    function M(A) {
      return y(A) === n;
    }
    function V(A) {
      return y(A) === u;
    }
    le.ContextConsumer = f, le.ContextProvider = T, le.Element = S, le.ForwardRef = j, le.Fragment = z, le.Lazy = Y, le.Memo = K, le.Portal = de, le.Profiler = q, le.StrictMode = Z, le.Suspense = re, le.isAsyncMode = v, le.isConcurrentMode = C, le.isContextConsumer = d, le.isContextProvider = b, le.isElement = $, le.isForwardRef = B, le.isFragment = O, le.isLazy = x, le.isMemo = w, le.isPortal = E, le.isProfiler = N, le.isStrictMode = M, le.isSuspense = V, le.isValidElementType = m, le.typeOf = y;
  }()), le;
}
var pe = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bo;
function Mp() {
  if (bo)
    return pe;
  bo = 1;
  var e = 60103, t = 60106, r = 60107, n = 60108, i = 60114, o = 60109, a = 60110, s = 60112, u = 60113, c = 60120, _ = 60115, h = 60116, P = 60121, D = 60122, W = 60117, I = 60129, R = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var U = Symbol.for;
    e = U("react.element"), t = U("react.portal"), r = U("react.fragment"), n = U("react.strict_mode"), i = U("react.profiler"), o = U("react.provider"), a = U("react.context"), s = U("react.forward_ref"), u = U("react.suspense"), c = U("react.suspense_list"), _ = U("react.memo"), h = U("react.lazy"), P = U("react.block"), D = U("react.server.block"), W = U("react.fundamental"), I = U("react.debug_trace_mode"), R = U("react.legacy_hidden");
  }
  function H(q) {
    if (typeof q == "object" && q !== null) {
      var Z = q.$$typeof;
      switch (Z) {
        case e:
          switch (q = q.type, q) {
            case r:
            case i:
            case n:
            case u:
            case c:
              return q;
            default:
              switch (q = q && q.$$typeof, q) {
                case a:
                case s:
                case h:
                case _:
                case o:
                  return q;
                default:
                  return Z;
              }
          }
        case t:
          return Z;
      }
    }
  }
  var m = o, y = e, f = s, T = r, S = h, j = _, z = t, Y = i, K = n, de = u;
  return pe.ContextConsumer = a, pe.ContextProvider = m, pe.Element = y, pe.ForwardRef = f, pe.Fragment = T, pe.Lazy = S, pe.Memo = j, pe.Portal = z, pe.Profiler = Y, pe.StrictMode = K, pe.Suspense = de, pe.isAsyncMode = function() {
    return !1;
  }, pe.isConcurrentMode = function() {
    return !1;
  }, pe.isContextConsumer = function(q) {
    return H(q) === a;
  }, pe.isContextProvider = function(q) {
    return H(q) === o;
  }, pe.isElement = function(q) {
    return typeof q == "object" && q !== null && q.$$typeof === e;
  }, pe.isForwardRef = function(q) {
    return H(q) === s;
  }, pe.isFragment = function(q) {
    return H(q) === r;
  }, pe.isLazy = function(q) {
    return H(q) === h;
  }, pe.isMemo = function(q) {
    return H(q) === _;
  }, pe.isPortal = function(q) {
    return H(q) === t;
  }, pe.isProfiler = function(q) {
    return H(q) === i;
  }, pe.isStrictMode = function(q) {
    return H(q) === n;
  }, pe.isSuspense = function(q) {
    return H(q) === u;
  }, pe.isValidElementType = function(q) {
    return typeof q == "string" || typeof q == "function" || q === r || q === i || q === I || q === n || q === u || q === c || q === R || typeof q == "object" && q !== null && (q.$$typeof === h || q.$$typeof === _ || q.$$typeof === o || q.$$typeof === a || q.$$typeof === s || q.$$typeof === W || q.$$typeof === P || q[0] === D);
  }, pe.typeOf = H, pe;
}
process.env.NODE_ENV === "production" ? Mp() : qp();
function Bp() {
  var e = jo(Bt);
  if (process.env.NODE_ENV !== "production" && !e)
    throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
  return e;
}
var zp = function(t, r) {
  return t === r;
};
function Fp(e, t, r, n) {
  var i = vs(function(W) {
    return W + 1;
  }, 0), o = i[1], a = tn(function() {
    return Ba(r, n);
  }, [r, n]), s = tr(), u = tr(), c = tr(), _ = tr(), h = r.getState(), P;
  try {
    if (e !== u.current || h !== c.current || s.current) {
      var D = e(h);
      _.current === void 0 || !t(D, _.current) ? P = D : P = _.current;
    } else
      P = _.current;
  } catch (W) {
    throw s.current && (W.message += `
The error may be correlated with this previous error:
` + s.current.stack + `

`), W;
  }
  return xn(function() {
    u.current = e, c.current = h, _.current = P, s.current = void 0;
  }), xn(function() {
    function W() {
      try {
        var I = r.getState();
        if (I === c.current)
          return;
        var R = u.current(I);
        if (t(R, _.current))
          return;
        _.current = R, c.current = I;
      } catch (U) {
        s.current = U;
      }
      o();
    }
    return a.onStateChange = W, a.trySubscribe(), W(), function() {
      return a.tryUnsubscribe();
    };
  }, [r, a]), P;
}
function Hp(e) {
  e === void 0 && (e = Bt);
  var t = e === Bt ? Bp : function() {
    return jo(e);
  };
  return function(n, i) {
    if (i === void 0 && (i = zp), process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    var o = t(), a = o.store, s = o.subscription, u = Fp(n, i, a, s);
    return ms(u), u;
  };
}
Lp(gs);
function ve(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
function Ge(e) {
  return function t(r) {
    return arguments.length === 0 || ve(r) ? t : e.apply(this, arguments);
  };
}
function Ae(e) {
  return function t(r, n) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return ve(r) ? t : Ge(function(i) {
          return e(r, i);
        });
      default:
        return ve(r) && ve(n) ? t : ve(r) ? Ge(function(i) {
          return e(i, n);
        }) : ve(n) ? Ge(function(i) {
          return e(r, i);
        }) : e(r, n);
    }
  };
}
function Wn(e) {
  return function t(r, n, i) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return ve(r) ? t : Ae(function(o, a) {
          return e(r, o, a);
        });
      case 2:
        return ve(r) && ve(n) ? t : ve(r) ? Ae(function(o, a) {
          return e(o, n, a);
        }) : ve(n) ? Ae(function(o, a) {
          return e(r, o, a);
        }) : Ge(function(o) {
          return e(r, n, o);
        });
      default:
        return ve(r) && ve(n) && ve(i) ? t : ve(r) && ve(n) ? Ae(function(o, a) {
          return e(o, a, i);
        }) : ve(r) && ve(i) ? Ae(function(o, a) {
          return e(o, n, a);
        }) : ve(n) && ve(i) ? Ae(function(o, a) {
          return e(r, o, a);
        }) : ve(r) ? Ge(function(o) {
          return e(o, n, i);
        }) : ve(n) ? Ge(function(o) {
          return e(r, o, i);
        }) : ve(i) ? Ge(function(o) {
          return e(r, n, o);
        }) : e(r, n, i);
    }
  };
}
const Vn = Array.isArray || function(t) {
  return t != null && t.length >= 0 && Object.prototype.toString.call(t) === "[object Array]";
};
function Wp(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function Vp(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
const Rt = Number.isInteger || function(t) {
  return t << 0 === t;
};
var Wa = /* @__PURE__ */ Ae(function(t, r) {
  var n = t < 0 ? r.length + t : t;
  return Wp(r) ? r.charAt(n) : r[n];
}), Yp = /* @__PURE__ */ Ae(function(t, r) {
  if (r != null)
    return Rt(t) ? Wa(t, r) : r[t];
});
const Ft = Yp;
function Kp(e, t, r) {
  if (Rt(e) && Vn(r)) {
    var n = [].concat(r);
    return n[e] = t, n;
  }
  var i = {};
  for (var o in r)
    i[o] = r[o];
  return i[e] = t, i;
}
var Gp = /* @__PURE__ */ Ge(function(t) {
  return t == null;
}), Xp = /* @__PURE__ */ Wn(function e(t, r, n) {
  if (t.length === 0)
    return r;
  var i = t[0];
  if (t.length > 1) {
    var o = !Gp(n) && Vp(i, n) ? n[i] : Rt(t[1]) ? [] : {};
    r = e(Array.prototype.slice.call(t, 1), r, o);
  }
  return Kp(i, r, n);
});
const Yn = Xp;
var Jp = /* @__PURE__ */ Wn(function(t, r, n) {
  return Yn([t], r, n);
});
const _r = Jp;
var Zp = /* @__PURE__ */ Wn(function(t, r, n) {
  var i = Array.prototype.slice.call(n, 0);
  return i.splice(t, r), i;
});
function Qp(e, t) {
  if (t == null)
    return t;
  if (Rt(e) && Vn(t))
    return Zp(e, 1, t);
  var r = {};
  for (var n in t)
    r[n] = t[n];
  return delete r[e], r;
}
function ef(e, t) {
  if (Rt(e) && Vn(t))
    return [].concat(t);
  var r = {};
  for (var n in t)
    r[n] = t[n];
  return r;
}
var tf = /* @__PURE__ */ Ae(function e(t, r) {
  if (r == null)
    return r;
  switch (t.length) {
    case 0:
      return r;
    case 1:
      return Qp(t[0], r);
    default:
      var n = t[0], i = Array.prototype.slice.call(t, 1);
      return r[n] == null ? ef(n, r) : _r(n, e(i, r[n]), r);
  }
}), rf = /* @__PURE__ */ Ae(function(t, r) {
  return tf([t], r);
});
const Va = rf;
var nf = /* @__PURE__ */ Ae(function(t, r) {
  return t.map(function(n) {
    for (var i = r, o = 0, a; o < n.length; ) {
      if (i == null)
        return;
      a = n[o], i = Rt(a) ? Wa(a, i) : i[a], o += 1;
    }
    return i;
  });
}), of = /* @__PURE__ */ Ae(function(t, r) {
  return nf([t], r)[0];
});
const af = of, Ya = "INSERT_DOWNLOAD", Ka = "REMOVE_DOWNLOAD", Ga = "DOWNLOAD_UPDATE_PERCENT", sf = (e) => Ft("download", e), Xa = (e) => (t) => Ft(e, sf(t)), xo = {
  [Ya]: ({ fileId: e, ...t }) => _r(e, t),
  [Ka]: ({ fileId: e }) => Va(e),
  [Ga]: ({ fileId: e, percent: t }) => Yn([e, "percent"], t)
}, cf = (e = {}, { type: t, payload: r }) => xo[t] ? xo[t](r)(e) : e, uf = {
  token: "",
  uploads: {}
}, lf = Ft("upload"), pf = (e) => Ft("uploads", lf(e)), Ja = (e) => (t) => Ft(e, pf(t)), wo = {
  [Aa]: (e, { uploadId: t, percent: r, sent: n }) => ({
    ...e,
    [t]: { ...e[t], percent: r, sent: n }
  }),
  [Na]: (e, { uploadId: t, percent: r }) => Yn([t, "conversionPercent"], r, e),
  [La]: (e, { uploadId: t, fileId: r }) => _r(t, { fileId: r, percent: 0 }, e),
  [Da]: (e, t) => Va(t, e)
}, _o = {
  [Ua]: (e, { token: t }) => t
}, ff = (e = uf, { type: t, payload: r }) => ({
  token: _o[t] ? _o[t](e.token, r) : e.token,
  uploads: wo[t] ? wo[t](e.uploads, r) : e.uploads
}), Za = "ADD_BLOB_URL", df = (e) => af(["blobURLs", e], Gn()), Eo = {
  [Za]: (e, { fileId: t, blobURL: r }) => _r(t, r, e)
}, hf = (e = {}, { type: t, payload: r }) => Eo[t] ? Eo[t](e, r) : e, mf = Ep({
  download: cf,
  upload: ff,
  blobURLs: hf
}), vf = typeof window == "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "file"
}) : Op, Qa = $a(mf, vf()), es = ys(null), Kn = Hp(es), { getState: Gn, dispatch: We } = Qa, yf = He(Ua, (e) => ({ token: e })), gf = (...e) => We(yf(...e)), bf = (...e) => We(
  He(Aa, (t, r, n) => ({
    uploadId: t,
    percent: r,
    sent: n
  }))(...e)
), xf = (...e) => We(
  He(Na, (t, r) => ({
    uploadId: t,
    percent: r
  }))(...e)
), wf = He(
  La,
  (e, t) => ({
    uploadId: e,
    fileId: t
  })
), _f = (...e) => We(wf(...e)), ts = (...e) => We(He(Da)(...e));
let rs, ns;
const is = (e) => rs(e).then((t) => t == null ? void 0 : t.file), os = (e, t) => ns(e, t), Jf = ({
  get: e,
  insert: t
}) => {
  rs = e, ns = t;
}, as = {
  "application/prs.cww": ["cww"],
  "application/prs.xsf+xml": ["xsf"],
  "application/vnd.1000minds.decision-model+xml": ["1km"],
  "application/vnd.3gpp.pic-bw-large": ["plb"],
  "application/vnd.3gpp.pic-bw-small": ["psb"],
  "application/vnd.3gpp.pic-bw-var": ["pvb"],
  "application/vnd.3gpp2.tcap": ["tcap"],
  "application/vnd.3m.post-it-notes": ["pwn"],
  "application/vnd.accpac.simply.aso": ["aso"],
  "application/vnd.accpac.simply.imp": ["imp"],
  "application/vnd.acucobol": ["acu"],
  "application/vnd.acucorp": ["atc", "acutc"],
  "application/vnd.adobe.air-application-installer-package+zip": ["air"],
  "application/vnd.adobe.formscentral.fcdt": ["fcdt"],
  "application/vnd.adobe.fxp": ["fxp", "fxpl"],
  "application/vnd.adobe.xdp+xml": ["xdp"],
  "application/vnd.adobe.xfdf": ["*xfdf"],
  "application/vnd.age": ["age"],
  "application/vnd.ahead.space": ["ahead"],
  "application/vnd.airzip.filesecure.azf": ["azf"],
  "application/vnd.airzip.filesecure.azs": ["azs"],
  "application/vnd.amazon.ebook": ["azw"],
  "application/vnd.americandynamics.acc": ["acc"],
  "application/vnd.amiga.ami": ["ami"],
  "application/vnd.android.package-archive": ["apk"],
  "application/vnd.anser-web-certificate-issue-initiation": ["cii"],
  "application/vnd.anser-web-funds-transfer-initiation": ["fti"],
  "application/vnd.antix.game-component": ["atx"],
  "application/vnd.apple.installer+xml": ["mpkg"],
  "application/vnd.apple.keynote": ["key"],
  "application/vnd.apple.mpegurl": ["m3u8"],
  "application/vnd.apple.numbers": ["numbers"],
  "application/vnd.apple.pages": ["pages"],
  "application/vnd.apple.pkpass": ["pkpass"],
  "application/vnd.aristanetworks.swi": ["swi"],
  "application/vnd.astraea-software.iota": ["iota"],
  "application/vnd.audiograph": ["aep"],
  "application/vnd.balsamiq.bmml+xml": ["bmml"],
  "application/vnd.blueice.multipass": ["mpm"],
  "application/vnd.bmi": ["bmi"],
  "application/vnd.businessobjects": ["rep"],
  "application/vnd.chemdraw+xml": ["cdxml"],
  "application/vnd.chipnuts.karaoke-mmd": ["mmd"],
  "application/vnd.cinderella": ["cdy"],
  "application/vnd.citationstyles.style+xml": ["csl"],
  "application/vnd.claymore": ["cla"],
  "application/vnd.cloanto.rp9": ["rp9"],
  "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"],
  "application/vnd.cluetrust.cartomobile-config": ["c11amc"],
  "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"],
  "application/vnd.commonspace": ["csp"],
  "application/vnd.contact.cmsg": ["cdbcmsg"],
  "application/vnd.cosmocaller": ["cmc"],
  "application/vnd.crick.clicker": ["clkx"],
  "application/vnd.crick.clicker.keyboard": ["clkk"],
  "application/vnd.crick.clicker.palette": ["clkp"],
  "application/vnd.crick.clicker.template": ["clkt"],
  "application/vnd.crick.clicker.wordbank": ["clkw"],
  "application/vnd.criticaltools.wbs+xml": ["wbs"],
  "application/vnd.ctc-posml": ["pml"],
  "application/vnd.cups-ppd": ["ppd"],
  "application/vnd.curl.car": ["car"],
  "application/vnd.curl.pcurl": ["pcurl"],
  "application/vnd.dart": ["dart"],
  "application/vnd.data-vision.rdz": ["rdz"],
  "application/vnd.dbf": ["dbf"],
  "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"],
  "application/vnd.dece.ttml+xml": ["uvt", "uvvt"],
  "application/vnd.dece.unspecified": ["uvx", "uvvx"],
  "application/vnd.dece.zip": ["uvz", "uvvz"],
  "application/vnd.denovo.fcselayout-link": ["fe_launch"],
  "application/vnd.dna": ["dna"],
  "application/vnd.dolby.mlp": ["mlp"],
  "application/vnd.dpgraph": ["dpg"],
  "application/vnd.dreamfactory": ["dfac"],
  "application/vnd.ds-keypoint": ["kpxx"],
  "application/vnd.dvb.ait": ["ait"],
  "application/vnd.dvb.service": ["svc"],
  "application/vnd.dynageo": ["geo"],
  "application/vnd.ecowin.chart": ["mag"],
  "application/vnd.enliven": ["nml"],
  "application/vnd.epson.esf": ["esf"],
  "application/vnd.epson.msf": ["msf"],
  "application/vnd.epson.quickanime": ["qam"],
  "application/vnd.epson.salt": ["slt"],
  "application/vnd.epson.ssf": ["ssf"],
  "application/vnd.eszigno3+xml": ["es3", "et3"],
  "application/vnd.ezpix-album": ["ez2"],
  "application/vnd.ezpix-package": ["ez3"],
  "application/vnd.fdf": ["*fdf"],
  "application/vnd.fdsn.mseed": ["mseed"],
  "application/vnd.fdsn.seed": ["seed", "dataless"],
  "application/vnd.flographit": ["gph"],
  "application/vnd.fluxtime.clip": ["ftc"],
  "application/vnd.framemaker": ["fm", "frame", "maker", "book"],
  "application/vnd.frogans.fnc": ["fnc"],
  "application/vnd.frogans.ltf": ["ltf"],
  "application/vnd.fsc.weblaunch": ["fsc"],
  "application/vnd.fujitsu.oasys": ["oas"],
  "application/vnd.fujitsu.oasys2": ["oa2"],
  "application/vnd.fujitsu.oasys3": ["oa3"],
  "application/vnd.fujitsu.oasysgp": ["fg5"],
  "application/vnd.fujitsu.oasysprs": ["bh2"],
  "application/vnd.fujixerox.ddd": ["ddd"],
  "application/vnd.fujixerox.docuworks": ["xdw"],
  "application/vnd.fujixerox.docuworks.binder": ["xbd"],
  "application/vnd.fuzzysheet": ["fzs"],
  "application/vnd.genomatix.tuxedo": ["txd"],
  "application/vnd.geogebra.file": ["ggb"],
  "application/vnd.geogebra.slides": ["ggs"],
  "application/vnd.geogebra.tool": ["ggt"],
  "application/vnd.geometry-explorer": ["gex", "gre"],
  "application/vnd.geonext": ["gxt"],
  "application/vnd.geoplan": ["g2w"],
  "application/vnd.geospace": ["g3w"],
  "application/vnd.gmx": ["gmx"],
  "application/vnd.google-apps.document": ["gdoc"],
  "application/vnd.google-apps.presentation": ["gslides"],
  "application/vnd.google-apps.spreadsheet": ["gsheet"],
  "application/vnd.google-earth.kml+xml": ["kml"],
  "application/vnd.google-earth.kmz": ["kmz"],
  "application/vnd.gov.sk.xmldatacontainer+xml": ["xdcf"],
  "application/vnd.grafeq": ["gqf", "gqs"],
  "application/vnd.groove-account": ["gac"],
  "application/vnd.groove-help": ["ghf"],
  "application/vnd.groove-identity-message": ["gim"],
  "application/vnd.groove-injector": ["grv"],
  "application/vnd.groove-tool-message": ["gtm"],
  "application/vnd.groove-tool-template": ["tpl"],
  "application/vnd.groove-vcard": ["vcg"],
  "application/vnd.hal+xml": ["hal"],
  "application/vnd.handheld-entertainment+xml": ["zmm"],
  "application/vnd.hbci": ["hbci"],
  "application/vnd.hhe.lesson-player": ["les"],
  "application/vnd.hp-hpgl": ["hpgl"],
  "application/vnd.hp-hpid": ["hpid"],
  "application/vnd.hp-hps": ["hps"],
  "application/vnd.hp-jlyt": ["jlt"],
  "application/vnd.hp-pcl": ["pcl"],
  "application/vnd.hp-pclxl": ["pclxl"],
  "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"],
  "application/vnd.ibm.minipay": ["mpy"],
  "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"],
  "application/vnd.ibm.rights-management": ["irm"],
  "application/vnd.ibm.secure-container": ["sc"],
  "application/vnd.iccprofile": ["icc", "icm"],
  "application/vnd.igloader": ["igl"],
  "application/vnd.immervision-ivp": ["ivp"],
  "application/vnd.immervision-ivu": ["ivu"],
  "application/vnd.insors.igm": ["igm"],
  "application/vnd.intercon.formnet": ["xpw", "xpx"],
  "application/vnd.intergeo": ["i2g"],
  "application/vnd.intu.qbo": ["qbo"],
  "application/vnd.intu.qfx": ["qfx"],
  "application/vnd.ipunplugged.rcprofile": ["rcprofile"],
  "application/vnd.irepository.package+xml": ["irp"],
  "application/vnd.is-xpr": ["xpr"],
  "application/vnd.isac.fcs": ["fcs"],
  "application/vnd.jam": ["jam"],
  "application/vnd.jcp.javame.midlet-rms": ["rms"],
  "application/vnd.jisp": ["jisp"],
  "application/vnd.joost.joda-archive": ["joda"],
  "application/vnd.kahootz": ["ktz", "ktr"],
  "application/vnd.kde.karbon": ["karbon"],
  "application/vnd.kde.kchart": ["chrt"],
  "application/vnd.kde.kformula": ["kfo"],
  "application/vnd.kde.kivio": ["flw"],
  "application/vnd.kde.kontour": ["kon"],
  "application/vnd.kde.kpresenter": ["kpr", "kpt"],
  "application/vnd.kde.kspread": ["ksp"],
  "application/vnd.kde.kword": ["kwd", "kwt"],
  "application/vnd.kenameaapp": ["htke"],
  "application/vnd.kidspiration": ["kia"],
  "application/vnd.kinar": ["kne", "knp"],
  "application/vnd.koan": ["skp", "skd", "skt", "skm"],
  "application/vnd.kodak-descriptor": ["sse"],
  "application/vnd.las.las+xml": ["lasxml"],
  "application/vnd.llamagraphics.life-balance.desktop": ["lbd"],
  "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"],
  "application/vnd.lotus-1-2-3": ["123"],
  "application/vnd.lotus-approach": ["apr"],
  "application/vnd.lotus-freelance": ["pre"],
  "application/vnd.lotus-notes": ["nsf"],
  "application/vnd.lotus-organizer": ["org"],
  "application/vnd.lotus-screencam": ["scm"],
  "application/vnd.lotus-wordpro": ["lwp"],
  "application/vnd.macports.portpkg": ["portpkg"],
  "application/vnd.mapbox-vector-tile": ["mvt"],
  "application/vnd.mcd": ["mcd"],
  "application/vnd.medcalcdata": ["mc1"],
  "application/vnd.mediastation.cdkey": ["cdkey"],
  "application/vnd.mfer": ["mwf"],
  "application/vnd.mfmp": ["mfm"],
  "application/vnd.micrografx.flo": ["flo"],
  "application/vnd.micrografx.igx": ["igx"],
  "application/vnd.mif": ["mif"],
  "application/vnd.mobius.daf": ["daf"],
  "application/vnd.mobius.dis": ["dis"],
  "application/vnd.mobius.mbk": ["mbk"],
  "application/vnd.mobius.mqy": ["mqy"],
  "application/vnd.mobius.msl": ["msl"],
  "application/vnd.mobius.plc": ["plc"],
  "application/vnd.mobius.txf": ["txf"],
  "application/vnd.mophun.application": ["mpn"],
  "application/vnd.mophun.certificate": ["mpc"],
  "application/vnd.mozilla.xul+xml": ["xul"],
  "application/vnd.ms-artgalry": ["cil"],
  "application/vnd.ms-cab-compressed": ["cab"],
  "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"],
  "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"],
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"],
  "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"],
  "application/vnd.ms-excel.template.macroenabled.12": ["xltm"],
  "application/vnd.ms-fontobject": ["eot"],
  "application/vnd.ms-htmlhelp": ["chm"],
  "application/vnd.ms-ims": ["ims"],
  "application/vnd.ms-lrm": ["lrm"],
  "application/vnd.ms-officetheme": ["thmx"],
  "application/vnd.ms-outlook": ["msg"],
  "application/vnd.ms-pki.seccat": ["cat"],
  "application/vnd.ms-pki.stl": ["*stl"],
  "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"],
  "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"],
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"],
  "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"],
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"],
  "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"],
  "application/vnd.ms-project": ["*mpp", "mpt"],
  "application/vnd.ms-word.document.macroenabled.12": ["docm"],
  "application/vnd.ms-word.template.macroenabled.12": ["dotm"],
  "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"],
  "application/vnd.ms-wpl": ["wpl"],
  "application/vnd.ms-xpsdocument": ["xps"],
  "application/vnd.mseq": ["mseq"],
  "application/vnd.musician": ["mus"],
  "application/vnd.muvee.style": ["msty"],
  "application/vnd.mynfc": ["taglet"],
  "application/vnd.nato.bindingdataobject+xml": ["bdo"],
  "application/vnd.neurolanguage.nlu": ["nlu"],
  "application/vnd.nitf": ["ntf", "nitf"],
  "application/vnd.noblenet-directory": ["nnd"],
  "application/vnd.noblenet-sealer": ["nns"],
  "application/vnd.noblenet-web": ["nnw"],
  "application/vnd.nokia.n-gage.ac+xml": ["*ac"],
  "application/vnd.nokia.n-gage.data": ["ngdat"],
  "application/vnd.nokia.n-gage.symbian.install": ["n-gage"],
  "application/vnd.nokia.radio-preset": ["rpst"],
  "application/vnd.nokia.radio-presets": ["rpss"],
  "application/vnd.novadigm.edm": ["edm"],
  "application/vnd.novadigm.edx": ["edx"],
  "application/vnd.novadigm.ext": ["ext"],
  "application/vnd.oasis.opendocument.chart": ["odc"],
  "application/vnd.oasis.opendocument.chart-template": ["otc"],
  "application/vnd.oasis.opendocument.database": ["odb"],
  "application/vnd.oasis.opendocument.formula": ["odf"],
  "application/vnd.oasis.opendocument.formula-template": ["odft"],
  "application/vnd.oasis.opendocument.graphics": ["odg"],
  "application/vnd.oasis.opendocument.graphics-template": ["otg"],
  "application/vnd.oasis.opendocument.image": ["odi"],
  "application/vnd.oasis.opendocument.image-template": ["oti"],
  "application/vnd.oasis.opendocument.presentation": ["odp"],
  "application/vnd.oasis.opendocument.presentation-template": ["otp"],
  "application/vnd.oasis.opendocument.spreadsheet": ["ods"],
  "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"],
  "application/vnd.oasis.opendocument.text": ["odt"],
  "application/vnd.oasis.opendocument.text-master": ["odm"],
  "application/vnd.oasis.opendocument.text-template": ["ott"],
  "application/vnd.oasis.opendocument.text-web": ["oth"],
  "application/vnd.olpc-sugar": ["xo"],
  "application/vnd.oma.dd2+xml": ["dd2"],
  "application/vnd.openblox.game+xml": ["obgx"],
  "application/vnd.openofficeorg.extension": ["oxt"],
  "application/vnd.openstreetmap.data+xml": ["osm"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    "pptx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.slide": [
    "sldx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
    "ppsx"
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.template": [
    "potx"
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
    "xltx"
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx"
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
    "dotx"
  ],
  "application/vnd.osgeo.mapguide.package": ["mgp"],
  "application/vnd.osgi.dp": ["dp"],
  "application/vnd.osgi.subsystem": ["esa"],
  "application/vnd.palm": ["pdb", "pqa", "oprc"],
  "application/vnd.pawaafile": ["paw"],
  "application/vnd.pg.format": ["str"],
  "application/vnd.pg.osasli": ["ei6"],
  "application/vnd.picsel": ["efif"],
  "application/vnd.pmi.widget": ["wg"],
  "application/vnd.pocketlearn": ["plf"],
  "application/vnd.powerbuilder6": ["pbd"],
  "application/vnd.previewsystems.box": ["box"],
  "application/vnd.proteus.magazine": ["mgz"],
  "application/vnd.publishare-delta-tree": ["qps"],
  "application/vnd.pvi.ptid1": ["ptid"],
  "application/vnd.pwg-xhtml-print+xml": ["xhtm"],
  "application/vnd.quark.quarkxpress": [
    "qxd",
    "qxt",
    "qwd",
    "qwt",
    "qxl",
    "qxb"
  ],
  "application/vnd.rar": ["rar"],
  "application/vnd.realvnc.bed": ["bed"],
  "application/vnd.recordare.musicxml": ["mxl"],
  "application/vnd.recordare.musicxml+xml": ["musicxml"],
  "application/vnd.rig.cryptonote": ["cryptonote"],
  "application/vnd.rim.cod": ["cod"],
  "application/vnd.rn-realmedia": ["rm"],
  "application/vnd.rn-realmedia-vbr": ["rmvb"],
  "application/vnd.route66.link66+xml": ["link66"],
  "application/vnd.sailingtracker.track": ["st"],
  "application/vnd.seemail": ["see"],
  "application/vnd.sema": ["sema"],
  "application/vnd.semd": ["semd"],
  "application/vnd.semf": ["semf"],
  "application/vnd.shana.informed.formdata": ["ifm"],
  "application/vnd.shana.informed.formtemplate": ["itp"],
  "application/vnd.shana.informed.interchange": ["iif"],
  "application/vnd.shana.informed.package": ["ipk"],
  "application/vnd.simtech-mindmapper": ["twd", "twds"],
  "application/vnd.smaf": ["mmf"],
  "application/vnd.smart.teacher": ["teacher"],
  "application/vnd.software602.filler.form+xml": ["fo"],
  "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"],
  "application/vnd.spotfire.dxp": ["dxp"],
  "application/vnd.spotfire.sfs": ["sfs"],
  "application/vnd.stardivision.calc": ["sdc"],
  "application/vnd.stardivision.draw": ["sda"],
  "application/vnd.stardivision.impress": ["sdd"],
  "application/vnd.stardivision.math": ["smf"],
  "application/vnd.stardivision.writer": ["sdw", "vor"],
  "application/vnd.stardivision.writer-global": ["sgl"],
  "application/vnd.stepmania.package": ["smzip"],
  "application/vnd.stepmania.stepchart": ["sm"],
  "application/vnd.sun.wadl+xml": ["wadl"],
  "application/vnd.sun.xml.calc": ["sxc"],
  "application/vnd.sun.xml.calc.template": ["stc"],
  "application/vnd.sun.xml.draw": ["sxd"],
  "application/vnd.sun.xml.draw.template": ["std"],
  "application/vnd.sun.xml.impress": ["sxi"],
  "application/vnd.sun.xml.impress.template": ["sti"],
  "application/vnd.sun.xml.math": ["sxm"],
  "application/vnd.sun.xml.writer": ["sxw"],
  "application/vnd.sun.xml.writer.global": ["sxg"],
  "application/vnd.sun.xml.writer.template": ["stw"],
  "application/vnd.sus-calendar": ["sus", "susp"],
  "application/vnd.svd": ["svd"],
  "application/vnd.symbian.install": ["sis", "sisx"],
  "application/vnd.syncml+xml": ["xsm"],
  "application/vnd.syncml.dm+wbxml": ["bdm"],
  "application/vnd.syncml.dm+xml": ["xdm"],
  "application/vnd.syncml.dmddf+xml": ["ddf"],
  "application/vnd.tao.intent-module-archive": ["tao"],
  "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"],
  "application/vnd.tmobile-livetv": ["tmo"],
  "application/vnd.trid.tpt": ["tpt"],
  "application/vnd.triscape.mxs": ["mxs"],
  "application/vnd.trueapp": ["tra"],
  "application/vnd.ufdl": ["ufd", "ufdl"],
  "application/vnd.uiq.theme": ["utz"],
  "application/vnd.umajin": ["umj"],
  "application/vnd.unity": ["unityweb"],
  "application/vnd.uoml+xml": ["uoml", "uo"],
  "application/vnd.vcx": ["vcx"],
  "application/vnd.visio": ["vsd", "vst", "vss", "vsw"],
  "application/vnd.visionary": ["vis"],
  "application/vnd.vsf": ["vsf"],
  "application/vnd.wap.wbxml": ["wbxml"],
  "application/vnd.wap.wmlc": ["wmlc"],
  "application/vnd.wap.wmlscriptc": ["wmlsc"],
  "application/vnd.webturbo": ["wtb"],
  "application/vnd.wolfram.player": ["nbp"],
  "application/vnd.wordperfect": ["wpd"],
  "application/vnd.wqd": ["wqd"],
  "application/vnd.wt.stf": ["stf"],
  "application/vnd.xara": ["xar"],
  "application/vnd.xfdl": ["xfdl"],
  "application/vnd.yamaha.hv-dic": ["hvd"],
  "application/vnd.yamaha.hv-script": ["hvs"],
  "application/vnd.yamaha.hv-voice": ["hvp"],
  "application/vnd.yamaha.openscoreformat": ["osf"],
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"],
  "application/vnd.yamaha.smaf-audio": ["saf"],
  "application/vnd.yamaha.smaf-phrase": ["spf"],
  "application/vnd.yellowriver-custom-menu": ["cmp"],
  "application/vnd.zul": ["zir", "zirz"],
  "application/vnd.zzazz.deck+xml": ["zaz"],
  "application/x-7z-compressed": ["7z"],
  "application/x-abiword": ["abw"],
  "application/x-ace-compressed": ["ace"],
  "application/x-apple-diskimage": ["*dmg"],
  "application/x-arj": ["arj"],
  "application/x-authorware-bin": ["aab", "x32", "u32", "vox"],
  "application/x-authorware-map": ["aam"],
  "application/x-authorware-seg": ["aas"],
  "application/x-bcpio": ["bcpio"],
  "application/x-bdoc": ["*bdoc"],
  "application/x-bittorrent": ["torrent"],
  "application/x-blorb": ["blb", "blorb"],
  "application/x-bzip": ["bz"],
  "application/x-bzip2": ["bz2", "boz"],
  "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"],
  "application/x-cdlink": ["vcd"],
  "application/x-cfs-compressed": ["cfs"],
  "application/x-chat": ["chat"],
  "application/x-chess-pgn": ["pgn"],
  "application/x-chrome-extension": ["crx"],
  "application/x-cocoa": ["cco"],
  "application/x-conference": ["nsc"],
  "application/x-cpio": ["cpio"],
  "application/x-csh": ["csh"],
  "application/x-debian-package": ["*deb", "udeb"],
  "application/x-dgc-compressed": ["dgc"],
  "application/x-director": [
    "dir",
    "dcr",
    "dxr",
    "cst",
    "cct",
    "cxt",
    "w3d",
    "fgd",
    "swa"
  ],
  "application/x-doom": ["wad"],
  "application/x-dtbncx+xml": ["ncx"],
  "application/x-dtbook+xml": ["dtb"],
  "application/x-dtbresource+xml": ["res"],
  "application/x-dvi": ["dvi"],
  "application/x-envoy": ["evy"],
  "application/x-eva": ["eva"],
  "application/x-font-bdf": ["bdf"],
  "application/x-font-ghostscript": ["gsf"],
  "application/x-font-linux-psf": ["psf"],
  "application/x-font-pcf": ["pcf"],
  "application/x-font-snf": ["snf"],
  "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"],
  "application/x-freearc": ["arc"],
  "application/x-futuresplash": ["spl"],
  "application/x-gca-compressed": ["gca"],
  "application/x-glulx": ["ulx"],
  "application/x-gnumeric": ["gnumeric"],
  "application/x-gramps-xml": ["gramps"],
  "application/x-gtar": ["gtar"],
  "application/x-hdf": ["hdf"],
  "application/x-httpd-php": ["php"],
  "application/x-install-instructions": ["install"],
  "application/x-iso9660-image": ["*iso"],
  "application/x-iwork-keynote-sffkey": ["*key"],
  "application/x-iwork-numbers-sffnumbers": ["*numbers"],
  "application/x-iwork-pages-sffpages": ["*pages"],
  "application/x-java-archive-diff": ["jardiff"],
  "application/x-java-jnlp-file": ["jnlp"],
  "application/x-keepass2": ["kdbx"],
  "application/x-latex": ["latex"],
  "application/x-lua-bytecode": ["luac"],
  "application/x-lzh-compressed": ["lzh", "lha"],
  "application/x-makeself": ["run"],
  "application/x-mie": ["mie"],
  "application/x-mobipocket-ebook": ["*prc", "mobi"],
  "application/x-ms-application": ["application"],
  "application/x-ms-shortcut": ["lnk"],
  "application/x-ms-wmd": ["wmd"],
  "application/x-ms-wmz": ["wmz"],
  "application/x-ms-xbap": ["xbap"],
  "application/x-msaccess": ["mdb"],
  "application/x-msbinder": ["obd"],
  "application/x-mscardfile": ["crd"],
  "application/x-msclip": ["clp"],
  "application/x-msdos-program": ["*exe"],
  "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"],
  "application/x-msmediaview": ["mvb", "m13", "m14"],
  "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"],
  "application/x-msmoney": ["mny"],
  "application/x-mspublisher": ["pub"],
  "application/x-msschedule": ["scd"],
  "application/x-msterminal": ["trm"],
  "application/x-mswrite": ["wri"],
  "application/x-netcdf": ["nc", "cdf"],
  "application/x-ns-proxy-autoconfig": ["pac"],
  "application/x-nzb": ["nzb"],
  "application/x-perl": ["pl", "pm"],
  "application/x-pilot": ["*prc", "*pdb"],
  "application/x-pkcs12": ["p12", "pfx"],
  "application/x-pkcs7-certificates": ["p7b", "spc"],
  "application/x-pkcs7-certreqresp": ["p7r"],
  "application/x-rar-compressed": ["*rar"],
  "application/x-redhat-package-manager": ["rpm"],
  "application/x-research-info-systems": ["ris"],
  "application/x-sea": ["sea"],
  "application/x-sh": ["sh"],
  "application/x-shar": ["shar"],
  "application/x-shockwave-flash": ["swf"],
  "application/x-silverlight-app": ["xap"],
  "application/x-sql": ["*sql"],
  "application/x-stuffit": ["sit"],
  "application/x-stuffitx": ["sitx"],
  "application/x-subrip": ["srt"],
  "application/x-sv4cpio": ["sv4cpio"],
  "application/x-sv4crc": ["sv4crc"],
  "application/x-t3vm-image": ["t3"],
  "application/x-tads": ["gam"],
  "application/x-tar": ["tar"],
  "application/x-tcl": ["tcl", "tk"],
  "application/x-tex": ["tex"],
  "application/x-tex-tfm": ["tfm"],
  "application/x-texinfo": ["texinfo", "texi"],
  "application/x-tgif": ["*obj"],
  "application/x-ustar": ["ustar"],
  "application/x-virtualbox-hdd": ["hdd"],
  "application/x-virtualbox-ova": ["ova"],
  "application/x-virtualbox-ovf": ["ovf"],
  "application/x-virtualbox-vbox": ["vbox"],
  "application/x-virtualbox-vbox-extpack": ["vbox-extpack"],
  "application/x-virtualbox-vdi": ["vdi"],
  "application/x-virtualbox-vhd": ["vhd"],
  "application/x-virtualbox-vmdk": ["vmdk"],
  "application/x-wais-source": ["src"],
  "application/x-web-app-manifest+json": ["webapp"],
  "application/x-x509-ca-cert": ["der", "crt", "pem"],
  "application/x-xfig": ["fig"],
  "application/x-xliff+xml": ["*xlf"],
  "application/x-xpinstall": ["xpi"],
  "application/x-xz": ["xz"],
  "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"],
  "audio/vnd.dece.audio": ["uva", "uvva"],
  "audio/vnd.digital-winds": ["eol"],
  "audio/vnd.dra": ["dra"],
  "audio/vnd.dts": ["dts"],
  "audio/vnd.dts.hd": ["dtshd"],
  "audio/vnd.lucent.voice": ["lvp"],
  "audio/vnd.ms-playready.media.pya": ["pya"],
  "audio/vnd.nuera.ecelp4800": ["ecelp4800"],
  "audio/vnd.nuera.ecelp7470": ["ecelp7470"],
  "audio/vnd.nuera.ecelp9600": ["ecelp9600"],
  "audio/vnd.rip": ["rip"],
  "audio/x-aac": ["*aac"],
  "audio/x-aiff": ["aif", "aiff", "aifc"],
  "audio/x-caf": ["caf"],
  "audio/x-flac": ["flac"],
  "audio/x-m4a": ["*m4a"],
  "audio/x-matroska": ["mka"],
  "audio/x-mpegurl": ["m3u"],
  "audio/x-ms-wax": ["wax"],
  "audio/x-ms-wma": ["wma"],
  "audio/x-pn-realaudio": ["ram", "ra"],
  "audio/x-pn-realaudio-plugin": ["rmp"],
  "audio/x-realaudio": ["*ra"],
  "audio/x-wav": ["*wav"],
  "chemical/x-cdx": ["cdx"],
  "chemical/x-cif": ["cif"],
  "chemical/x-cmdf": ["cmdf"],
  "chemical/x-cml": ["cml"],
  "chemical/x-csml": ["csml"],
  "chemical/x-xyz": ["xyz"],
  "image/prs.btif": ["btif", "btf"],
  "image/prs.pti": ["pti"],
  "image/vnd.adobe.photoshop": ["psd"],
  "image/vnd.airzip.accelerator.azv": ["azv"],
  "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"],
  "image/vnd.djvu": ["djvu", "djv"],
  "image/vnd.dvb.subtitle": ["*sub"],
  "image/vnd.dwg": ["dwg"],
  "image/vnd.dxf": ["dxf"],
  "image/vnd.fastbidsheet": ["fbs"],
  "image/vnd.fpx": ["fpx"],
  "image/vnd.fst": ["fst"],
  "image/vnd.fujixerox.edmics-mmr": ["mmr"],
  "image/vnd.fujixerox.edmics-rlc": ["rlc"],
  "image/vnd.microsoft.icon": ["ico"],
  "image/vnd.ms-dds": ["dds"],
  "image/vnd.ms-modi": ["mdi"],
  "image/vnd.ms-photo": ["wdp"],
  "image/vnd.net-fpx": ["npx"],
  "image/vnd.pco.b16": ["b16"],
  "image/vnd.tencent.tap": ["tap"],
  "image/vnd.valve.source.texture": ["vtf"],
  "image/vnd.wap.wbmp": ["wbmp"],
  "image/vnd.xiff": ["xif"],
  "image/vnd.zbrush.pcx": ["pcx"],
  "image/x-3ds": ["3ds"],
  "image/x-cmu-raster": ["ras"],
  "image/x-cmx": ["cmx"],
  "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"],
  "image/x-icon": ["*ico"],
  "image/x-jng": ["jng"],
  "image/x-mrsid-image": ["sid"],
  "image/x-ms-bmp": ["*bmp"],
  "image/x-pcx": ["*pcx"],
  "image/x-pict": ["pic", "pct"],
  "image/x-portable-anymap": ["pnm"],
  "image/x-portable-bitmap": ["pbm"],
  "image/x-portable-graymap": ["pgm"],
  "image/x-portable-pixmap": ["ppm"],
  "image/x-rgb": ["rgb"],
  "image/x-tga": ["tga"],
  "image/x-xbitmap": ["xbm"],
  "image/x-xpixmap": ["xpm"],
  "image/x-xwindowdump": ["xwd"],
  "message/vnd.wfa.wsc": ["wsc"],
  "model/vnd.bary": ["bary"],
  "model/vnd.cld": ["cld"],
  "model/vnd.collada+xml": ["dae"],
  "model/vnd.dwf": ["dwf"],
  "model/vnd.gdl": ["gdl"],
  "model/vnd.gtw": ["gtw"],
  "model/vnd.mts": ["*mts"],
  "model/vnd.opengex": ["ogex"],
  "model/vnd.parasolid.transmit.binary": ["x_b"],
  "model/vnd.parasolid.transmit.text": ["x_t"],
  "model/vnd.pytha.pyox": ["pyo", "pyox"],
  "model/vnd.sap.vds": ["vds"],
  "model/vnd.usda": ["usda"],
  "model/vnd.usdz+zip": ["usdz"],
  "model/vnd.valve.source.compiled-map": ["bsp"],
  "model/vnd.vtu": ["vtu"],
  "text/prs.lines.tag": ["dsc"],
  "text/vnd.curl": ["curl"],
  "text/vnd.curl.dcurl": ["dcurl"],
  "text/vnd.curl.mcurl": ["mcurl"],
  "text/vnd.curl.scurl": ["scurl"],
  "text/vnd.dvb.subtitle": ["sub"],
  "text/vnd.familysearch.gedcom": ["ged"],
  "text/vnd.fly": ["fly"],
  "text/vnd.fmi.flexstor": ["flx"],
  "text/vnd.graphviz": ["gv"],
  "text/vnd.in3d.3dml": ["3dml"],
  "text/vnd.in3d.spot": ["spot"],
  "text/vnd.sun.j2me.app-descriptor": ["jad"],
  "text/vnd.wap.wml": ["wml"],
  "text/vnd.wap.wmlscript": ["wmls"],
  "text/x-asm": ["s", "asm"],
  "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"],
  "text/x-component": ["htc"],
  "text/x-fortran": ["f", "for", "f77", "f90"],
  "text/x-handlebars-template": ["hbs"],
  "text/x-java-source": ["java"],
  "text/x-lua": ["lua"],
  "text/x-markdown": ["mkd"],
  "text/x-nfo": ["nfo"],
  "text/x-opml": ["opml"],
  "text/x-org": ["*org"],
  "text/x-pascal": ["p", "pas"],
  "text/x-processing": ["pde"],
  "text/x-sass": ["sass"],
  "text/x-scss": ["scss"],
  "text/x-setext": ["etx"],
  "text/x-sfv": ["sfv"],
  "text/x-suse-ymp": ["ymp"],
  "text/x-uuencode": ["uu"],
  "text/x-vcalendar": ["vcs"],
  "text/x-vcard": ["vcf"],
  "video/vnd.dece.hd": ["uvh", "uvvh"],
  "video/vnd.dece.mobile": ["uvm", "uvvm"],
  "video/vnd.dece.pd": ["uvp", "uvvp"],
  "video/vnd.dece.sd": ["uvs", "uvvs"],
  "video/vnd.dece.video": ["uvv", "uvvv"],
  "video/vnd.dvb.file": ["dvb"],
  "video/vnd.fvt": ["fvt"],
  "video/vnd.mpegurl": ["mxu", "m4u"],
  "video/vnd.ms-playready.media.pyv": ["pyv"],
  "video/vnd.uvvu.mp4": ["uvu", "uvvu"],
  "video/vnd.vivo": ["viv"],
  "video/x-f4v": ["f4v"],
  "video/x-fli": ["fli"],
  "video/x-flv": ["flv"],
  "video/x-m4v": ["m4v"],
  "video/x-matroska": ["mkv", "mk3d", "mks"],
  "video/x-mng": ["mng"],
  "video/x-ms-asf": ["asf", "asx"],
  "video/x-ms-vob": ["vob"],
  "video/x-ms-wm": ["wm"],
  "video/x-ms-wmv": ["wmv"],
  "video/x-ms-wmx": ["wmx"],
  "video/x-ms-wvx": ["wvx"],
  "video/x-msvideo": ["avi"],
  "video/x-sgi-movie": ["movie"],
  "video/x-smv": ["smv"],
  "x-conference/x-cooltalk": ["ice"]
};
Object.freeze(as);
const ss = {
  "application/andrew-inset": ["ez"],
  "application/appinstaller": ["appinstaller"],
  "application/applixware": ["aw"],
  "application/appx": ["appx"],
  "application/appxbundle": ["appxbundle"],
  "application/atom+xml": ["atom"],
  "application/atomcat+xml": ["atomcat"],
  "application/atomdeleted+xml": ["atomdeleted"],
  "application/atomsvc+xml": ["atomsvc"],
  "application/atsc-dwd+xml": ["dwd"],
  "application/atsc-held+xml": ["held"],
  "application/atsc-rsat+xml": ["rsat"],
  "application/automationml-aml+xml": ["aml"],
  "application/automationml-amlx+zip": ["amlx"],
  "application/bdoc": ["bdoc"],
  "application/calendar+xml": ["xcs"],
  "application/ccxml+xml": ["ccxml"],
  "application/cdfx+xml": ["cdfx"],
  "application/cdmi-capability": ["cdmia"],
  "application/cdmi-container": ["cdmic"],
  "application/cdmi-domain": ["cdmid"],
  "application/cdmi-object": ["cdmio"],
  "application/cdmi-queue": ["cdmiq"],
  "application/cpl+xml": ["cpl"],
  "application/cu-seeme": ["cu"],
  "application/cwl": ["cwl"],
  "application/dash+xml": ["mpd"],
  "application/dash-patch+xml": ["mpp"],
  "application/davmount+xml": ["davmount"],
  "application/docbook+xml": ["dbk"],
  "application/dssc+der": ["dssc"],
  "application/dssc+xml": ["xdssc"],
  "application/ecmascript": ["ecma"],
  "application/emma+xml": ["emma"],
  "application/emotionml+xml": ["emotionml"],
  "application/epub+zip": ["epub"],
  "application/exi": ["exi"],
  "application/express": ["exp"],
  "application/fdf": ["fdf"],
  "application/fdt+xml": ["fdt"],
  "application/font-tdpfr": ["pfr"],
  "application/geo+json": ["geojson"],
  "application/gml+xml": ["gml"],
  "application/gpx+xml": ["gpx"],
  "application/gxf": ["gxf"],
  "application/gzip": ["gz"],
  "application/hjson": ["hjson"],
  "application/hyperstudio": ["stk"],
  "application/inkml+xml": ["ink", "inkml"],
  "application/ipfix": ["ipfix"],
  "application/its+xml": ["its"],
  "application/java-archive": ["jar", "war", "ear"],
  "application/java-serialized-object": ["ser"],
  "application/java-vm": ["class"],
  "application/javascript": ["*js"],
  "application/json": ["json", "map"],
  "application/json5": ["json5"],
  "application/jsonml+json": ["jsonml"],
  "application/ld+json": ["jsonld"],
  "application/lgr+xml": ["lgr"],
  "application/lost+xml": ["lostxml"],
  "application/mac-binhex40": ["hqx"],
  "application/mac-compactpro": ["cpt"],
  "application/mads+xml": ["mads"],
  "application/manifest+json": ["webmanifest"],
  "application/marc": ["mrc"],
  "application/marcxml+xml": ["mrcx"],
  "application/mathematica": ["ma", "nb", "mb"],
  "application/mathml+xml": ["mathml"],
  "application/mbox": ["mbox"],
  "application/media-policy-dataset+xml": ["mpf"],
  "application/mediaservercontrol+xml": ["mscml"],
  "application/metalink+xml": ["metalink"],
  "application/metalink4+xml": ["meta4"],
  "application/mets+xml": ["mets"],
  "application/mmt-aei+xml": ["maei"],
  "application/mmt-usd+xml": ["musd"],
  "application/mods+xml": ["mods"],
  "application/mp21": ["m21", "mp21"],
  "application/mp4": ["*mp4", "*mpg4", "mp4s", "m4p"],
  "application/msix": ["msix"],
  "application/msixbundle": ["msixbundle"],
  "application/msword": ["doc", "dot"],
  "application/mxf": ["mxf"],
  "application/n-quads": ["nq"],
  "application/n-triples": ["nt"],
  "application/node": ["cjs"],
  "application/octet-stream": [
    "bin",
    "dms",
    "lrf",
    "mar",
    "so",
    "dist",
    "distz",
    "pkg",
    "bpk",
    "dump",
    "elc",
    "deploy",
    "exe",
    "dll",
    "deb",
    "dmg",
    "iso",
    "img",
    "msi",
    "msp",
    "msm",
    "buffer"
  ],
  "application/oda": ["oda"],
  "application/oebps-package+xml": ["opf"],
  "application/ogg": ["ogx"],
  "application/omdoc+xml": ["omdoc"],
  "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"],
  "application/oxps": ["oxps"],
  "application/p2p-overlay+xml": ["relo"],
  "application/patch-ops-error+xml": ["xer"],
  "application/pdf": ["pdf"],
  "application/pgp-encrypted": ["pgp"],
  "application/pgp-keys": ["asc"],
  "application/pgp-signature": ["sig", "*asc"],
  "application/pics-rules": ["prf"],
  "application/pkcs10": ["p10"],
  "application/pkcs7-mime": ["p7m", "p7c"],
  "application/pkcs7-signature": ["p7s"],
  "application/pkcs8": ["p8"],
  "application/pkix-attr-cert": ["ac"],
  "application/pkix-cert": ["cer"],
  "application/pkix-crl": ["crl"],
  "application/pkix-pkipath": ["pkipath"],
  "application/pkixcmp": ["pki"],
  "application/pls+xml": ["pls"],
  "application/postscript": ["ai", "eps", "ps"],
  "application/provenance+xml": ["provx"],
  "application/pskc+xml": ["pskcxml"],
  "application/raml+yaml": ["raml"],
  "application/rdf+xml": ["rdf", "owl"],
  "application/reginfo+xml": ["rif"],
  "application/relax-ng-compact-syntax": ["rnc"],
  "application/resource-lists+xml": ["rl"],
  "application/resource-lists-diff+xml": ["rld"],
  "application/rls-services+xml": ["rs"],
  "application/route-apd+xml": ["rapd"],
  "application/route-s-tsid+xml": ["sls"],
  "application/route-usd+xml": ["rusd"],
  "application/rpki-ghostbusters": ["gbr"],
  "application/rpki-manifest": ["mft"],
  "application/rpki-roa": ["roa"],
  "application/rsd+xml": ["rsd"],
  "application/rss+xml": ["rss"],
  "application/rtf": ["rtf"],
  "application/sbml+xml": ["sbml"],
  "application/scvp-cv-request": ["scq"],
  "application/scvp-cv-response": ["scs"],
  "application/scvp-vp-request": ["spq"],
  "application/scvp-vp-response": ["spp"],
  "application/sdp": ["sdp"],
  "application/senml+xml": ["senmlx"],
  "application/sensml+xml": ["sensmlx"],
  "application/set-payment-initiation": ["setpay"],
  "application/set-registration-initiation": ["setreg"],
  "application/shf+xml": ["shf"],
  "application/sieve": ["siv", "sieve"],
  "application/smil+xml": ["smi", "smil"],
  "application/sparql-query": ["rq"],
  "application/sparql-results+xml": ["srx"],
  "application/sql": ["sql"],
  "application/srgs": ["gram"],
  "application/srgs+xml": ["grxml"],
  "application/sru+xml": ["sru"],
  "application/ssdl+xml": ["ssdl"],
  "application/ssml+xml": ["ssml"],
  "application/swid+xml": ["swidtag"],
  "application/tei+xml": ["tei", "teicorpus"],
  "application/thraud+xml": ["tfi"],
  "application/timestamped-data": ["tsd"],
  "application/toml": ["toml"],
  "application/trig": ["trig"],
  "application/ttml+xml": ["ttml"],
  "application/ubjson": ["ubj"],
  "application/urc-ressheet+xml": ["rsheet"],
  "application/urc-targetdesc+xml": ["td"],
  "application/voicexml+xml": ["vxml"],
  "application/wasm": ["wasm"],
  "application/watcherinfo+xml": ["wif"],
  "application/widget": ["wgt"],
  "application/winhlp": ["hlp"],
  "application/wsdl+xml": ["wsdl"],
  "application/wspolicy+xml": ["wspolicy"],
  "application/xaml+xml": ["xaml"],
  "application/xcap-att+xml": ["xav"],
  "application/xcap-caps+xml": ["xca"],
  "application/xcap-diff+xml": ["xdf"],
  "application/xcap-el+xml": ["xel"],
  "application/xcap-ns+xml": ["xns"],
  "application/xenc+xml": ["xenc"],
  "application/xfdf": ["xfdf"],
  "application/xhtml+xml": ["xhtml", "xht"],
  "application/xliff+xml": ["xlf"],
  "application/xml": ["xml", "xsl", "xsd", "rng"],
  "application/xml-dtd": ["dtd"],
  "application/xop+xml": ["xop"],
  "application/xproc+xml": ["xpl"],
  "application/xslt+xml": ["*xsl", "xslt"],
  "application/xspf+xml": ["xspf"],
  "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
  "application/yang": ["yang"],
  "application/yin+xml": ["yin"],
  "application/zip": ["zip"],
  "audio/3gpp": ["*3gpp"],
  "audio/aac": ["adts", "aac"],
  "audio/adpcm": ["adp"],
  "audio/amr": ["amr"],
  "audio/basic": ["au", "snd"],
  "audio/midi": ["mid", "midi", "kar", "rmi"],
  "audio/mobile-xmf": ["mxmf"],
  "audio/mp3": ["*mp3"],
  "audio/mp4": ["m4a", "mp4a"],
  "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"],
  "audio/ogg": ["oga", "ogg", "spx", "opus"],
  "audio/s3m": ["s3m"],
  "audio/silk": ["sil"],
  "audio/wav": ["wav"],
  "audio/wave": ["*wav"],
  "audio/webm": ["weba"],
  "audio/xm": ["xm"],
  "font/collection": ["ttc"],
  "font/otf": ["otf"],
  "font/ttf": ["ttf"],
  "font/woff": ["woff"],
  "font/woff2": ["woff2"],
  "image/aces": ["exr"],
  "image/apng": ["apng"],
  "image/avci": ["avci"],
  "image/avcs": ["avcs"],
  "image/avif": ["avif"],
  "image/bmp": ["bmp", "dib"],
  "image/cgm": ["cgm"],
  "image/dicom-rle": ["drle"],
  "image/dpx": ["dpx"],
  "image/emf": ["emf"],
  "image/fits": ["fits"],
  "image/g3fax": ["g3"],
  "image/gif": ["gif"],
  "image/heic": ["heic"],
  "image/heic-sequence": ["heics"],
  "image/heif": ["heif"],
  "image/heif-sequence": ["heifs"],
  "image/hej2k": ["hej2"],
  "image/hsj2": ["hsj2"],
  "image/ief": ["ief"],
  "image/jls": ["jls"],
  "image/jp2": ["jp2", "jpg2"],
  "image/jpeg": ["jpeg", "jpg", "jpe"],
  "image/jph": ["jph"],
  "image/jphc": ["jhc"],
  "image/jpm": ["jpm", "jpgm"],
  "image/jpx": ["jpx", "jpf"],
  "image/jxl": ["jxl"],
  "image/jxr": ["jxr"],
  "image/jxra": ["jxra"],
  "image/jxrs": ["jxrs"],
  "image/jxs": ["jxs"],
  "image/jxsc": ["jxsc"],
  "image/jxsi": ["jxsi"],
  "image/jxss": ["jxss"],
  "image/ktx": ["ktx"],
  "image/ktx2": ["ktx2"],
  "image/png": ["png"],
  "image/sgi": ["sgi"],
  "image/svg+xml": ["svg", "svgz"],
  "image/t38": ["t38"],
  "image/tiff": ["tif", "tiff"],
  "image/tiff-fx": ["tfx"],
  "image/webp": ["webp"],
  "image/wmf": ["wmf"],
  "message/disposition-notification": ["disposition-notification"],
  "message/global": ["u8msg"],
  "message/global-delivery-status": ["u8dsn"],
  "message/global-disposition-notification": ["u8mdn"],
  "message/global-headers": ["u8hdr"],
  "message/rfc822": ["eml", "mime"],
  "model/3mf": ["3mf"],
  "model/gltf+json": ["gltf"],
  "model/gltf-binary": ["glb"],
  "model/iges": ["igs", "iges"],
  "model/jt": ["jt"],
  "model/mesh": ["msh", "mesh", "silo"],
  "model/mtl": ["mtl"],
  "model/obj": ["obj"],
  "model/prc": ["prc"],
  "model/step+xml": ["stpx"],
  "model/step+zip": ["stpz"],
  "model/step-xml+zip": ["stpxz"],
  "model/stl": ["stl"],
  "model/u3d": ["u3d"],
  "model/vrml": ["wrl", "vrml"],
  "model/x3d+binary": ["*x3db", "x3dbz"],
  "model/x3d+fastinfoset": ["x3db"],
  "model/x3d+vrml": ["*x3dv", "x3dvz"],
  "model/x3d+xml": ["x3d", "x3dz"],
  "model/x3d-vrml": ["x3dv"],
  "text/cache-manifest": ["appcache", "manifest"],
  "text/calendar": ["ics", "ifb"],
  "text/coffeescript": ["coffee", "litcoffee"],
  "text/css": ["css"],
  "text/csv": ["csv"],
  "text/html": ["html", "htm", "shtml"],
  "text/jade": ["jade"],
  "text/javascript": ["js", "mjs"],
  "text/jsx": ["jsx"],
  "text/less": ["less"],
  "text/markdown": ["md", "markdown"],
  "text/mathml": ["mml"],
  "text/mdx": ["mdx"],
  "text/n3": ["n3"],
  "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"],
  "text/richtext": ["rtx"],
  "text/rtf": ["*rtf"],
  "text/sgml": ["sgml", "sgm"],
  "text/shex": ["shex"],
  "text/slim": ["slim", "slm"],
  "text/spdx": ["spdx"],
  "text/stylus": ["stylus", "styl"],
  "text/tab-separated-values": ["tsv"],
  "text/troff": ["t", "tr", "roff", "man", "me", "ms"],
  "text/turtle": ["ttl"],
  "text/uri-list": ["uri", "uris", "urls"],
  "text/vcard": ["vcard"],
  "text/vtt": ["vtt"],
  "text/wgsl": ["wgsl"],
  "text/xml": ["*xml"],
  "text/yaml": ["yaml", "yml"],
  "video/3gpp": ["3gp", "3gpp"],
  "video/3gpp2": ["3g2"],
  "video/h261": ["h261"],
  "video/h263": ["h263"],
  "video/h264": ["h264"],
  "video/iso.segment": ["m4s"],
  "video/jpeg": ["jpgv"],
  "video/jpm": ["*jpm", "*jpgm"],
  "video/mj2": ["mj2", "mjp2"],
  "video/mp2t": ["ts", "m2t", "m2ts", "mts"],
  "video/mp4": ["mp4", "mp4v", "mpg4"],
  "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"],
  "video/ogg": ["ogv"],
  "video/quicktime": ["qt", "mov"],
  "video/webm": ["webm"]
};
Object.freeze(ss);
var Ue = function(e, t, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, yt, At, Qe;
class Ef {
  constructor(...t) {
    yt.set(this, /* @__PURE__ */ new Map()), At.set(this, /* @__PURE__ */ new Map()), Qe.set(this, /* @__PURE__ */ new Map());
    for (const r of t)
      this.define(r);
  }
  define(t, r = !1) {
    for (let [n, i] of Object.entries(t)) {
      n = n.toLowerCase(), i = i.map((s) => s.toLowerCase()), Ue(this, Qe, "f").has(n) || Ue(this, Qe, "f").set(n, /* @__PURE__ */ new Set());
      const o = Ue(this, Qe, "f").get(n);
      let a = !0;
      for (let s of i) {
        const u = s.startsWith("*");
        if (s = u ? s.slice(1) : s, o == null || o.add(s), a && Ue(this, At, "f").set(n, s), a = !1, u)
          continue;
        const c = Ue(this, yt, "f").get(s);
        if (c && c != n && !r)
          throw new Error(`"${n} -> ${s}" conflicts with "${c} -> ${s}". Pass \`force=true\` to override this definition.`);
        Ue(this, yt, "f").set(s, n);
      }
    }
    return this;
  }
  getType(t) {
    if (typeof t != "string")
      return null;
    const r = t.replace(/^.*[/\\]/, "").toLowerCase(), n = r.replace(/^.*\./, "").toLowerCase(), i = r.length < t.length;
    return !(n.length < r.length - 1) && i ? null : Ue(this, yt, "f").get(n) ?? null;
  }
  getExtension(t) {
    var r;
    return typeof t != "string" ? null : (t = (r = t == null ? void 0 : t.split) == null ? void 0 : r.call(t, ";")[0], (t && Ue(this, At, "f").get(t.trim().toLowerCase())) ?? null);
  }
  getAllExtensions(t) {
    return typeof t != "string" ? null : Ue(this, Qe, "f").get(t.toLowerCase()) ?? null;
  }
  _freeze() {
    this.define = () => {
      throw new Error("define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances");
    }, Object.freeze(this);
    for (const t of Ue(this, Qe, "f").values())
      Object.freeze(t);
    return this;
  }
  _getTestState() {
    return {
      types: Ue(this, yt, "f"),
      extensions: Ue(this, At, "f")
    };
  }
}
yt = /* @__PURE__ */ new WeakMap(), At = /* @__PURE__ */ new WeakMap(), Qe = /* @__PURE__ */ new WeakMap();
const Of = new Ef(ss, as)._freeze();
var wn = { exports: {} }, Zr = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oo;
function Sf() {
  return Oo || (Oo = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = pr, r = Hn(), n = 60103, i = 60106;
      e.Fragment = 60107;
      var o = 60108, a = 60114, s = 60109, u = 60110, c = 60112, _ = 60113, h = 60120, P = 60115, D = 60116, W = 60121, I = 60122, R = 60117, U = 60129, H = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var m = Symbol.for;
        n = m("react.element"), i = m("react.portal"), e.Fragment = m("react.fragment"), o = m("react.strict_mode"), a = m("react.profiler"), s = m("react.provider"), u = m("react.context"), c = m("react.forward_ref"), _ = m("react.suspense"), h = m("react.suspense_list"), P = m("react.memo"), D = m("react.lazy"), W = m("react.block"), I = m("react.server.block"), R = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), U = m("react.debug_trace_mode"), m("react.offscreen"), H = m("react.legacy_hidden");
      }
      var y = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
      function T(l) {
        if (l === null || typeof l != "object")
          return null;
        var L = y && l[y] || l[f];
        return typeof L == "function" ? L : null;
      }
      var S = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function j(l) {
        {
          for (var L = arguments.length, F = new Array(L > 1 ? L - 1 : 0), X = 1; X < L; X++)
            F[X - 1] = arguments[X];
          z("error", l, F);
        }
      }
      function z(l, L, F) {
        {
          var X = S.ReactDebugCurrentFrame, oe = X.getStackAddendum();
          oe !== "" && (L += "%s", F = F.concat([oe]));
          var ae = F.map(function(Q) {
            return "" + Q;
          });
          ae.unshift("Warning: " + L), Function.prototype.apply.call(console[l], console, ae);
        }
      }
      var Y = !1;
      function K(l) {
        return !!(typeof l == "string" || typeof l == "function" || l === e.Fragment || l === a || l === U || l === o || l === _ || l === h || l === H || Y || typeof l == "object" && l !== null && (l.$$typeof === D || l.$$typeof === P || l.$$typeof === s || l.$$typeof === u || l.$$typeof === c || l.$$typeof === R || l.$$typeof === W || l[0] === I));
      }
      function de(l, L, F) {
        var X = L.displayName || L.name || "";
        return l.displayName || (X !== "" ? F + "(" + X + ")" : F);
      }
      function q(l) {
        return l.displayName || "Context";
      }
      function Z(l) {
        if (l == null)
          return null;
        if (typeof l.tag == "number" && j("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof l == "function")
          return l.displayName || l.name || null;
        if (typeof l == "string")
          return l;
        switch (l) {
          case e.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case a:
            return "Profiler";
          case o:
            return "StrictMode";
          case _:
            return "Suspense";
          case h:
            return "SuspenseList";
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case u:
              var L = l;
              return q(L) + ".Consumer";
            case s:
              var F = l;
              return q(F._context) + ".Provider";
            case c:
              return de(l, l.render, "ForwardRef");
            case P:
              return Z(l.type);
            case W:
              return Z(l._render);
            case D: {
              var X = l, oe = X._payload, ae = X._init;
              try {
                return Z(ae(oe));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var re = 0, g, p, v, C, d, b, $;
      function B() {
      }
      B.__reactDisabledLog = !0;
      function O() {
        {
          if (re === 0) {
            g = console.log, p = console.info, v = console.warn, C = console.error, d = console.group, b = console.groupCollapsed, $ = console.groupEnd;
            var l = {
              configurable: !0,
              enumerable: !0,
              value: B,
              writable: !0
            };
            Object.defineProperties(console, {
              info: l,
              log: l,
              warn: l,
              error: l,
              group: l,
              groupCollapsed: l,
              groupEnd: l
            });
          }
          re++;
        }
      }
      function x() {
        {
          if (re--, re === 0) {
            var l = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, l, {
                value: g
              }),
              info: r({}, l, {
                value: p
              }),
              warn: r({}, l, {
                value: v
              }),
              error: r({}, l, {
                value: C
              }),
              group: r({}, l, {
                value: d
              }),
              groupCollapsed: r({}, l, {
                value: b
              }),
              groupEnd: r({}, l, {
                value: $
              })
            });
          }
          re < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var w = S.ReactCurrentDispatcher, E;
      function N(l, L, F) {
        {
          if (E === void 0)
            try {
              throw Error();
            } catch (oe) {
              var X = oe.stack.trim().match(/\n( *(at )?)/);
              E = X && X[1] || "";
            }
          return `
` + E + l;
        }
      }
      var M = !1, V;
      {
        var A = typeof WeakMap == "function" ? WeakMap : Map;
        V = new A();
      }
      function k(l, L) {
        if (!l || M)
          return "";
        {
          var F = V.get(l);
          if (F !== void 0)
            return F;
        }
        var X;
        M = !0;
        var oe = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ae;
        ae = w.current, w.current = null, O();
        try {
          if (L) {
            var Q = function() {
              throw Error();
            };
            if (Object.defineProperty(Q.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Q, []);
              } catch (Be) {
                X = Be;
              }
              Reflect.construct(l, [], Q);
            } else {
              try {
                Q.call();
              } catch (Be) {
                X = Be;
              }
              l.call(Q.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Be) {
              X = Be;
            }
            l();
          }
        } catch (Be) {
          if (Be && X && typeof Be.stack == "string") {
            for (var ee = Be.stack.split(`
`), ge = X.stack.split(`
`), be = ee.length - 1, xe = ge.length - 1; be >= 1 && xe >= 0 && ee[be] !== ge[xe]; )
              xe--;
            for (; be >= 1 && xe >= 0; be--, xe--)
              if (ee[be] !== ge[xe]) {
                if (be !== 1 || xe !== 1)
                  do
                    if (be--, xe--, xe < 0 || ee[be] !== ge[xe]) {
                      var Me = `
` + ee[be].replace(" at new ", " at ");
                      return typeof l == "function" && V.set(l, Me), Me;
                    }
                  while (be >= 1 && xe >= 0);
                break;
              }
          }
        } finally {
          M = !1, w.current = ae, x(), Error.prepareStackTrace = oe;
        }
        var lt = l ? l.displayName || l.name : "", Jn = lt ? N(lt) : "";
        return typeof l == "function" && V.set(l, Jn), Jn;
      }
      function G(l, L, F) {
        return k(l, !1);
      }
      function ne(l) {
        var L = l.prototype;
        return !!(L && L.isReactComponent);
      }
      function ue(l, L, F) {
        if (l == null)
          return "";
        if (typeof l == "function")
          return k(l, ne(l));
        if (typeof l == "string")
          return N(l);
        switch (l) {
          case _:
            return N("Suspense");
          case h:
            return N("SuspenseList");
        }
        if (typeof l == "object")
          switch (l.$$typeof) {
            case c:
              return G(l.render);
            case P:
              return ue(l.type, L, F);
            case W:
              return G(l._render);
            case D: {
              var X = l, oe = X._payload, ae = X._init;
              try {
                return ue(ae(oe), L, F);
              } catch {
              }
            }
          }
        return "";
      }
      var Se = {}, ye = S.ReactDebugCurrentFrame;
      function J(l) {
        if (l) {
          var L = l._owner, F = ue(l.type, l._source, L ? L.type : null);
          ye.setExtraStackFrame(F);
        } else
          ye.setExtraStackFrame(null);
      }
      function Te(l, L, F, X, oe) {
        {
          var ae = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Q in l)
            if (ae(l, Q)) {
              var ee = void 0;
              try {
                if (typeof l[Q] != "function") {
                  var ge = Error((X || "React class") + ": " + F + " type `" + Q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[Q] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ge.name = "Invariant Violation", ge;
                }
                ee = l[Q](L, Q, X, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (be) {
                ee = be;
              }
              ee && !(ee instanceof Error) && (J(oe), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", F, Q, typeof ee), J(null)), ee instanceof Error && !(ee.message in Se) && (Se[ee.message] = !0, J(oe), j("Failed %s type: %s", F, ee.message), J(null));
            }
        }
      }
      var he = S.ReactCurrentOwner, De = Object.prototype.hasOwnProperty, Tt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ve, Ye, $e;
      $e = {};
      function Xe(l) {
        if (De.call(l, "ref")) {
          var L = Object.getOwnPropertyDescriptor(l, "ref").get;
          if (L && L.isReactWarning)
            return !1;
        }
        return l.ref !== void 0;
      }
      function Ke(l) {
        if (De.call(l, "key")) {
          var L = Object.getOwnPropertyDescriptor(l, "key").get;
          if (L && L.isReactWarning)
            return !1;
        }
        return l.key !== void 0;
      }
      function we(l, L) {
        if (typeof l.ref == "string" && he.current && L && he.current.stateNode !== L) {
          var F = Z(he.current.type);
          $e[F] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Z(he.current.type), l.ref), $e[F] = !0);
        }
      }
      function _e(l, L) {
        {
          var F = function() {
            Ve || (Ve = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
          };
          F.isReactWarning = !0, Object.defineProperty(l, "key", {
            get: F,
            configurable: !0
          });
        }
      }
      function Wt(l, L) {
        {
          var F = function() {
            Ye || (Ye = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
          };
          F.isReactWarning = !0, Object.defineProperty(l, "ref", {
            get: F,
            configurable: !0
          });
        }
      }
      var Vt = function(l, L, F, X, oe, ae, Q) {
        var ee = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: l,
          key: L,
          ref: F,
          props: Q,
          // Record the component responsible for creating this element.
          _owner: ae
        };
        return ee._store = {}, Object.defineProperty(ee._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ee, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: X
        }), Object.defineProperty(ee, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: oe
        }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
      };
      function Yt(l, L, F, X, oe) {
        {
          var ae, Q = {}, ee = null, ge = null;
          F !== void 0 && (ee = "" + F), Ke(L) && (ee = "" + L.key), Xe(L) && (ge = L.ref, we(L, oe));
          for (ae in L)
            De.call(L, ae) && !Tt.hasOwnProperty(ae) && (Q[ae] = L[ae]);
          if (l && l.defaultProps) {
            var be = l.defaultProps;
            for (ae in be)
              Q[ae] === void 0 && (Q[ae] = be[ae]);
          }
          if (ee || ge) {
            var xe = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
            ee && _e(Q, xe), ge && Wt(Q, xe);
          }
          return Vt(l, ee, ge, oe, X, he.current, Q);
        }
      }
      var ot = S.ReactCurrentOwner, Pt = S.ReactDebugCurrentFrame;
      function qe(l) {
        if (l) {
          var L = l._owner, F = ue(l.type, l._source, L ? L.type : null);
          Pt.setExtraStackFrame(F);
        } else
          Pt.setExtraStackFrame(null);
      }
      var at;
      at = !1;
      function st(l) {
        return typeof l == "object" && l !== null && l.$$typeof === n;
      }
      function jt() {
        {
          if (ot.current) {
            var l = Z(ot.current.type);
            if (l)
              return `

Check the render method of \`` + l + "`.";
          }
          return "";
        }
      }
      function Er(l) {
        {
          if (l !== void 0) {
            var L = l.fileName.replace(/^.*[\\\/]/, ""), F = l.lineNumber;
            return `

Check your code at ` + L + ":" + F + ".";
          }
          return "";
        }
      }
      var Kt = {};
      function Or(l) {
        {
          var L = jt();
          if (!L) {
            var F = typeof l == "string" ? l : l.displayName || l.name;
            F && (L = `

Check the top-level render call using <` + F + ">.");
          }
          return L;
        }
      }
      function Gt(l, L) {
        {
          if (!l._store || l._store.validated || l.key != null)
            return;
          l._store.validated = !0;
          var F = Or(L);
          if (Kt[F])
            return;
          Kt[F] = !0;
          var X = "";
          l && l._owner && l._owner !== ot.current && (X = " It was passed a child from " + Z(l._owner.type) + "."), qe(l), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, X), qe(null);
        }
      }
      function ct(l, L) {
        {
          if (typeof l != "object")
            return;
          if (Array.isArray(l))
            for (var F = 0; F < l.length; F++) {
              var X = l[F];
              st(X) && Gt(X, L);
            }
          else if (st(l))
            l._store && (l._store.validated = !0);
          else if (l) {
            var oe = T(l);
            if (typeof oe == "function" && oe !== l.entries)
              for (var ae = oe.call(l), Q; !(Q = ae.next()).done; )
                st(Q.value) && Gt(Q.value, L);
          }
        }
      }
      function Xt(l) {
        {
          var L = l.type;
          if (L == null || typeof L == "string")
            return;
          var F;
          if (typeof L == "function")
            F = L.propTypes;
          else if (typeof L == "object" && (L.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          L.$$typeof === P))
            F = L.propTypes;
          else
            return;
          if (F) {
            var X = Z(L);
            Te(F, l.props, "prop", X, l);
          } else if (L.PropTypes !== void 0 && !at) {
            at = !0;
            var oe = Z(L);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", oe || "Unknown");
          }
          typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Jt(l) {
        {
          for (var L = Object.keys(l.props), F = 0; F < L.length; F++) {
            var X = L[F];
            if (X !== "children" && X !== "key") {
              qe(l), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), qe(null);
              break;
            }
          }
          l.ref !== null && (qe(l), j("Invalid attribute `ref` supplied to `React.Fragment`."), qe(null));
        }
      }
      function ut(l, L, F, X, oe, ae) {
        {
          var Q = K(l);
          if (!Q) {
            var ee = "";
            (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (ee += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ge = Er(oe);
            ge ? ee += ge : ee += jt();
            var be;
            l === null ? be = "null" : Array.isArray(l) ? be = "array" : l !== void 0 && l.$$typeof === n ? (be = "<" + (Z(l.type) || "Unknown") + " />", ee = " Did you accidentally export a JSX literal instead of a component?") : be = typeof l, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", be, ee);
          }
          var xe = Yt(l, L, F, oe, ae);
          if (xe == null)
            return xe;
          if (Q) {
            var Me = L.children;
            if (Me !== void 0)
              if (X)
                if (Array.isArray(Me)) {
                  for (var lt = 0; lt < Me.length; lt++)
                    ct(Me[lt], l);
                  Object.freeze && Object.freeze(Me);
                } else
                  j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                ct(Me, l);
          }
          return l === e.Fragment ? Jt(xe) : Xt(xe), xe;
        }
      }
      function kt(l, L, F) {
        return ut(l, L, F, !0);
      }
      function Zt(l, L, F) {
        return ut(l, L, F, !1);
      }
      var Qt = Zt, er = kt;
      e.jsx = Qt, e.jsxs = er;
    }();
  }(Zr)), Zr;
}
var mt = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var So;
function Rf() {
  if (So)
    return mt;
  So = 1, Hn();
  var e = pr, t = 60103;
  if (mt.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), mt.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, u, c) {
    var _, h = {}, P = null, D = null;
    c !== void 0 && (P = "" + c), u.key !== void 0 && (P = "" + u.key), u.ref !== void 0 && (D = u.ref);
    for (_ in u)
      i.call(u, _) && !o.hasOwnProperty(_) && (h[_] = u[_]);
    if (s && s.defaultProps)
      for (_ in u = s.defaultProps, u)
        h[_] === void 0 && (h[_] = u[_]);
    return { $$typeof: t, type: s, key: P, ref: D, props: h, _owner: n.current };
  }
  return mt.jsx = a, mt.jsxs = a, mt;
}
process.env.NODE_ENV === "production" ? wn.exports = Rf() : wn.exports = Sf();
var _n = wn.exports;
const cs = "file-selector", Tf = () => /* @__PURE__ */ _n.jsx(
  "input",
  {
    id: cs,
    className: "display-none",
    style: { display: "none" },
    type: "file",
    accept: "*"
  }
), us = (e) => {
  if (!e)
    return;
  if (e.type === "audio/webm")
    return e;
  const [t] = e.name.split(".").slice(-1);
  if (!t)
    return e;
  const r = Of.getType(t);
  return r ? new File([e], e.name, { type: r }) : e;
}, Zf = (e, t, r = !1) => {
  const n = document.getElementById(cs);
  n.setAttribute("accept", e), r ? n.setAttribute("multiple", "multiple") : n.removeAttribute("multiple"), n.onchange = (i) => {
    const o = i.target;
    t(r ? Array.from(o.files) : o.files[0]), i.target.value = "";
  }, n.click();
}, En = /* @__PURE__ */ new Set(), Pf = 1e4;
async function jf({
  uploadId: e,
  file: t,
  onProgress: r,
  onComplete: n,
  type: i,
  onError: o,
  convert: a,
  queue: s,
  persist: u = !0,
  retry: c = !0,
  retryDelay: _ = 2e3,
  onConversionProgress: h
}) {
  if (!En.has(e))
    try {
      const P = us(t), D = await Fe.upload(P, {
        type: i,
        temp: !!a,
        onUploadSubmit: (U) => _f(e, U),
        onProgress: (U, { sent: H, total: m }) => {
          const y = Math.floor(H / m * 100);
          bf(e, y, H), r == null || r(y);
        },
        queue: s
      });
      if (!D)
        return;
      let { fileId: W } = D;
      a && (W = (await Fe.convert(D.convertToken, a, {
        onProgress: (H) => {
          xf(
            e,
            H.percent
          ), h == null || h({ percent: H.percent });
        }
      })).data.fileIds[0]);
      const { size: I, directLink: R } = await Fe.getInfo(W);
      u && await os(R, P), En.has(e) || n == null || n({ fileId: W, size: I });
    } catch (P) {
      console.error(P), c ? (ts(e), setTimeout(
        () => jf({
          uploadId: e,
          file: t,
          onProgress: r,
          onComplete: n,
          type: i,
          onError: o,
          convert: a,
          queue: s,
          persist: u,
          retry: c,
          retryDelay: Math.min(_ * _, Pf)
        }),
        _
      )) : o == null || o(P);
    }
}
function kf(e) {
  return Ja(e)(Gn());
}
function Cf(e) {
  const t = kf(e);
  ts(e), t != null && t.fileId && Fe.cancelUpload(t.fileId), En.add(e);
}
function Qf(e) {
  gf(e), Fe.setConfig({ ...Fe.getConfig(), authToken: e });
}
function ed(e) {
  const t = Kn(Ja(e)), r = ko(() => {
    Cf(e);
  }, [e]), n = t == null ? void 0 : t.conversionPercent;
  return {
    uploading: !!e,
    percentage: e && (t == null ? void 0 : t.percent) || null,
    sentBytes: (t == null ? void 0 : t.sent) || 0,
    conversionPercentage: n,
    cancelUpload: r
  };
}
var On = { exports: {} }, ls = { exports: {} };
(function(e) {
  e.exports = t;
  function t(n) {
    if (n)
      return r(n);
  }
  function r(n) {
    for (var i in t.prototype)
      n[i] = t.prototype[i];
    return n;
  }
  t.prototype.on = t.prototype.addEventListener = function(n, i) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + n] = this._callbacks["$" + n] || []).push(i), this;
  }, t.prototype.once = function(n, i) {
    function o() {
      this.off(n, o), i.apply(this, arguments);
    }
    return o.fn = i, this.on(n, o), this;
  }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function(n, i) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var o = this._callbacks["$" + n];
    if (!o)
      return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + n], this;
    for (var a, s = 0; s < o.length; s++)
      if (a = o[s], a === i || a.fn === i) {
        o.splice(s, 1);
        break;
      }
    return o.length === 0 && delete this._callbacks["$" + n], this;
  }, t.prototype.emit = function(n) {
    this._callbacks = this._callbacks || {};
    for (var i = new Array(arguments.length - 1), o = this._callbacks["$" + n], a = 1; a < arguments.length; a++)
      i[a - 1] = arguments[a];
    if (o) {
      o = o.slice(0);
      for (var a = 0, s = o.length; a < s; ++a)
        o[a].apply(this, i);
    }
    return this;
  }, t.prototype.listeners = function(n) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + n] || [];
  }, t.prototype.hasListeners = function(n) {
    return !!this.listeners(n).length;
  };
})(ls);
var Uf = ls.exports;
function Af(e) {
  return e !== null && typeof e == "object";
}
var ps = Af, lr = ps, Lf = te;
function te(e) {
  if (e)
    return Df(e);
}
function Df(e) {
  for (var t in te.prototype)
    e[t] = te.prototype[t];
  return e;
}
te.prototype.clearTimeout = function() {
  return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, this;
};
te.prototype.parse = function(t) {
  return this._parser = t, this;
};
te.prototype.responseType = function(e) {
  return this._responseType = e, this;
};
te.prototype.serialize = function(t) {
  return this._serializer = t, this;
};
te.prototype.timeout = function(t) {
  if (!t || typeof t != "object")
    return this._timeout = t, this._responseTimeout = 0, this;
  for (var r in t)
    switch (r) {
      case "deadline":
        this._timeout = t.deadline;
        break;
      case "response":
        this._responseTimeout = t.response;
        break;
      default:
        console.warn("Unknown timeout option", r);
    }
  return this;
};
te.prototype.retry = function(t, r) {
  return (arguments.length === 0 || t === !0) && (t = 1), t <= 0 && (t = 0), this._maxRetries = t, this._retries = 0, this._retryCallback = r, this;
};
var Nf = [
  "ECONNRESET",
  "ETIMEDOUT",
  "EADDRINFO",
  "ESOCKETTIMEDOUT"
];
te.prototype._shouldRetry = function(e, t) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries)
    return !1;
  if (this._retryCallback)
    try {
      var r = this._retryCallback(e, t);
      if (r === !0)
        return !0;
      if (r === !1)
        return !1;
    } catch (n) {
      console.error(n);
    }
  return !!(t && t.status && t.status >= 500 && t.status != 501 || e && (e.code && ~Nf.indexOf(e.code) || e.timeout && e.code == "ECONNABORTED" || e.crossDomain));
};
te.prototype._retry = function() {
  return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this._end();
};
te.prototype.then = function(t, r) {
  if (!this._fullfilledPromise) {
    var n = this;
    this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new Promise(function(i, o) {
      n.end(function(a, s) {
        a ? o(a) : i(s);
      });
    });
  }
  return this._fullfilledPromise.then(t, r);
};
te.prototype.catch = function(e) {
  return this.then(void 0, e);
};
te.prototype.use = function(t) {
  return t(this), this;
};
te.prototype.ok = function(e) {
  if (typeof e != "function")
    throw Error("Callback required");
  return this._okCallback = e, this;
};
te.prototype._isResponseOK = function(e) {
  return e ? this._okCallback ? this._okCallback(e) : e.status >= 200 && e.status < 300 : !1;
};
te.prototype.get = function(e) {
  return this._header[e.toLowerCase()];
};
te.prototype.getHeader = te.prototype.get;
te.prototype.set = function(e, t) {
  if (lr(e)) {
    for (var r in e)
      this.set(r, e[r]);
    return this;
  }
  return this._header[e.toLowerCase()] = t, this.header[e] = t, this;
};
te.prototype.unset = function(e) {
  return delete this._header[e.toLowerCase()], delete this.header[e], this;
};
te.prototype.field = function(e, t) {
  if (e == null)
    throw new Error(".field(name, val) name can not be empty");
  if (this._data && console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()"), lr(e)) {
    for (var r in e)
      this.field(r, e[r]);
    return this;
  }
  if (Array.isArray(t)) {
    for (var n in t)
      this.field(e, t[n]);
    return this;
  }
  if (t == null)
    throw new Error(".field(name, val) val can not be empty");
  return typeof t == "boolean" && (t = "" + t), this._getFormData().append(e, t), this;
};
te.prototype.abort = function() {
  return this._aborted ? this : (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort"), this);
};
te.prototype._auth = function(e, t, r, n) {
  switch (r.type) {
    case "basic":
      this.set("Authorization", "Basic " + n(e + ":" + t));
      break;
    case "auto":
      this.username = e, this.password = t;
      break;
    case "bearer":
      this.set("Authorization", "Bearer " + e);
      break;
  }
  return this;
};
te.prototype.withCredentials = function(e) {
  return e == null && (e = !0), this._withCredentials = e, this;
};
te.prototype.redirects = function(e) {
  return this._maxRedirects = e, this;
};
te.prototype.maxResponseSize = function(e) {
  if (typeof e != "number")
    throw TypeError("Invalid argument");
  return this._maxResponseSize = e, this;
};
te.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};
te.prototype.send = function(e) {
  var t = lr(e), r = this._header["content-type"];
  if (this._formData && console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()"), t && !this._data)
    Array.isArray(e) ? this._data = [] : this._isHost(e) || (this._data = {});
  else if (e && this._data && this._isHost(this._data))
    throw Error("Can't merge these send calls");
  if (t && lr(this._data))
    for (var n in e)
      this._data[n] = e[n];
  else
    typeof e == "string" ? (r || this.type("form"), r = this._header["content-type"], r == "application/x-www-form-urlencoded" ? this._data = this._data ? this._data + "&" + e : e : this._data = (this._data || "") + e) : this._data = e;
  return !t || this._isHost(e) ? this : (r || this.type("json"), this);
};
te.prototype.sortQuery = function(e) {
  return this._sort = typeof e > "u" ? !0 : e, this;
};
te.prototype._finalizeQueryString = function() {
  var e = this._query.join("&");
  if (e && (this.url += (this.url.indexOf("?") >= 0 ? "&" : "?") + e), this._query.length = 0, this._sort) {
    var t = this.url.indexOf("?");
    if (t >= 0) {
      var r = this.url.substring(t + 1).split("&");
      typeof this._sort == "function" ? r.sort(this._sort) : r.sort(), this.url = this.url.substring(0, t) + "?" + r.join("&");
    }
  }
};
te.prototype._appendQueryString = function() {
  console.trace("Unsupported");
};
te.prototype._timeoutError = function(e, t, r) {
  if (!this._aborted) {
    var n = new Error(e + t + "ms exceeded");
    n.timeout = t, n.code = "ECONNABORTED", n.errno = r, this.timedout = !0, this.abort(), this.callback(n);
  }
};
te.prototype._setTimeouts = function() {
  var e = this;
  this._timeout && !this._timer && (this._timer = setTimeout(function() {
    e._timeoutError("Timeout of ", e._timeout, "ETIME");
  }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function() {
    e._timeoutError("Response timeout of ", e._responseTimeout, "ETIMEDOUT");
  }, this._responseTimeout));
};
var Ht = {};
Ht.type = function(e) {
  return e.split(/ *; */).shift();
};
Ht.params = function(e) {
  return e.split(/ *; */).reduce(function(t, r) {
    var n = r.split(/ *= */), i = n.shift(), o = n.shift();
    return i && o && (t[i] = o), t;
  }, {});
};
Ht.parseLinks = function(e) {
  return e.split(/ *, */).reduce(function(t, r) {
    var n = r.split(/ *; */), i = n[0].slice(1, -1), o = n[1].split(/ *= */)[1].slice(1, -1);
    return t[o] = i, t;
  }, {});
};
Ht.cleanHeader = function(e, t) {
  return delete e["content-type"], delete e["content-length"], delete e["transfer-encoding"], delete e.host, t && (delete e.authorization, delete e.cookie), e;
};
var Qr = Ht, If = Ot;
function Ot(e) {
  if (e)
    return $f(e);
}
function $f(e) {
  for (var t in Ot.prototype)
    e[t] = Ot.prototype[t];
  return e;
}
Ot.prototype.get = function(e) {
  return this.header[e.toLowerCase()];
};
Ot.prototype._setHeaderProperties = function(e) {
  var t = e["content-type"] || "";
  this.type = Qr.type(t);
  var r = Qr.params(t);
  for (var n in r)
    this[n] = r[n];
  this.links = {};
  try {
    e.link && (this.links = Qr.parseLinks(e.link));
  } catch {
  }
};
Ot.prototype._setStatusProperties = function(e) {
  var t = e / 100 | 0;
  this.status = this.statusCode = e, this.statusType = t, this.info = t == 1, this.ok = t == 2, this.redirect = t == 3, this.clientError = t == 4, this.serverError = t == 5, this.error = t == 4 || t == 5 ? this.toError() : !1, this.created = e == 201, this.accepted = e == 202, this.noContent = e == 204, this.badRequest = e == 400, this.unauthorized = e == 401, this.notAcceptable = e == 406, this.forbidden = e == 403, this.notFound = e == 404, this.unprocessableEntity = e == 422;
};
function Xn() {
  this._defaults = [];
}
[
  "use",
  "on",
  "once",
  "set",
  "query",
  "type",
  "accept",
  "auth",
  "withCredentials",
  "sortQuery",
  "retry",
  "ok",
  "redirects",
  "timeout",
  "buffer",
  "serialize",
  "parse",
  "ca",
  "key",
  "pfx",
  "cert"
].forEach(function(e) {
  Xn.prototype[e] = function() {
    return this._defaults.push({ fn: e, arguments }), this;
  };
});
Xn.prototype._setDefaults = function(e) {
  this._defaults.forEach(function(t) {
    e[t.fn].apply(e, t.arguments);
  });
};
var qf = Xn;
(function(e, t) {
  var r;
  typeof window < "u" ? r = window : typeof self < "u" ? r = self : (console.warn("Using browser-only version of superagent in non-browser environment"), r = ie);
  var n = Uf, i = Lf, o = ps, a = If, s = qf;
  function u() {
  }
  var c = t = e.exports = function(m, y) {
    return typeof y == "function" ? new t.Request("GET", m).end(y) : arguments.length == 1 ? new t.Request("GET", m) : new t.Request(m, y);
  };
  t.Request = U, c.getXHR = function() {
    if (r.XMLHttpRequest && (!r.location || r.location.protocol != "file:" || !r.ActiveXObject))
      return new XMLHttpRequest();
    try {
      return new ActiveXObject("Microsoft.XMLHTTP");
    } catch {
    }
    try {
      return new ActiveXObject("Msxml2.XMLHTTP.6.0");
    } catch {
    }
    try {
      return new ActiveXObject("Msxml2.XMLHTTP.3.0");
    } catch {
    }
    try {
      return new ActiveXObject("Msxml2.XMLHTTP");
    } catch {
    }
    throw Error("Browser-only version of superagent could not find XHR");
  };
  var _ = "".trim ? function(m) {
    return m.trim();
  } : function(m) {
    return m.replace(/(^\s*|\s*$)/g, "");
  };
  function h(m) {
    if (!o(m))
      return m;
    var y = [];
    for (var f in m)
      P(y, f, m[f]);
    return y.join("&");
  }
  function P(m, y, f) {
    if (f != null)
      if (Array.isArray(f))
        f.forEach(function(S) {
          P(m, y, S);
        });
      else if (o(f))
        for (var T in f)
          P(m, y + "[" + T + "]", f[T]);
      else
        m.push(encodeURIComponent(y) + "=" + encodeURIComponent(f));
    else
      f === null && m.push(encodeURIComponent(y));
  }
  c.serializeObject = h;
  function D(m) {
    for (var y = {}, f = m.split("&"), T, S, j = 0, z = f.length; j < z; ++j)
      T = f[j], S = T.indexOf("="), S == -1 ? y[decodeURIComponent(T)] = "" : y[decodeURIComponent(T.slice(0, S))] = decodeURIComponent(T.slice(S + 1));
    return y;
  }
  c.parseString = D, c.types = {
    html: "text/html",
    json: "application/json",
    xml: "text/xml",
    urlencoded: "application/x-www-form-urlencoded",
    form: "application/x-www-form-urlencoded",
    "form-data": "application/x-www-form-urlencoded"
  }, c.serialize = {
    "application/x-www-form-urlencoded": h,
    "application/json": JSON.stringify
  }, c.parse = {
    "application/x-www-form-urlencoded": D,
    "application/json": JSON.parse
  };
  function W(m) {
    for (var y = m.split(/\r?\n/), f = {}, T, S, j, z, Y = 0, K = y.length; Y < K; ++Y)
      S = y[Y], T = S.indexOf(":"), T !== -1 && (j = S.slice(0, T).toLowerCase(), z = _(S.slice(T + 1)), f[j] = z);
    return f;
  }
  function I(m) {
    return /[\/+]json($|[^-\w])/.test(m);
  }
  function R(m) {
    this.req = m, this.xhr = this.req.xhr, this.text = this.req.method != "HEAD" && (this.xhr.responseType === "" || this.xhr.responseType === "text") || typeof this.xhr.responseType > "u" ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
    var y = this.xhr.status;
    y === 1223 && (y = 204), this._setStatusProperties(y), this.header = this.headers = W(this.xhr.getAllResponseHeaders()), this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), this.text === null && m._responseType ? this.body = this.xhr.response : this.body = this.req.method != "HEAD" ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
  }
  a(R.prototype), R.prototype._parseBody = function(m) {
    var y = c.parse[this.type];
    return this.req._parser ? this.req._parser(this, m) : (!y && I(this.type) && (y = c.parse["application/json"]), y && m && (m.length || m instanceof Object) ? y(m) : null);
  }, R.prototype.toError = function() {
    var m = this.req, y = m.method, f = m.url, T = "cannot " + y + " " + f + " (" + this.status + ")", S = new Error(T);
    return S.status = this.status, S.method = y, S.url = f, S;
  }, c.Response = R;
  function U(m, y) {
    var f = this;
    this._query = this._query || [], this.method = m, this.url = y, this.header = {}, this._header = {}, this.on("end", function() {
      var T = null, S = null;
      try {
        S = new R(f);
      } catch (z) {
        return T = new Error("Parser is unable to parse the response"), T.parse = !0, T.original = z, f.xhr ? (T.rawResponse = typeof f.xhr.responseType > "u" ? f.xhr.responseText : f.xhr.response, T.status = f.xhr.status ? f.xhr.status : null, T.statusCode = T.status) : (T.rawResponse = null, T.status = null), f.callback(T);
      }
      f.emit("response", S);
      var j;
      try {
        f._isResponseOK(S) || (j = new Error(S.statusText || "Unsuccessful HTTP response"));
      } catch (z) {
        j = z;
      }
      j ? (j.original = T, j.response = S, j.status = S.status, f.callback(j, S)) : f.callback(null, S);
    });
  }
  n(U.prototype), i(U.prototype), U.prototype.type = function(m) {
    return this.set("Content-Type", c.types[m] || m), this;
  }, U.prototype.accept = function(m) {
    return this.set("Accept", c.types[m] || m), this;
  }, U.prototype.auth = function(m, y, f) {
    arguments.length === 1 && (y = ""), typeof y == "object" && y !== null && (f = y, y = ""), f || (f = {
      type: typeof btoa == "function" ? "basic" : "auto"
    });
    var T = function(S) {
      if (typeof btoa == "function")
        return btoa(S);
      throw new Error("Cannot use basic auth, btoa is not a function");
    };
    return this._auth(m, y, f, T);
  }, U.prototype.query = function(m) {
    return typeof m != "string" && (m = h(m)), m && this._query.push(m), this;
  }, U.prototype.attach = function(m, y, f) {
    if (y) {
      if (this._data)
        throw Error("superagent can't mix .send() and .attach()");
      this._getFormData().append(m, y, f || y.name);
    }
    return this;
  }, U.prototype._getFormData = function() {
    return this._formData || (this._formData = new r.FormData()), this._formData;
  }, U.prototype.callback = function(m, y) {
    if (this._shouldRetry(m, y))
      return this._retry();
    var f = this._callback;
    this.clearTimeout(), m && (this._maxRetries && (m.retries = this._retries - 1), this.emit("error", m)), f(m, y);
  }, U.prototype.crossDomainError = function() {
    var m = new Error(`Request has been terminated
Possible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.`);
    m.crossDomain = !0, m.status = this.status, m.method = this.method, m.url = this.url, this.callback(m);
  }, U.prototype.buffer = U.prototype.ca = U.prototype.agent = function() {
    return console.warn("This is not supported in browser version of superagent"), this;
  }, U.prototype.pipe = U.prototype.write = function() {
    throw Error("Streaming is not supported in browser version of superagent");
  }, U.prototype._isHost = function(y) {
    return y && typeof y == "object" && !Array.isArray(y) && Object.prototype.toString.call(y) !== "[object Object]";
  }, U.prototype.end = function(m) {
    return this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = m || u, this._finalizeQueryString(), this._end();
  }, U.prototype._end = function() {
    var m = this, y = this.xhr = c.getXHR(), f = this._formData || this._data;
    this._setTimeouts(), y.onreadystatechange = function() {
      var Y = y.readyState;
      if (Y >= 2 && m._responseTimeoutTimer && clearTimeout(m._responseTimeoutTimer), Y == 4) {
        var K;
        try {
          K = y.status;
        } catch {
          K = 0;
        }
        if (!K)
          return m.timedout || m._aborted ? void 0 : m.crossDomainError();
        m.emit("end");
      }
    };
    var T = function(Y, K) {
      K.total > 0 && (K.percent = K.loaded / K.total * 100), K.direction = Y, m.emit("progress", K);
    };
    if (this.hasListeners("progress"))
      try {
        y.onprogress = T.bind(null, "download"), y.upload && (y.upload.onprogress = T.bind(null, "upload"));
      } catch {
      }
    try {
      this.username && this.password ? y.open(this.method, this.url, !0, this.username, this.password) : y.open(this.method, this.url, !0);
    } catch (Y) {
      return this.callback(Y);
    }
    if (this._withCredentials && (y.withCredentials = !0), !this._formData && this.method != "GET" && this.method != "HEAD" && typeof f != "string" && !this._isHost(f)) {
      var S = this._header["content-type"], j = this._serializer || c.serialize[S ? S.split(";")[0] : ""];
      !j && I(S) && (j = c.serialize["application/json"]), j && (f = j(f));
    }
    for (var z in this.header)
      this.header[z] != null && this.header.hasOwnProperty(z) && y.setRequestHeader(z, this.header[z]);
    return this._responseType && (y.responseType = this._responseType), this.emit("request", this), y.send(typeof f < "u" ? f : null), this;
  }, c.agent = function() {
    return new s();
  }, ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(m) {
    s.prototype[m.toLowerCase()] = function(y, f) {
      var T = new c.Request(m, y);
      return this._setDefaults(T), f && T.end(f), T;
    };
  }), s.prototype.del = s.prototype.delete, c.get = function(m, y, f) {
    var T = c("GET", m);
    return typeof y == "function" && (f = y, y = null), y && T.query(y), f && T.end(f), T;
  }, c.head = function(m, y, f) {
    var T = c("HEAD", m);
    return typeof y == "function" && (f = y, y = null), y && T.query(y), f && T.end(f), T;
  }, c.options = function(m, y, f) {
    var T = c("OPTIONS", m);
    return typeof y == "function" && (f = y, y = null), y && T.send(y), f && T.end(f), T;
  };
  function H(m, y, f) {
    var T = c("DELETE", m);
    return typeof y == "function" && (f = y, y = null), y && T.send(y), f && T.end(f), T;
  }
  c.del = H, c.delete = H, c.patch = function(m, y, f) {
    var T = c("PATCH", m);
    return typeof y == "function" && (f = y, y = null), y && T.send(y), f && T.end(f), T;
  }, c.post = function(m, y, f) {
    var T = c("POST", m);
    return typeof y == "function" && (f = y, y = null), y && T.send(y), f && T.end(f), T;
  }, c.put = function(m, y, f) {
    var T = c("PUT", m);
    return typeof y == "function" && (f = y, y = null), y && T.send(y), f && T.end(f), T;
  };
})(On, On.exports);
var Mf = On.exports;
const Bf = /* @__PURE__ */ fr(Mf), zf = (...e) => We(He(Ya)(...e)), en = (...e) => We(He(Ka)(...e)), Ff = (...e) => We(
  He(Ga, (t, r) => ({
    fileId: t,
    percent: r
  }))(...e)
), fs = (e) => {
  const t = document.createElement("a");
  return document.body.appendChild(t), t.style = "display: none", e ? (r, n) => {
    const i = window.URL.createObjectURL(r);
    t.href = i, t.download = n, t.click(), window.URL.revokeObjectURL(i);
  } : (r, n) => {
    t.href = r, t.target = "_blank", t.download = n, t.click();
  };
}, ds = fs(!0), Hf = fs(), td = (e, t, r) => r ? Hf(e, t) : is(e).then((n) => n ? (ds(n, t), !0) : !1);
function Wf(e, t) {
  const r = Bf.get(e);
  return r.on("request", function() {
    this.xhr.responseType = "blob";
  }), t && r.on("progress", t), r;
}
const Vf = (e, t) => ({ percent: r, direction: n }) => {
  n === "download" && (Ff(e, Math.floor(r)), t && t(Math.floor(r)));
}, rd = ({
  url: e,
  fileId: t,
  fileName: r,
  onProgress: n,
  onComplete: i,
  onError: o
}) => {
  const a = new window.URL(e);
  a.searchParams.append("x-mode", "cors");
  const s = Wf(a.href, Vf(t, n));
  zf({
    fileId: t,
    percent: 0,
    abort: s.abort.bind(s)
  }), s.on("abort", () => en({ fileId: t })), s.then((u) => {
    const c = u.xhr.response, _ = us(
      new File([c], r, { type: c.type })
    );
    en({ fileId: t }), i && i(_), r && ds(_, r), os(e, _);
  }).catch((u) => {
    en({ fileId: t }), o && o(u);
  });
};
function nd(e) {
  const t = Kn(Xa(e)), { percent: r, abort: n } = t || {}, i = ko(() => {
    n == null || n();
  }, [e, n]);
  return {
    downloading: !!t,
    percentage: t ? r : null,
    cancelDownload: i
  };
}
const Yf = (...e) => We(
  He(Za, (t, r) => ({
    fileId: t,
    blobURL: r
  }))(...e)
), Kf = (e, t) => {
  const r = window.URL.createObjectURL(t);
  Yf(e, r);
};
function id({
  fileId: e,
  fileUrl: t,
  blobCreator: r
}) {
  const n = Kn(() => df(e));
  return Po(() => {
    const i = Xa(e)(Gn());
    e && !i && !n && is(t).then((o) => {
      o && Kf(e, r(o));
    });
  }, [e, n]), n;
}
function od({
  children: e
}) {
  return /* @__PURE__ */ _n.jsxs(za, { store: Qa, context: es, children: [
    /* @__PURE__ */ _n.jsx(Tf, {}),
    e
  ] });
}
const ad = (e) => e ? Fe.getDirectLink(e) : null;
export {
  od as FileProvider,
  Cf as cancelUpload,
  Kf as createBlobURL,
  rd as downloadFile,
  df as getFileBlobUrlByFileId,
  is as getFileByUrl,
  Zf as getFileFromUser,
  ad as getFileUrl,
  kf as getUploadInfo,
  us as inferFileTypeIfNotAvailable,
  os as insertFile,
  td as openFile,
  ds as saveBlobToDisk,
  Jf as setCachedFileHandlers,
  Qf as setUploadToken,
  jf as uploadFile,
  id as useBlobURL,
  nd as useDownloadStatus,
  ed as useUploadStatus
};
//# sourceMappingURL=weblite-file.js.map
